import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
};

export type ActivitiesResponse = {
  __typename?: 'ActivitiesResponse';
  collection: Array<Activity>;
  meta: ActivityMeta;
};

export type Activity = {
  __typename?: 'Activity';
  data: Scalars['String']['output'];
  date: Scalars['String']['output'];
  from: User;
  id: Scalars['ID']['output'];
  targetUserId: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type ActivityMeta = {
  __typename?: 'ActivityMeta';
  range: ActivityRange;
};

export type ActivityRange = {
  __typename?: 'ActivityRange';
  from: Scalars['Int']['output'];
  to: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum AgeCategory {
  Juniors = 'juniors',
  Kids = 'kids',
  Men = 'men',
  Women = 'women'
}

export type AnimationLayer = {
  __typename?: 'AnimationLayer';
  dataViews: Array<TalentDataView>;
  label: Scalars['String']['output'];
  total?: Maybe<Scalars['Int']['output']>;
};

export type ApplyNetworkWithTalentInput = {
  networkId: Scalars['Int']['input'];
  talentId: Scalars['Int']['input'];
};

export type Authentication = {
  __typename?: 'Authentication';
  apiToken: Scalars['String']['output'];
  token: Scalars['String']['output'];
  user: User;
};

export type AuthenticationCodeInput = {
  code: Scalars['String']['input'];
};

export type AuthenticationFormInput = {
  name: Scalars['String']['input'];
  password: Scalars['String']['input'];
  permanent: Scalars['Boolean']['input'];
};

export type AuthenticationTokenInput = {
  token: Scalars['String']['input'];
};

export type Camp = {
  __typename?: 'Camp';
  campType?: Maybe<Scalars['String']['output']>;
  caption?: Maybe<Scalars['String']['output']>;
  end?: Maybe<Scalars['String']['output']>;
  start?: Maybe<Scalars['String']['output']>;
};

export type Certificate = {
  __typename?: 'Certificate';
  birthday: Scalars['String']['output'];
  camp: Camp;
  caption?: Maybe<Scalars['String']['output']>;
  club: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  lastName: Scalars['String']['output'];
  player?: Maybe<Scalars['String']['output']>;
  renderPayload?: Maybe<Scalars['String']['output']>;
  shareKey?: Maybe<Scalars['String']['output']>;
  talentClass?: Maybe<Scalars['Int']['output']>;
  talentId: Scalars['String']['output'];
  vote: Array<Scalars['Int']['output']>;
};

export enum ChartType {
  AdStage = 'adStage',
  Pie = 'pie',
  Radar = 'radar'
}

export type ContactBlockedUser = {
  __typename?: 'ContactBlockedUser';
  createdAt: Scalars['String']['output'];
  user?: Maybe<User>;
  userId: Scalars['ID']['output'];
};

export enum ContactChannel {
  InApp = 'IN_APP'
}

export type ContactConversation = {
  __typename?: 'ContactConversation';
  channel: ContactChannel;
  counterpart?: Maybe<User>;
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastMessage?: Maybe<ContactMessage>;
  messages: Array<ContactMessage>;
  participantUserIds: Array<Scalars['ID']['output']>;
  request?: Maybe<ContactRequest>;
  status: ContactRequestStatus;
  targetId: Scalars['ID']['output'];
  targetType: ContactTargetType;
  unreadCount: Scalars['Int']['output'];
  updatedAt: Scalars['String']['output'];
};

export enum ContactEntryPointType {
  Profile = 'profile',
  TalentCard = 'talent_card'
}

export type ContactMessage = {
  __typename?: 'ContactMessage';
  body: Scalars['String']['output'];
  conversationId: Scalars['ID']['output'];
  createdAt: Scalars['String']['output'];
  fromExternal: Scalars['Boolean']['output'];
  fromUserId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  readAt?: Maybe<Scalars['String']['output']>;
  status: ContactMessageStatus;
};

export enum ContactMessageStatus {
  Read = 'read',
  Sent = 'sent'
}

export enum ContactReportReason {
  FakeProfile = 'fake_profile',
  Harassment = 'harassment',
  Inappropriate = 'inappropriate',
  Other = 'other',
  Spam = 'spam'
}

export type ContactRequest = {
  __typename?: 'ContactRequest';
  channel: ContactChannel;
  conversationId: Scalars['ID']['output'];
  createdAt: Scalars['String']['output'];
  fromUser?: Maybe<User>;
  fromUserId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  status: ContactRequestStatus;
  target?: Maybe<ContactTarget>;
  targetId: Scalars['ID']['output'];
  targetType: ContactTargetType;
  targetUserId: Scalars['ID']['output'];
  updatedAt: Scalars['String']['output'];
};

export enum ContactRequestDirection {
  Incoming = 'incoming',
  Outgoing = 'outgoing'
}

export enum ContactRequestStatus {
  Accepted = 'accepted',
  Blocked = 'blocked',
  Closed = 'closed',
  Declined = 'declined',
  Pending = 'pending',
  Withdrawn = 'withdrawn'
}

export type ContactTarget = {
  __typename?: 'ContactTarget';
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  type: ContactTargetType;
};

export enum ContactTargetType {
  Talent = 'talent',
  User = 'user'
}

export type CreateContactReportInput = {
  block?: InputMaybe<Scalars['Boolean']['input']>;
  conversationId: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  reason: ContactReportReason;
};

export type CreateContactRequestInput = {
  entryPointType?: InputMaybe<ContactEntryPointType>;
  message: Scalars['String']['input'];
  targetId: Scalars['ID']['input'];
  targetType: ContactTargetType;
};

export type CurrentUser = {
  __typename?: 'CurrentUser';
  _created: Scalars['Int']['output'];
  data?: Maybe<UserMetaData>;
};

export type DeleteAccountInput = {
  password: Scalars['String']['input'];
};

export type DeleteAccountResponse = {
  __typename?: 'DeleteAccountResponse';
  message: Scalars['String']['output'];
};

export type DoimailInput = {
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  subject: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type EditTransferTalentRequestInput = {
  status?: InputMaybe<TalentTransferRequestStatus>;
};

export enum Experience {
  Amateur = 'amateur',
  Professional = 'professional',
  SemiProfessional = 'semiProfessional'
}

export type FileUploadResponse = {
  __typename?: 'FileUploadResponse';
  _created: Scalars['Int']['output'];
  _links: Links;
  _updated: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  token: Scalars['String']['output'];
  url: Scalars['String']['output'];
  user: Scalars['String']['output'];
};

export type FollowUser = {
  follow_user: UrlInput;
};

export type FollowUserInput = {
  _links: FollowUser;
};

export type HistoryItem = {
  __typename?: 'HistoryItem';
  data: Scalars['String']['output'];
  date: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  type: Scalars['String']['output'];
};

export type HistoryItemInput = {
  data: Scalars['String']['input'];
  date: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  talentId: Scalars['ID']['input'];
  type: Scalars['String']['input'];
};

export type ImageInput = {
  image: UrlInput;
};

export type InNetworkState = {
  __typename?: 'InNetworkState';
  state: NetworkState;
};

export type InviteNetworkWithTalentInput = {
  activityId: Scalars['String']['input'];
  link: Scalars['String']['input'];
  networkId: Scalars['Int']['input'];
  targetUserId: Scalars['Int']['input'];
};

export type JmtNetworkResponse = {
  __typename?: 'JMTNetworkResponse';
  JMTnetworks: NetworksResponse;
};

export type LatestObject = {
  __typename?: 'LatestObject';
  image?: Maybe<Scalars['String']['output']>;
};

export type Layer = {
  __typename?: 'Layer';
  dataViews: Array<TalentDataView>;
  name: Scalars['String']['output'];
};

export type Link = {
  __typename?: 'Link';
  rel: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type LinkImageInput = {
  _links: ImageInput;
};

export type LinkUserInput = {
  _links: UserLinkInput;
};

export type Links = {
  __typename?: 'Links';
  self: Link;
  user: Link;
};

export type MapEntry = {
  __typename?: 'MapEntry';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type Message = {
  __typename?: 'Message';
  message?: Maybe<Scalars['String']['output']>;
};

export type MessageResponse = {
  __typename?: 'MessageResponse';
  message: Scalars['String']['output'];
};

export type Meta = {
  __typename?: 'Meta';
  range?: Maybe<Range>;
  sortOptions?: Maybe<Array<MapEntry>>;
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptContactRequest: ContactRequest;
  acceptOrDeclineNetworkInvitation: NetworkInvitation;
  addNetwork: Network;
  addPlaylist: Playlist;
  addRoleModel: MessageResponse;
  addTalentsToNetwork: Network;
  addTalentsToPlaylist: Playlist;
  addUsersToNetwork: Network;
  applyNetworkWithTalent: MessageResponse;
  blockContactUser: Scalars['Boolean']['output'];
  createContactRequest: ContactRequest;
  createHistoryItem: HistoryItem;
  createNetworkTokenInvitation: NetworkTokenInvitation;
  createShanghaiTalent: Array<Scalars['String']['output']>;
  declineContactRequest: ContactRequest;
  deleteAccount: DeleteAccountResponse;
  deleteContactConversation: Scalars['Boolean']['output'];
  deleteHistoryItem?: Maybe<Scalars['Boolean']['output']>;
  deleteNetwork?: Maybe<Scalars['Boolean']['output']>;
  deletePlaylist?: Maybe<Scalars['Boolean']['output']>;
  deleteTalent?: Maybe<Scalars['Boolean']['output']>;
  doimail: Message;
  editHistoryItem: HistoryItem;
  editNetwork: Network;
  editPlaylist: Playlist;
  editTransferTalentRequest: TalentTransferRequest;
  inviteNetworkWithTalent: MessageResponse;
  inviteOrApplyToNetwork: NetworkInvitation;
  joinNetworkByToken: Network;
  markContactConversationRead: ContactConversation;
  networkLinkImage: Network;
  networkUnlinkImage: Network;
  recoverUsername: UserRecoverCollection;
  register: Authentication;
  /**
   * Registriert die OneSignal-Subscription-ID des Geräts am Novu-Subscriber,
   * damit Novu Push (über den OneSignal-Provider) zustellen kann.
   */
  registerPushDevice: Scalars['Boolean']['output'];
  removeTalentFromNetwork: Network;
  removeTalentsFromPlaylist: Playlist;
  removeUserFromNetwork: Network;
  reportContactUser: Scalars['Boolean']['output'];
  requestPasswordChange: RequestPasswordChangeResponse;
  savePerformanceVote: PerformanceVote;
  saveTalent: Talent;
  saveTalentCustomMeta: TalentCustomMeta;
  saveUserMetaData: UserMetaDataSaveResponse;
  sendContactMessage: ContactMessage;
  shareTalent: ShareTalentResponse;
  shortVote: Vote;
  signin?: Maybe<Authentication>;
  signinWithHSVIDCode: Array<Authentication>;
  signinWithToken: Authentication;
  talentJoinMarketplace: Network;
  talentLinkImage: Talent;
  talentLinkUser: Talent;
  talentUnlinkImage: Talent;
  toggleMod?: Maybe<Network>;
  transferOwner?: Maybe<Network>;
  transferTalentRequest: TalentTransferRequest;
  unblockContactUser: Scalars['Boolean']['output'];
  updatePassword: User;
  updateUser: User;
  updateVote: Vote;
  uploadImage: FileUploadResponse;
  userFollow: User;
  userJoinMarketplace: Network;
  userLinkImage: User;
  userUnlinkImage: User;
  vote: Vote;
  withdrawContactRequest: ContactRequest;
};


export type MutationAcceptContactRequestArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAcceptOrDeclineNetworkInvitationArgs = {
  id: Scalars['ID']['input'];
  input?: InputMaybe<NetworkApplyAnswerInput>;
};


export type MutationAddNetworkArgs = {
  input: NetworkInput;
};


export type MutationAddPlaylistArgs = {
  input: PlaylistInput;
};


export type MutationAddRoleModelArgs = {
  input?: InputMaybe<RoleModelInput>;
};


export type MutationAddTalentsToNetworkArgs = {
  id: Scalars['ID']['input'];
  input: NetworkTalentsInput;
};


export type MutationAddTalentsToPlaylistArgs = {
  id: Scalars['String']['input'];
  input: PlaylistTalentsInput;
};


export type MutationAddUsersToNetworkArgs = {
  id: Scalars['ID']['input'];
  input: NetworkUsersInput;
};


export type MutationApplyNetworkWithTalentArgs = {
  input?: InputMaybe<ApplyNetworkWithTalentInput>;
};


export type MutationBlockContactUserArgs = {
  conversationId: Scalars['ID']['input'];
};


export type MutationCreateContactRequestArgs = {
  input: CreateContactRequestInput;
};


export type MutationCreateHistoryItemArgs = {
  input: HistoryItemInput;
};


export type MutationCreateNetworkTokenInvitationArgs = {
  input: NetworkTokenInvitationInput;
  networkId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationCreateShanghaiTalentArgs = {
  talentId: Scalars['ID']['input'];
};


export type MutationDeclineContactRequestArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteAccountArgs = {
  input: DeleteAccountInput;
};


export type MutationDeleteContactConversationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteHistoryItemArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteNetworkArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePlaylistArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteTalentArgs = {
  talentId: Scalars['ID']['input'];
};


export type MutationDoimailArgs = {
  input: DoimailInput;
};


export type MutationEditHistoryItemArgs = {
  input: HistoryItemInput;
};


export type MutationEditNetworkArgs = {
  id: Scalars['ID']['input'];
  input: NetworkInput;
};


export type MutationEditPlaylistArgs = {
  id: Scalars['String']['input'];
  input: PlaylistInput;
};


export type MutationEditTransferTalentRequestArgs = {
  input: EditTransferTalentRequestInput;
  transferId: Scalars['ID']['input'];
};


export type MutationInviteNetworkWithTalentArgs = {
  input?: InputMaybe<InviteNetworkWithTalentInput>;
};


export type MutationInviteOrApplyToNetworkArgs = {
  input: NetworkInvitationInput;
};


export type MutationJoinNetworkByTokenArgs = {
  input: NetworkTokenInput;
};


export type MutationMarkContactConversationReadArgs = {
  id: Scalars['ID']['input'];
};


export type MutationNetworkLinkImageArgs = {
  input: LinkImageInput;
  networkId: Scalars['String']['input'];
};


export type MutationNetworkUnlinkImageArgs = {
  input: LinkImageInput;
  networkId: Scalars['String']['input'];
};


export type MutationRecoverUsernameArgs = {
  input: RecoverUsernameInput;
};


export type MutationRegisterArgs = {
  input: RegistrationInput;
};


export type MutationRegisterPushDeviceArgs = {
  deviceId: Scalars['String']['input'];
};


export type MutationRemoveTalentFromNetworkArgs = {
  id: Scalars['ID']['input'];
  input: NetworkTalentsInput;
};


export type MutationRemoveTalentsFromPlaylistArgs = {
  id: Scalars['String']['input'];
  input: PlaylistTalentsInput;
};


export type MutationRemoveUserFromNetworkArgs = {
  id: Scalars['ID']['input'];
  input: NetworkUsersInput;
};


export type MutationReportContactUserArgs = {
  input: CreateContactReportInput;
};


export type MutationRequestPasswordChangeArgs = {
  input: RequestPasswordChangeInput;
};


export type MutationSavePerformanceVoteArgs = {
  input: PerformanceVoteInput;
};


export type MutationSaveTalentArgs = {
  classId?: InputMaybe<Scalars['String']['input']>;
  input: TalentInput;
  talentId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSaveTalentCustomMetaArgs = {
  input: TalentCustomMetaInput;
  metaDataId?: InputMaybe<Scalars['String']['input']>;
  talentId: Scalars['String']['input'];
};


export type MutationSaveUserMetaDataArgs = {
  input: UserMetaDataInput;
};


export type MutationSendContactMessageArgs = {
  input: SendContactMessageInput;
};


export type MutationShareTalentArgs = {
  input: ShareTalentInput;
};


export type MutationShortVoteArgs = {
  input: VoteInput;
  talentId: Scalars['ID']['input'];
};


export type MutationSigninArgs = {
  input: AuthenticationFormInput;
};


export type MutationSigninWithHsvidCodeArgs = {
  input: AuthenticationCodeInput;
};


export type MutationSigninWithTokenArgs = {
  input: AuthenticationTokenInput;
};


export type MutationTalentJoinMarketplaceArgs = {
  input: Scalars['ID']['input'];
};


export type MutationTalentLinkImageArgs = {
  input: LinkImageInput;
  talentId: Scalars['String']['input'];
};


export type MutationTalentLinkUserArgs = {
  input: LinkUserInput;
  talentId: Scalars['String']['input'];
};


export type MutationTalentUnlinkImageArgs = {
  input: LinkImageInput;
  talentId: Scalars['String']['input'];
};


export type MutationToggleModArgs = {
  id: Scalars['String']['input'];
  idUserTarget: Scalars['String']['input'];
  input: Scalars['String']['input'];
  networkId: Scalars['String']['input'];
};


export type MutationTransferOwnerArgs = {
  id: Scalars['String']['input'];
  idUserTarget: Scalars['String']['input'];
  input: Scalars['String']['input'];
  networkId: Scalars['String']['input'];
};


export type MutationTransferTalentRequestArgs = {
  input: TransferTalentRequestInput;
};


export type MutationUnblockContactUserArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationUpdatePasswordArgs = {
  input: PasswordInput;
  userId: Scalars['String']['input'];
};


export type MutationUpdateUserArgs = {
  input: UserInput;
  userId: Scalars['String']['input'];
};


export type MutationUpdateVoteArgs = {
  id: Scalars['ID']['input'];
  input: VoteInput;
};


export type MutationUploadImageArgs = {
  input: Scalars['String']['input'];
};


export type MutationUserFollowArgs = {
  input: FollowUserInput;
  method: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationUserJoinMarketplaceArgs = {
  input: Scalars['ID']['input'];
};


export type MutationUserLinkImageArgs = {
  input: LinkImageInput;
  userId: Scalars['String']['input'];
};


export type MutationUserUnlinkImageArgs = {
  input: LinkImageInput;
  userId: Scalars['String']['input'];
};


export type MutationVoteArgs = {
  input: VoteInput;
  talentId: Scalars['ID']['input'];
};


export type MutationWithdrawContactRequestArgs = {
  id: Scalars['ID']['input'];
};

export type MyPlaceTalent = {
  __typename?: 'MyPlaceTalent';
  network: Network;
  talent: Talent;
};

export type MySpaceTalentsResponse = {
  __typename?: 'MySpaceTalentsResponse';
  collection: Array<MyPlaceTalent>;
  meta: Meta;
};

export type Network = {
  __typename?: 'Network';
  asset?: Maybe<Scalars['String']['output']>;
  bugTrackerEnabled?: Maybe<Scalars['Boolean']['output']>;
  caption: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  networkRoles?: Maybe<Array<Maybe<NetworkRole>>>;
  open?: Maybe<Scalars['Boolean']['output']>;
  owner?: Maybe<Scalars['String']['output']>;
  public?: Maybe<Scalars['Boolean']['output']>;
  users?: Maybe<NetworkUsersResponse>;
};

export type NetworkApplyAnswerInput = {
  status?: InputMaybe<NetworkInvitationStatusResponse>;
};

export type NetworkInput = {
  caption: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  open?: InputMaybe<Scalars['Boolean']['input']>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NetworkInvitation = {
  __typename?: 'NetworkInvitation';
  id: Scalars['ID']['output'];
  message?: Maybe<Scalars['String']['output']>;
  network?: Maybe<Network>;
  networkId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<NetworkInvitationStatus>;
  targetUser?: Maybe<User>;
  targetUserId?: Maybe<Scalars['String']['output']>;
  type?: Maybe<NetworkInvitationType>;
};

export type NetworkInvitationInput = {
  message?: InputMaybe<Scalars['String']['input']>;
  networkId?: InputMaybe<Scalars['String']['input']>;
  targetUserId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<NetworkInvitationType>;
};

export type NetworkInvitationResponse = {
  __typename?: 'NetworkInvitationResponse';
  collection: Array<NetworkInvitation>;
  meta: Meta;
};

export enum NetworkInvitationStatus {
  Accepted = 'accepted',
  Declined = 'declined',
  Pending = 'pending'
}

export enum NetworkInvitationStatusResponse {
  Accepted = 'accepted',
  Declined = 'declined'
}

export type NetworkInvitationToken = {
  __typename?: 'NetworkInvitationToken';
  email: Scalars['String']['output'];
  token: Scalars['String']['output'];
};

export enum NetworkInvitationType {
  Application = 'application',
  Invitation = 'invitation'
}

export enum NetworkRole {
  ImportOwn = 'importOwn',
  Member = 'member',
  Mod = 'mod',
  None = 'none',
  Owner = 'owner'
}

export enum NetworkState {
  InNetwork = 'in_network',
  NotInNetwork = 'not_in_network'
}

export type NetworkTalentsInput = {
  _links: TalentLink;
};

export type NetworkTalentsResponse = {
  __typename?: 'NetworkTalentsResponse';
  collection: Array<Talent>;
  meta: Meta;
};

export type NetworkTokenInput = {
  token: Scalars['String']['input'];
};

export type NetworkTokenInvitation = {
  __typename?: 'NetworkTokenInvitation';
  network: Network;
  networkId: Scalars['String']['output'];
  tokens: Array<NetworkInvitationToken>;
  type: Scalars['String']['output'];
  user: User;
  userId: Scalars['String']['output'];
};

export type NetworkTokenInvitationInput = {
  recipients: Array<Recipient>;
  type: Scalars['String']['input'];
  withObject?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NetworkUsersInput = {
  _links: UserLink;
};

export type NetworkUsersResponse = {
  __typename?: 'NetworkUsersResponse';
  collection: Array<User>;
  meta: Meta;
};

export type NetworksResponse = {
  __typename?: 'NetworksResponse';
  collection: Array<Network>;
  meta: Meta;
};

export type NovuInboxConfig = {
  __typename?: 'NovuInboxConfig';
  applicationIdentifier: Scalars['String']['output'];
  subscriberHash: Scalars['String']['output'];
  subscriberId: Scalars['String']['output'];
};

export type PasswordInput = {
  oldPassword: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type PerformanceVote = {
  __typename?: 'PerformanceVote';
  private?: Maybe<Array<Scalars['Int']['output']>>;
  privateCount?: Maybe<Scalars['Int']['output']>;
  public?: Maybe<Scalars['Int']['output']>;
  publicDetail?: Maybe<Array<Scalars['Int']['output']>>;
  talentId: Scalars['ID']['output'];
};

export type PerformanceVoteInput = {
  networkId: Scalars['String']['input'];
  talentId: Scalars['ID']['input'];
  vote: Array<InputMaybe<Scalars['Int']['input']>>;
};

export enum PermissionLevel {
  Administrative = 'ADMINISTRATIVE',
  None = 'NONE',
  Personal = 'PERSONAL'
}

export type Playlist = {
  __typename?: 'Playlist';
  caption: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  latestObject?: Maybe<LatestObject>;
  public: Scalars['Boolean']['output'];
  user: Scalars['String']['output'];
};

export type PlaylistInput = {
  caption?: InputMaybe<Scalars['String']['input']>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PlaylistTalentLink = {
  objectByPlaylist: UrlArray;
};

export type PlaylistTalentResponse = {
  __typename?: 'PlaylistTalentResponse';
  collection: Array<Talent>;
  meta: Meta;
};

export type PlaylistTalentsInput = {
  _links: PlaylistTalentLink;
};

export type PlaylistsResponse = {
  __typename?: 'PlaylistsResponse';
  collection: Array<Playlist>;
  meta: Meta;
};

export type Query = {
  __typename?: 'Query';
  activities: ActivitiesResponse;
  activitylevel: Scalars['Int']['output'];
  certificates: Array<Certificate>;
  contactBlockedUsers: Array<ContactBlockedUser>;
  contactConversation: ContactConversation;
  contactConversations: Array<ContactConversation>;
  contactRequests: Array<ContactRequest>;
  followed?: Maybe<UserCollection>;
  follower?: Maybe<UserCollection>;
  globalVoteForDateRange: Array<TalentDataView>;
  invitations: NetworkInvitationResponse;
  isTalentInNetwork: InNetworkState;
  jmtNetworks: JmtNetworkResponse;
  listMarketplaceTalents: NetworkTalentsResponse;
  listMyPersonifications: NetworkTalentsResponse;
  listMyTalents: NetworkTalentsResponse;
  myspace: Network;
  myspaceTalents: MySpaceTalentsResponse;
  network: Network;
  networkFriends: NetworkUsersResponse;
  networkTalents: NetworkTalentsResponse;
  networkUsers: NetworkUsersResponse;
  networks: NetworksResponse;
  newActivities: Array<Activity>;
  novuInboxConfig: NovuInboxConfig;
  performanceVote: PerformanceVote;
  playlist: Playlist;
  playlistTalents: PlaylistTalentResponse;
  playlists: PlaylistsResponse;
  roleModelIds: Array<Scalars['Int']['output']>;
  searchNetwork: SearchNetworkCollection;
  searchTalent: SearchTalent;
  searchUser: SearchUserCollection;
  shanghaiTalent?: Maybe<Talent>;
  sharedTalent: SharedTalentResponse;
  similar: NetworkTalentsResponse;
  similarNetwork: NetworkTalentsResponse;
  similarNetworkV2: NetworkTalentsResponse;
  suggestTalent: Array<SuggestUser>;
  suggestUser: Array<SuggestUser>;
  talent: Talent;
  talentClass: TalentClass;
  talentHistory: Array<HistoryItem>;
  talentLatestVote?: Maybe<Vote>;
  talentLayer?: Maybe<Array<Layer>>;
  talentLayerAnimation?: Maybe<Array<AnimationLayer>>;
  transferTalentRequests: TalentTransferRequests;
  user?: Maybe<User>;
  userMetaData?: Maybe<UserMetaDataResponse>;
  userPersonification: NetworkTalentsResponse;
  userStatus: UserStatusResponse;
  whoami: Authentication;
};


export type QueryActivitiesArgs = {
  date: Scalars['String']['input'];
  from?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryActivitylevelArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryCertificatesArgs = {
  talentId: Scalars['ID']['input'];
};


export type QueryContactConversationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryContactConversationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<ContactRequestStatus>;
};


export type QueryContactRequestsArgs = {
  direction?: InputMaybe<ContactRequestDirection>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<ContactRequestStatus>;
};


export type QueryFollowedArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFollowerArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGlobalVoteForDateRangeArgs = {
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
  talentId: Scalars['ID']['input'];
};


export type QueryInvitationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryIsTalentInNetworkArgs = {
  networkId: Scalars['ID']['input'];
  talentId: Scalars['ID']['input'];
};


export type QueryListMarketplaceTalentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  userId: Scalars['ID']['input'];
};


export type QueryListMyPersonificationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  userId: Scalars['ID']['input'];
};


export type QueryListMyTalentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  userId: Scalars['ID']['input'];
};


export type QueryMyspaceTalentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query: Scalars['String']['input'];
  start?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryNetworkArgs = {
  networkId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type QueryNetworkFriendsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  networkId: Scalars['String']['input'];
  start?: InputMaybe<Scalars['Int']['input']>;
  userId: Scalars['String']['input'];
};


export type QueryNetworkTalentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  networkId: Scalars['ID']['input'];
  start?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryNetworkUsersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  networkId: Scalars['ID']['input'];
  start?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryNetworksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  userId: Scalars['ID']['input'];
};


export type QueryNewActivitiesArgs = {
  isoDate: Scalars['String']['input'];
};


export type QueryPerformanceVoteArgs = {
  network?: InputMaybe<Scalars['String']['input']>;
  talentId: Scalars['ID']['input'];
};


export type QueryPlaylistArgs = {
  id: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type QueryPlaylistTalentsArgs = {
  id: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  userId: Scalars['String']['input'];
};


export type QueryPlaylistsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  userId: Scalars['String']['input'];
};


export type QuerySearchNetworkArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query: Scalars['String']['input'];
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySearchTalentArgs = {
  ageFrom?: InputMaybe<Scalars['Int']['input']>;
  ageTo?: InputMaybe<Scalars['Int']['input']>;
  classId?: InputMaybe<Scalars['String']['input']>;
  fieldPosition?: InputMaybe<Scalars['String']['input']>;
  fifaCountry?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  networkId?: InputMaybe<Scalars['String']['input']>;
  query: Scalars['String']['input'];
  sort: Scalars['String']['input'];
  start?: InputMaybe<Scalars['Int']['input']>;
  yearFrom?: InputMaybe<Scalars['Int']['input']>;
  yearTo?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySearchUserArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  meId: Scalars['String']['input'];
  networkId: Scalars['String']['input'];
  query: Scalars['String']['input'];
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryShanghaiTalentArgs = {
  token: Scalars['String']['input'];
};


export type QuerySharedTalentArgs = {
  hash?: InputMaybe<Scalars['ID']['input']>;
};


export type QuerySimilarArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  talentId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySimilarNetworkArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  networkId: Scalars['ID']['input'];
  queryString?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  userId: Scalars['ID']['input'];
};


export type QuerySimilarNetworkV2Args = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  networkId: Scalars['ID']['input'];
  start?: InputMaybe<Scalars['Int']['input']>;
  talentClass: Scalars['String']['input'];
  talentId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type QuerySuggestTalentArgs = {
  q?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySuggestUserArgs = {
  q: Scalars['String']['input'];
};


export type QueryTalentArgs = {
  talentId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type QueryTalentClassArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTalentHistoryArgs = {
  talentId: Scalars['ID']['input'];
};


export type QueryTalentLatestVoteArgs = {
  talentId: Scalars['ID']['input'];
  type?: InputMaybe<VoteType>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryTalentLayerArgs = {
  contextId?: InputMaybe<Scalars['String']['input']>;
  layerParams?: InputMaybe<Scalars['String']['input']>;
  talentId: Scalars['ID']['input'];
};


export type QueryTalentLayerAnimationArgs = {
  talentId: Scalars['ID']['input'];
};


export type QueryUserArgs = {
  networkId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type QueryUserMetaDataArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryUserPersonificationArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  userId: Scalars['ID']['input'];
};


export type QueryUserStatusArgs = {
  userId: Scalars['ID']['input'];
};

export type Range = {
  __typename?: 'Range';
  from: Scalars['Int']['output'];
  to: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type Recipient = {
  email: Scalars['String']['input'];
};

export type RecoverUsernameInput = {
  email: Scalars['String']['input'];
};

export type RegistrationInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  name: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type RequestPasswordChangeInput = {
  name: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type RequestPasswordChangeResponse = {
  __typename?: 'RequestPasswordChangeResponse';
  token: Scalars['String']['output'];
  user: User;
};

export type RoleModelInput = {
  roleModelId: Scalars['Int']['input'];
};

export enum Salutation {
  Female = 'female',
  Male = 'male'
}

export type Scalar = {
  __typename?: 'Scalar';
  caption: Scalars['String']['output'];
  formula: Scalars['Boolean']['output'];
  offset: Scalars['Int']['output'];
};

export type SearchNetworkCollection = {
  __typename?: 'SearchNetworkCollection';
  collection: Array<Network>;
  meta: Meta;
};

export type SearchTalent = {
  __typename?: 'SearchTalent';
  collection: Array<Talent>;
  meta: Meta;
};

export type SearchUserCollection = {
  __typename?: 'SearchUserCollection';
  collection: Array<User>;
  meta: Meta;
};

export type SendContactMessageInput = {
  body: Scalars['String']['input'];
  conversationId: Scalars['ID']['input'];
};

export type ShareTalentInput = {
  roleModel?: InputMaybe<Scalars['Boolean']['input']>;
  talentId: Scalars['ID']['input'];
};

export type ShareTalentResponse = {
  __typename?: 'ShareTalentResponse';
  publicToken: Scalars['String']['output'];
};

export type SharedTalentId = {
  __typename?: 'SharedTalentId';
  dataViews: Array<TalentDataView>;
  key: Scalars['String']['output'];
};

export type SharedTalentResponse = {
  __typename?: 'SharedTalentResponse';
  certificates: Array<Certificate>;
  roleModel?: Maybe<Talent>;
  sharedRoleModel: Scalars['Boolean']['output'];
  talent: Talent;
  talentHistory: Array<HistoryItem>;
  talentIds: Array<SharedTalentId>;
};

export type SuggestUser = {
  __typename?: 'SuggestUser';
  name: Scalars['String']['output'];
};

export type Talent = {
  __typename?: 'Talent';
  asset?: Maybe<Scalars['String']['output']>;
  caption: Scalars['String']['output'];
  customMeta?: Maybe<TalentCustomMeta>;
  dataViews: Array<TalentDataView>;
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  imageSource?: Maybe<Scalars['String']['output']>;
  metas: TalentMeta;
  permissionLevel: PermissionLevel;
  personification?: Maybe<Scalars['Boolean']['output']>;
  playlistCount?: Maybe<Scalars['Int']['output']>;
  profileId?: Maybe<Scalars['String']['output']>;
  public?: Maybe<Scalars['Boolean']['output']>;
  rateCount?: Maybe<Scalars['Int']['output']>;
  tm_id?: Maybe<Scalars['Int']['output']>;
};

export type TalentClass = {
  __typename?: 'TalentClass';
  dataViews: Array<TalentClassDataView>;
  id: Scalars['ID']['output'];
};

export type TalentClassDataView = {
  __typename?: 'TalentClassDataView';
  backgroundColor?: Maybe<Scalars['String']['output']>;
  borderColor?: Maybe<Scalars['String']['output']>;
  caption: Scalars['String']['output'];
  chartType: ChartType;
  id: Scalars['ID']['output'];
  textColor?: Maybe<Scalars['String']['output']>;
  voteScalarGroups?: Maybe<Array<VoteScalarGroup>>;
  withGroupLabels?: Maybe<Scalars['Boolean']['output']>;
  withLabelHover?: Maybe<Scalars['Boolean']['output']>;
};

export type TalentCustomMeta = {
  __typename?: 'TalentCustomMeta';
  club?: Maybe<Scalars['String']['output']>;
  foot?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  rolemodelid?: Maybe<Scalars['Int']['output']>;
  salutation?: Maybe<Salutation>;
  status?: Maybe<Scalars['String']['output']>;
  team?: Maybe<Scalars['String']['output']>;
  topskillsindexes?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  weight?: Maybe<Scalars['Int']['output']>;
};

export type TalentCustomMetaInput = {
  club?: InputMaybe<Scalars['String']['input']>;
  foot?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  rolemodelid?: InputMaybe<Scalars['Int']['input']>;
  salutation?: InputMaybe<Salutation>;
  status?: InputMaybe<Scalars['String']['input']>;
  team?: InputMaybe<Scalars['String']['input']>;
  topskillsindexes?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  weight?: InputMaybe<Scalars['Int']['input']>;
};

export type TalentDataView = {
  __typename?: 'TalentDataView';
  key: Scalars['Int']['output'];
  values: Array<Scalars['Float']['output']>;
};

export type TalentInput = {
  autoProfile?: InputMaybe<Scalars['Boolean']['input']>;
  autoPublicSelf?: InputMaybe<Scalars['Boolean']['input']>;
  caption: Scalars['String']['input'];
  metas: TalentMetaInput;
  networkId?: InputMaybe<Scalars['String']['input']>;
  publicSelf?: InputMaybe<Scalars['String']['input']>;
};

export type TalentLink = {
  objectByNetwork: UrlArray;
};

export type TalentMeta = {
  __typename?: 'TalentMeta';
  date: Scalars['String']['output'];
  fieldPosition: TalentPosition;
  fifaCountry: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
};

export type TalentMetaInput = {
  date: Scalars['String']['input'];
  fieldPosition?: InputMaybe<TalentPosition>;
  fifaCountry: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
};

export enum TalentPosition {
  Defensive = 'defensive',
  Goal = 'goal',
  Midfield = 'midfield',
  Offensive = 'offensive'
}

export type TalentTransferRequest = {
  __typename?: 'TalentTransferRequest';
  from: User;
  id: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  object?: Maybe<Talent>;
  status: TalentTransferRequestStatus;
  statusStamp: Scalars['String']['output'];
  targetUser: User;
};

export enum TalentTransferRequestStatus {
  Accepted = 'accepted',
  Declined = 'declined',
  Pending = 'pending'
}

export type TalentTransferRequests = {
  __typename?: 'TalentTransferRequests';
  collection: Array<TalentTransferRequest>;
};

export type TransferTalentRequestInput = {
  message: Scalars['String']['input'];
  networkId: Scalars['Int']['input'];
  objectId: Scalars['Int']['input'];
  targetUserId: Scalars['Int']['input'];
};

export type UrlArray = {
  url: Array<InputMaybe<Scalars['String']['input']>>;
};

export type UrlInput = {
  url: Scalars['String']['input'];
};

export type User = {
  __typename?: 'User';
  _created: Scalars['Int']['output'];
  _links?: Maybe<UserLinks>;
  asset?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  followed?: Maybe<UserCollection>;
  followers?: Maybe<UserCollection>;
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  isFriend?: Maybe<Scalars['Boolean']['output']>;
  lastName: Scalars['String']['output'];
  name: Scalars['String']['output'];
  networkRoles?: Maybe<Array<NetworkRole>>;
  personificationId?: Maybe<Scalars['String']['output']>;
  public: Scalars['Boolean']['output'];
  status?: Maybe<Scalars['String']['output']>;
  userMetaData?: Maybe<UserMetaDataResponse>;
};

export type UserBehavior = {
  __typename?: 'UserBehavior';
  onboardingDone?: Maybe<Array<Scalars['String']['output']>>;
  preferredPerformanceView?: Maybe<Scalars['String']['output']>;
  termsAcceptedAt?: Maybe<Scalars['String']['output']>;
  termsVersionAccepted?: Maybe<Scalars['Int']['output']>;
};

export type UserBehaviorInput = {
  onboardingDone?: InputMaybe<Array<Scalars['String']['input']>>;
  preferredPerformanceView?: InputMaybe<Scalars['String']['input']>;
  termsAcceptedAt?: InputMaybe<Scalars['String']['input']>;
  termsVersionAccepted?: InputMaybe<Scalars['Int']['input']>;
};

export type UserCollection = {
  __typename?: 'UserCollection';
  collection: Array<User>;
  meta: Meta;
};

export type UserInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  newPassword?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserLink = {
  userByNetwork: UrlArray;
};

export type UserLinkInput = {
  profile: UrlInput;
};

export type UserLinks = {
  __typename?: 'UserLinks';
  followed_users?: Maybe<Link>;
  followers?: Maybe<Link>;
};

export type UserMetaData = {
  __typename?: 'UserMetaData';
  aboutMe?: Maybe<Scalars['String']['output']>;
  activitiesLastViewed?: Maybe<Scalars['String']['output']>;
  ageCategory?: Maybe<Array<Maybe<AgeCategory>>>;
  behavior?: Maybe<UserBehavior>;
  birthdate?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  club?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  experience?: Maybe<Array<Maybe<Experience>>>;
  phone?: Maybe<Scalars['String']['output']>;
  salutation?: Maybe<Salutation>;
  status?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  team?: Maybe<Scalars['String']['output']>;
  userType?: Maybe<Array<Maybe<UserType>>>;
  username: Scalars['String']['output'];
  year?: Maybe<Scalars['Int']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type UserMetaDataCollection = {
  __typename?: 'UserMetaDataCollection';
  collection?: Maybe<Array<CurrentUser>>;
  meta: Meta;
};

export type UserMetaDataInput = {
  aboutMe?: InputMaybe<Scalars['String']['input']>;
  activitiesLastViewed?: InputMaybe<Scalars['String']['input']>;
  ageCategory?: InputMaybe<Array<InputMaybe<AgeCategory>>>;
  behavior?: InputMaybe<UserBehaviorInput>;
  birthdate?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  club?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  experience?: InputMaybe<Array<InputMaybe<Experience>>>;
  phone?: InputMaybe<Scalars['String']['input']>;
  salutation?: InputMaybe<Salutation>;
  status?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  team?: InputMaybe<Scalars['String']['input']>;
  userType?: InputMaybe<Array<InputMaybe<UserType>>>;
  username: Scalars['String']['input'];
  year?: InputMaybe<Scalars['Int']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type UserMetaDataResponse = {
  __typename?: 'UserMetaDataResponse';
  user?: Maybe<CurrentUser>;
};

export type UserMetaDataSaveResponse = {
  __typename?: 'UserMetaDataSaveResponse';
  current_user?: Maybe<CurrentUser>;
};

export type UserRecover = {
  __typename?: 'UserRecover';
  _links?: Maybe<UserLinks>;
  email?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  name: Scalars['String']['output'];
  public: Scalars['Boolean']['output'];
  status?: Maybe<Scalars['String']['output']>;
};

export type UserRecoverCollection = {
  __typename?: 'UserRecoverCollection';
  collection: Array<UserRecover>;
  meta: Meta;
};

export type UserStatusResponse = {
  __typename?: 'UserStatusResponse';
  jmtNetworks?: Maybe<Array<Scalars['String']['output']>>;
  selfNetwork?: Maybe<Scalars['String']['output']>;
  selfPlayer?: Maybe<Scalars['String']['output']>;
  selfUser?: Maybe<Scalars['ID']['output']>;
};

export enum UserType {
  Other = 'other',
  Player = 'player',
  Relatives = 'relatives',
  Scout = 'scout',
  Supervisor = 'supervisor',
  Trainer = 'trainer'
}

export type Vote = {
  __typename?: 'Vote';
  cc?: Maybe<Scalars['String']['output']>;
  dataViews: Array<Scalars['Int']['output']>;
  date: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  object: Talent;
  qlty?: Maybe<Scalars['String']['output']>;
  values: Array<Scalars['Int']['output']>;
};

export type VoteInput = {
  date?: InputMaybe<Scalars['String']['input']>;
  networkId?: InputMaybe<Scalars['ID']['input']>;
  values: Array<InputMaybe<Scalars['Int']['input']>>;
};

export type VoteScalarGroup = {
  __typename?: 'VoteScalarGroup';
  caption: Scalars['String']['output'];
  offset: Scalars['Int']['output'];
  scalars: Array<Scalar>;
};

export enum VoteType {
  ProfiVote = 'profiVote',
  ShortVote = 'shortVote'
}

export type SigninMutationVariables = Exact<{
  input: AuthenticationFormInput;
}>;


export type SigninMutation = { __typename?: 'Mutation', signin?: { __typename?: 'Authentication', token: string, apiToken: string, user: { __typename?: 'User', id: string, name: string, status?: string | null, public: boolean, email?: string | null, firstName: string, lastName: string, networkRoles?: Array<NetworkRole> | null, image?: string | null, asset?: string | null, personificationId?: string | null, _created: number } } | null };

export type SigninWithTokenMutationVariables = Exact<{
  input: AuthenticationTokenInput;
}>;


export type SigninWithTokenMutation = { __typename?: 'Mutation', signinWithToken: { __typename?: 'Authentication', token: string, apiToken: string, user: { __typename?: 'User', id: string, name: string, status?: string | null, public: boolean, email?: string | null, firstName: string, lastName: string, networkRoles?: Array<NetworkRole> | null, image?: string | null, asset?: string | null, personificationId?: string | null, _created: number } } };

export type SigninWithHsvidCodeMutationVariables = Exact<{
  input: AuthenticationCodeInput;
}>;


export type SigninWithHsvidCodeMutation = { __typename?: 'Mutation', signinWithHSVIDCode: Array<{ __typename?: 'Authentication', token: string, apiToken: string, user: { __typename?: 'User', id: string, name: string, status?: string | null, public: boolean, email?: string | null, firstName: string, lastName: string, networkRoles?: Array<NetworkRole> | null, image?: string | null, asset?: string | null, personificationId?: string | null, _created: number } }> };

export type RegisterMutationVariables = Exact<{
  input: RegistrationInput;
}>;


export type RegisterMutation = { __typename?: 'Mutation', register: { __typename?: 'Authentication', token: string, user: { __typename?: 'User', id: string, name: string, status?: string | null, public: boolean, email?: string | null, firstName: string, lastName: string, networkRoles?: Array<NetworkRole> | null, image?: string | null, asset?: string | null, personificationId?: string | null, _created: number } } };

export type DoimailMutationVariables = Exact<{
  input: DoimailInput;
}>;


export type DoimailMutation = { __typename?: 'Mutation', doimail: { __typename?: 'Message', message?: string | null } };

export type WhoamiQueryVariables = Exact<{ [key: string]: never; }>;


export type WhoamiQuery = { __typename?: 'Query', whoami: { __typename?: 'Authentication', token: string, apiToken: string, user: { __typename?: 'User', id: string, name: string, status?: string | null, public: boolean, email?: string | null, firstName: string, lastName: string, networkRoles?: Array<NetworkRole> | null, image?: string | null, asset?: string | null, personificationId?: string | null, _created: number } } };

export type ContactMessageFragment = { __typename?: 'ContactMessage', id: string, conversationId: string, body: string, status: ContactMessageStatus, fromUserId?: string | null, fromExternal: boolean, createdAt: string, readAt?: string | null };

export type ContactUserFragment = { __typename?: 'User', id: string, firstName: string, lastName: string, image?: string | null };

export type ContactTargetFragment = { __typename?: 'ContactTarget', type: ContactTargetType, id: string, name?: string | null, image?: string | null };

export type ContactRequestFragment = { __typename?: 'ContactRequest', id: string, status: ContactRequestStatus, targetType: ContactTargetType, targetId: string, fromUserId: string, conversationId: string, message: string, createdAt: string };

export type ContactRequestWithPeopleFragment = { __typename?: 'ContactRequest', id: string, status: ContactRequestStatus, targetType: ContactTargetType, targetId: string, fromUserId: string, conversationId: string, message: string, createdAt: string, fromUser?: { __typename?: 'User', id: string, firstName: string, lastName: string, image?: string | null } | null, target?: { __typename?: 'ContactTarget', type: ContactTargetType, id: string, name?: string | null, image?: string | null } | null };

export type ContactConversationFragment = { __typename?: 'ContactConversation', id: string, status: ContactRequestStatus, targetType: ContactTargetType, targetId: string, participantUserIds: Array<string>, createdAt: string, updatedAt: string, messages: Array<{ __typename?: 'ContactMessage', id: string, conversationId: string, body: string, status: ContactMessageStatus, fromUserId?: string | null, fromExternal: boolean, createdAt: string, readAt?: string | null }> };

export type ContactConversationListItemFragment = { __typename?: 'ContactConversation', id: string, status: ContactRequestStatus, updatedAt: string, unreadCount: number, counterpart?: { __typename?: 'User', id: string, firstName: string, lastName: string, image?: string | null } | null, request?: { __typename?: 'ContactRequest', id: string, fromUserId: string, target?: { __typename?: 'ContactTarget', type: ContactTargetType, id: string, name?: string | null, image?: string | null } | null } | null, lastMessage?: { __typename?: 'ContactMessage', id: string, body: string, createdAt: string, fromUserId?: string | null, status: ContactMessageStatus } | null };

export type ContactConversationsQueryVariables = Exact<{
  status?: InputMaybe<ContactRequestStatus>;
  start?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ContactConversationsQuery = { __typename?: 'Query', contactConversations: Array<{ __typename?: 'ContactConversation', id: string, status: ContactRequestStatus, updatedAt: string, unreadCount: number, counterpart?: { __typename?: 'User', id: string, firstName: string, lastName: string, image?: string | null } | null, request?: { __typename?: 'ContactRequest', id: string, fromUserId: string, target?: { __typename?: 'ContactTarget', type: ContactTargetType, id: string, name?: string | null, image?: string | null } | null } | null, lastMessage?: { __typename?: 'ContactMessage', id: string, body: string, createdAt: string, fromUserId?: string | null, status: ContactMessageStatus } | null }> };

export type ContactUnreadQueryVariables = Exact<{ [key: string]: never; }>;


export type ContactUnreadQuery = { __typename?: 'Query', contactConversations: Array<{ __typename?: 'ContactConversation', id: string, unreadCount: number }> };

export type ContactBlockedUserFragment = { __typename?: 'ContactBlockedUser', userId: string, createdAt: string, user?: { __typename?: 'User', id: string, firstName: string, lastName: string, image?: string | null } | null };

export type ContactBlockedUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type ContactBlockedUsersQuery = { __typename?: 'Query', contactBlockedUsers: Array<{ __typename?: 'ContactBlockedUser', userId: string, createdAt: string, user?: { __typename?: 'User', id: string, firstName: string, lastName: string, image?: string | null } | null }> };

export type ContactRequestsQueryVariables = Exact<{
  status?: InputMaybe<ContactRequestStatus>;
  direction?: InputMaybe<ContactRequestDirection>;
  start?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ContactRequestsQuery = { __typename?: 'Query', contactRequests: Array<{ __typename?: 'ContactRequest', id: string, status: ContactRequestStatus, targetType: ContactTargetType, targetId: string, fromUserId: string, conversationId: string, message: string, createdAt: string }> };

export type ContactRequestsWithPeopleQueryVariables = Exact<{
  status?: InputMaybe<ContactRequestStatus>;
  direction?: InputMaybe<ContactRequestDirection>;
  start?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ContactRequestsWithPeopleQuery = { __typename?: 'Query', contactRequests: Array<{ __typename?: 'ContactRequest', id: string, status: ContactRequestStatus, targetType: ContactTargetType, targetId: string, fromUserId: string, conversationId: string, message: string, createdAt: string, fromUser?: { __typename?: 'User', id: string, firstName: string, lastName: string, image?: string | null } | null, target?: { __typename?: 'ContactTarget', type: ContactTargetType, id: string, name?: string | null, image?: string | null } | null }> };

export type ContactConversationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ContactConversationQuery = { __typename?: 'Query', contactConversation: { __typename?: 'ContactConversation', id: string, status: ContactRequestStatus, targetType: ContactTargetType, targetId: string, participantUserIds: Array<string>, createdAt: string, updatedAt: string, messages: Array<{ __typename?: 'ContactMessage', id: string, conversationId: string, body: string, status: ContactMessageStatus, fromUserId?: string | null, fromExternal: boolean, createdAt: string, readAt?: string | null }> } };

export type ContactConversationHeaderQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ContactConversationHeaderQuery = { __typename?: 'Query', contactConversation: { __typename?: 'ContactConversation', id: string, status: ContactRequestStatus, counterpart?: { __typename?: 'User', id: string, firstName: string, lastName: string, image?: string | null } | null, request?: { __typename?: 'ContactRequest', id: string, status: ContactRequestStatus, fromUserId: string, target?: { __typename?: 'ContactTarget', type: ContactTargetType, id: string, name?: string | null, image?: string | null } | null } | null } };

export type CreateContactRequestMutationVariables = Exact<{
  input: CreateContactRequestInput;
}>;


export type CreateContactRequestMutation = { __typename?: 'Mutation', createContactRequest: { __typename?: 'ContactRequest', id: string, status: ContactRequestStatus, targetType: ContactTargetType, targetId: string, fromUserId: string, conversationId: string, message: string, createdAt: string } };

export type AcceptContactRequestMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AcceptContactRequestMutation = { __typename?: 'Mutation', acceptContactRequest: { __typename?: 'ContactRequest', id: string, status: ContactRequestStatus, targetType: ContactTargetType, targetId: string, fromUserId: string, conversationId: string, message: string, createdAt: string } };

export type DeclineContactRequestMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeclineContactRequestMutation = { __typename?: 'Mutation', declineContactRequest: { __typename?: 'ContactRequest', id: string, status: ContactRequestStatus, targetType: ContactTargetType, targetId: string, fromUserId: string, conversationId: string, message: string, createdAt: string } };

export type WithdrawContactRequestMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type WithdrawContactRequestMutation = { __typename?: 'Mutation', withdrawContactRequest: { __typename?: 'ContactRequest', id: string, status: ContactRequestStatus, targetType: ContactTargetType, targetId: string, fromUserId: string, conversationId: string, message: string, createdAt: string } };

export type SendContactMessageMutationVariables = Exact<{
  input: SendContactMessageInput;
}>;


export type SendContactMessageMutation = { __typename?: 'Mutation', sendContactMessage: { __typename?: 'ContactMessage', id: string, conversationId: string, body: string, status: ContactMessageStatus, fromUserId?: string | null, fromExternal: boolean, createdAt: string, readAt?: string | null } };

export type DeleteContactConversationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteContactConversationMutation = { __typename?: 'Mutation', deleteContactConversation: boolean };

export type BlockContactUserMutationVariables = Exact<{
  conversationId: Scalars['ID']['input'];
}>;


export type BlockContactUserMutation = { __typename?: 'Mutation', blockContactUser: boolean };

export type UnblockContactUserMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type UnblockContactUserMutation = { __typename?: 'Mutation', unblockContactUser: boolean };

export type ReportContactUserMutationVariables = Exact<{
  input: CreateContactReportInput;
}>;


export type ReportContactUserMutation = { __typename?: 'Mutation', reportContactUser: boolean };

export type MarkContactConversationReadMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type MarkContactConversationReadMutation = { __typename?: 'Mutation', markContactConversationRead: { __typename?: 'ContactConversation', id: string, status: ContactRequestStatus, targetType: ContactTargetType, targetId: string, participantUserIds: Array<string>, createdAt: string, updatedAt: string, messages: Array<{ __typename?: 'ContactMessage', id: string, conversationId: string, body: string, status: ContactMessageStatus, fromUserId?: string | null, fromExternal: boolean, createdAt: string, readAt?: string | null }> } };

export type UploadImageMutationVariables = Exact<{
  input: Scalars['String']['input'];
}>;


export type UploadImageMutation = { __typename?: 'Mutation', uploadImage: { __typename?: 'FileUploadResponse', id: string, token: string, url: string, user: string, _created: number, _updated: number, _links: { __typename?: 'Links', self: { __typename?: 'Link', rel: string, url: string } } } };

export type PlaylistFragment = { __typename?: 'Playlist', id: string, caption: string, public: boolean, user: string, latestObject?: { __typename?: 'LatestObject', image?: string | null } | null };

export type NetworkFragment = { __typename?: 'Network', id: string, caption: string, description?: string | null, owner?: string | null, public?: boolean | null, open?: boolean | null, bugTrackerEnabled?: boolean | null, networkRoles?: Array<NetworkRole | null> | null, image?: string | null, asset?: string | null };

export type NetworkSearchResultFragment = { __typename?: 'Network', id: string, caption: string, description?: string | null, owner?: string | null, public?: boolean | null, open?: boolean | null, bugTrackerEnabled?: boolean | null, image?: string | null };

export type JmtNetworkFragment = { __typename?: 'Network', id: string, caption: string, description?: string | null, public?: boolean | null, open?: boolean | null, bugTrackerEnabled?: boolean | null, networkRoles?: Array<NetworkRole | null> | null };

export type NetworksOfUserQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type NetworksOfUserQuery = { __typename?: 'Query', networks: { __typename?: 'NetworksResponse', collection: Array<{ __typename?: 'Network', id: string, caption: string, description?: string | null, owner?: string | null, public?: boolean | null, open?: boolean | null, bugTrackerEnabled?: boolean | null, networkRoles?: Array<NetworkRole | null> | null, image?: string | null, asset?: string | null }>, meta: { __typename?: 'Meta', range?: { __typename?: 'Range', from: number, to: number, total: number } | null, sortOptions?: Array<{ __typename?: 'MapEntry', key: string, value: string }> | null } } };

export type NetworksQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type NetworksQuery = { __typename?: 'Query', networks: { __typename?: 'NetworksResponse', collection: Array<{ __typename?: 'Network', id: string, caption: string, description?: string | null, owner?: string | null, public?: boolean | null, open?: boolean | null, bugTrackerEnabled?: boolean | null, networkRoles?: Array<NetworkRole | null> | null, image?: string | null, asset?: string | null }>, meta: { __typename?: 'Meta', range?: { __typename?: 'Range', from: number, to: number, total: number } | null, sortOptions?: Array<{ __typename?: 'MapEntry', key: string, value: string }> | null } } };

export type NetworkQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
  networkId: Scalars['ID']['input'];
}>;


export type NetworkQuery = { __typename?: 'Query', network: { __typename?: 'Network', id: string, caption: string, description?: string | null, owner?: string | null, public?: boolean | null, open?: boolean | null, bugTrackerEnabled?: boolean | null, networkRoles?: Array<NetworkRole | null> | null, image?: string | null, asset?: string | null } };

export type PlaylistTalentsQueryVariables = Exact<{
  userId: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  start?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PlaylistTalentsQuery = { __typename?: 'Query', playlistTalents: { __typename?: 'PlaylistTalentResponse', collection: Array<{ __typename?: 'Talent', id: string, caption: string, image?: string | null, imageSource?: string | null, playlistCount?: number | null, public?: boolean | null, permissionLevel: PermissionLevel, personification?: boolean | null, rateCount?: number | null, tm_id?: number | null, profileId?: string | null, asset?: string | null, dataViews: Array<{ __typename?: 'TalentDataView', key: number, values: Array<number> }>, metas: { __typename?: 'TalentMeta', date: string, fieldPosition: TalentPosition, fifaCountry: string, firstName: string, lastName: string }, customMeta?: { __typename?: 'TalentCustomMeta', id?: string | null, foot?: string | null, club?: string | null, team?: string | null, height?: number | null, weight?: number | null, rolemodelid?: number | null, topskillsindexes?: Array<number | null> | null, status?: string | null, salutation?: Salutation | null } | null }>, meta: { __typename?: 'Meta', range?: { __typename?: 'Range', from: number, to: number, total: number } | null, sortOptions?: Array<{ __typename?: 'MapEntry', key: string, value: string }> | null } } };

export type PlaylistQueryVariables = Exact<{
  userId: Scalars['String']['input'];
  id: Scalars['String']['input'];
}>;


export type PlaylistQuery = { __typename?: 'Query', playlist: { __typename?: 'Playlist', id: string, caption: string, public: boolean, user: string, latestObject?: { __typename?: 'LatestObject', image?: string | null } | null } };

export type PlaylistsQueryVariables = Exact<{
  userId: Scalars['String']['input'];
  start?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PlaylistsQuery = { __typename?: 'Query', playlists: { __typename?: 'PlaylistsResponse', collection: Array<{ __typename?: 'Playlist', id: string, caption: string, public: boolean, user: string, latestObject?: { __typename?: 'LatestObject', image?: string | null } | null }>, meta: { __typename?: 'Meta', range?: { __typename?: 'Range', from: number, to: number, total: number } | null, sortOptions?: Array<{ __typename?: 'MapEntry', key: string, value: string }> | null } } };

export type AddPlaylistMutationVariables = Exact<{
  input: PlaylistInput;
}>;


export type AddPlaylistMutation = { __typename?: 'Mutation', addPlaylist: { __typename?: 'Playlist', id: string, caption: string, public: boolean, user: string, latestObject?: { __typename?: 'LatestObject', image?: string | null } | null } };

export type EditPlaylistMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: PlaylistInput;
}>;


export type EditPlaylistMutation = { __typename?: 'Mutation', editPlaylist: { __typename?: 'Playlist', id: string, caption: string, public: boolean, user: string, latestObject?: { __typename?: 'LatestObject', image?: string | null } | null } };

export type DeletePlaylistMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeletePlaylistMutation = { __typename?: 'Mutation', deletePlaylist?: boolean | null };

export type AddTalentsToPlaylistMutationVariables = Exact<{
  id: Scalars['String']['input'];
  talents: PlaylistTalentsInput;
}>;


export type AddTalentsToPlaylistMutation = { __typename?: 'Mutation', addTalentsToPlaylist: { __typename?: 'Playlist', id: string, caption: string, public: boolean, user: string, latestObject?: { __typename?: 'LatestObject', image?: string | null } | null } };

export type RemoveTalentsFromPlaylistMutationVariables = Exact<{
  id: Scalars['String']['input'];
  talents: PlaylistTalentsInput;
}>;


export type RemoveTalentsFromPlaylistMutation = { __typename?: 'Mutation', removeTalentsFromPlaylist: { __typename?: 'Playlist', id: string, caption: string, public: boolean, user: string, latestObject?: { __typename?: 'LatestObject', image?: string | null } | null } };

export type IsTalentInNetworkQueryVariables = Exact<{
  talentId: Scalars['ID']['input'];
  networkId: Scalars['ID']['input'];
}>;


export type IsTalentInNetworkQuery = { __typename?: 'Query', isTalentInNetwork: { __typename?: 'InNetworkState', state: NetworkState } };

export type MyspaceQueryVariables = Exact<{ [key: string]: never; }>;


export type MyspaceQuery = { __typename?: 'Query', myspace: { __typename?: 'Network', id: string, caption: string, description?: string | null, owner?: string | null, public?: boolean | null, open?: boolean | null, bugTrackerEnabled?: boolean | null, networkRoles?: Array<NetworkRole | null> | null, image?: string | null, asset?: string | null } };

export type MyspaceTalentsQueryVariables = Exact<{
  query: Scalars['String']['input'];
  start?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type MyspaceTalentsQuery = { __typename?: 'Query', myspaceTalents: { __typename?: 'MySpaceTalentsResponse', meta: { __typename?: 'Meta', range?: { __typename?: 'Range', from: number, to: number, total: number } | null, sortOptions?: Array<{ __typename?: 'MapEntry', key: string, value: string }> | null }, collection: Array<{ __typename?: 'MyPlaceTalent', network: { __typename?: 'Network', id: string, caption: string, description?: string | null, owner?: string | null, public?: boolean | null, open?: boolean | null, bugTrackerEnabled?: boolean | null, networkRoles?: Array<NetworkRole | null> | null, image?: string | null, asset?: string | null }, talent: { __typename?: 'Talent', id: string, caption: string, image?: string | null, imageSource?: string | null, playlistCount?: number | null, public?: boolean | null, permissionLevel: PermissionLevel, personification?: boolean | null, rateCount?: number | null, tm_id?: number | null, profileId?: string | null, asset?: string | null, dataViews: Array<{ __typename?: 'TalentDataView', key: number, values: Array<number> }>, metas: { __typename?: 'TalentMeta', date: string, fieldPosition: TalentPosition, fifaCountry: string, firstName: string, lastName: string }, customMeta?: { __typename?: 'TalentCustomMeta', id?: string | null, foot?: string | null, club?: string | null, team?: string | null, height?: number | null, weight?: number | null, rolemodelid?: number | null, topskillsindexes?: Array<number | null> | null, status?: string | null, salutation?: Salutation | null } | null } }> } };

export type NetworkUsersQueryVariables = Exact<{
  networkId: Scalars['ID']['input'];
  start?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type NetworkUsersQuery = { __typename?: 'Query', networkUsers: { __typename?: 'NetworkUsersResponse', collection: Array<{ __typename?: 'User', id: string, name: string, status?: string | null, public: boolean, email?: string | null, firstName: string, lastName: string, networkRoles?: Array<NetworkRole> | null, image?: string | null, asset?: string | null, personificationId?: string | null, _created: number, userMetaData?: { __typename?: 'UserMetaDataResponse', user?: { __typename?: 'CurrentUser', _created: number, data?: { __typename?: 'UserMetaData', username: string, aboutMe?: string | null, ageCategory?: Array<AgeCategory | null> | null, birthdate?: string | null, city?: string | null, club?: string | null, country?: string | null, experience?: Array<Experience | null> | null, phone?: string | null, street?: string | null, team?: string | null, userType?: Array<UserType | null> | null, year?: number | null, zip?: string | null, activitiesLastViewed?: string | null, status?: string | null, salutation?: Salutation | null, behavior?: { __typename?: 'UserBehavior', termsAcceptedAt?: string | null, termsVersionAccepted?: number | null, onboardingDone?: Array<string> | null, preferredPerformanceView?: string | null } | null } | null } | null } | null }>, meta: { __typename?: 'Meta', range?: { __typename?: 'Range', from: number, to: number, total: number } | null, sortOptions?: Array<{ __typename?: 'MapEntry', key: string, value: string }> | null } } };

export type NetworkFriendsQueryVariables = Exact<{
  userId: Scalars['String']['input'];
  networkId: Scalars['String']['input'];
  start?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type NetworkFriendsQuery = { __typename?: 'Query', networkFriends: { __typename?: 'NetworkUsersResponse', collection: Array<{ __typename?: 'User', id: string, name: string, status?: string | null, public: boolean, email?: string | null, firstName: string, lastName: string, networkRoles?: Array<NetworkRole> | null, image?: string | null, asset?: string | null, personificationId?: string | null, _created: number }>, meta: { __typename?: 'Meta', range?: { __typename?: 'Range', from: number, to: number, total: number } | null, sortOptions?: Array<{ __typename?: 'MapEntry', key: string, value: string }> | null } } };

export type NetworkTalentsQueryVariables = Exact<{
  networkId: Scalars['ID']['input'];
  start?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type NetworkTalentsQuery = { __typename?: 'Query', networkTalents: { __typename?: 'NetworkTalentsResponse', collection: Array<{ __typename?: 'Talent', id: string, caption: string, image?: string | null, imageSource?: string | null, playlistCount?: number | null, public?: boolean | null, permissionLevel: PermissionLevel, personification?: boolean | null, rateCount?: number | null, tm_id?: number | null, profileId?: string | null, asset?: string | null, dataViews: Array<{ __typename?: 'TalentDataView', key: number, values: Array<number> }>, metas: { __typename?: 'TalentMeta', date: string, fieldPosition: TalentPosition, fifaCountry: string, firstName: string, lastName: string }, customMeta?: { __typename?: 'TalentCustomMeta', id?: string | null, foot?: string | null, club?: string | null, team?: string | null, height?: number | null, weight?: number | null, rolemodelid?: number | null, topskillsindexes?: Array<number | null> | null, status?: string | null, salutation?: Salutation | null } | null }>, meta: { __typename?: 'Meta', range?: { __typename?: 'Range', from: number, to: number, total: number } | null, sortOptions?: Array<{ __typename?: 'MapEntry', key: string, value: string }> | null } } };

export type AddNetworkMutationVariables = Exact<{
  input: NetworkInput;
}>;


export type AddNetworkMutation = { __typename?: 'Mutation', addNetwork: { __typename?: 'Network', id: string, caption: string, description?: string | null, owner?: string | null, public?: boolean | null, open?: boolean | null, bugTrackerEnabled?: boolean | null, networkRoles?: Array<NetworkRole | null> | null, image?: string | null, asset?: string | null } };

export type EditNetworkMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: NetworkInput;
}>;


export type EditNetworkMutation = { __typename?: 'Mutation', editNetwork: { __typename?: 'Network', id: string, caption: string, description?: string | null, owner?: string | null, public?: boolean | null, open?: boolean | null, bugTrackerEnabled?: boolean | null, networkRoles?: Array<NetworkRole | null> | null, image?: string | null, asset?: string | null } };

export type DeleteNetworkMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteNetworkMutation = { __typename?: 'Mutation', deleteNetwork?: boolean | null };

export type AddTalentsToNetworkMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  talents: NetworkTalentsInput;
}>;


export type AddTalentsToNetworkMutation = { __typename?: 'Mutation', addTalentsToNetwork: { __typename?: 'Network', id: string, caption: string, description?: string | null, owner?: string | null, public?: boolean | null, open?: boolean | null, bugTrackerEnabled?: boolean | null, networkRoles?: Array<NetworkRole | null> | null, image?: string | null, asset?: string | null } };

export type AddUsersToNetworkMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  user: NetworkUsersInput;
}>;


export type AddUsersToNetworkMutation = { __typename?: 'Mutation', addUsersToNetwork: { __typename?: 'Network', id: string, caption: string, description?: string | null, owner?: string | null, public?: boolean | null, open?: boolean | null, bugTrackerEnabled?: boolean | null, networkRoles?: Array<NetworkRole | null> | null, image?: string | null, asset?: string | null } };

export type RemoveUserFromNetworkMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  user: NetworkUsersInput;
}>;


export type RemoveUserFromNetworkMutation = { __typename?: 'Mutation', removeUserFromNetwork: { __typename?: 'Network', id: string, caption: string, description?: string | null, owner?: string | null, public?: boolean | null, open?: boolean | null, bugTrackerEnabled?: boolean | null, networkRoles?: Array<NetworkRole | null> | null, image?: string | null, asset?: string | null } };

export type ToggleModMutationVariables = Exact<{
  id: Scalars['String']['input'];
  networkId: Scalars['String']['input'];
  idUserTarget: Scalars['String']['input'];
}>;


export type ToggleModMutation = { __typename?: 'Mutation', toggleMod?: { __typename?: 'Network', id: string } | null };

export type TransferOwnerMutationVariables = Exact<{
  id: Scalars['String']['input'];
  networkId: Scalars['String']['input'];
  idUserTarget: Scalars['String']['input'];
}>;


export type TransferOwnerMutation = { __typename?: 'Mutation', transferOwner?: { __typename?: 'Network', id: string } | null };

export type RemoveTalentFromNetworkMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  talent: NetworkTalentsInput;
}>;


export type RemoveTalentFromNetworkMutation = { __typename?: 'Mutation', removeTalentFromNetwork: { __typename?: 'Network', id: string, caption: string, description?: string | null, owner?: string | null, public?: boolean | null, open?: boolean | null, bugTrackerEnabled?: boolean | null, networkRoles?: Array<NetworkRole | null> | null, image?: string | null, asset?: string | null } };

export type NetworkLinkImageMutationVariables = Exact<{
  url: Scalars['String']['input'];
  networkId: Scalars['String']['input'];
}>;


export type NetworkLinkImageMutation = { __typename?: 'Mutation', networkLinkImage: { __typename?: 'Network', id: string, caption: string, description?: string | null, owner?: string | null, public?: boolean | null, open?: boolean | null, bugTrackerEnabled?: boolean | null, networkRoles?: Array<NetworkRole | null> | null, image?: string | null, asset?: string | null } };

export type NetworkUnlinkImageMutationVariables = Exact<{
  url: Scalars['String']['input'];
  networkId: Scalars['String']['input'];
}>;


export type NetworkUnlinkImageMutation = { __typename?: 'Mutation', networkUnlinkImage: { __typename?: 'Network', id: string, caption: string, description?: string | null, owner?: string | null, public?: boolean | null, open?: boolean | null, bugTrackerEnabled?: boolean | null, networkRoles?: Array<NetworkRole | null> | null, image?: string | null, asset?: string | null } };

export type SearchNetworkQueryVariables = Exact<{
  query: Scalars['String']['input'];
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SearchNetworkQuery = { __typename?: 'Query', searchNetwork: { __typename?: 'SearchNetworkCollection', meta: { __typename?: 'Meta', range?: { __typename?: 'Range', from: number, to: number, total: number } | null, sortOptions?: Array<{ __typename?: 'MapEntry', value: string, key: string }> | null }, collection: Array<{ __typename?: 'Network', id: string, caption: string, description?: string | null, owner?: string | null, public?: boolean | null, open?: boolean | null, bugTrackerEnabled?: boolean | null, image?: string | null }> } };

export type JmtNetworksQueryVariables = Exact<{ [key: string]: never; }>;


export type JmtNetworksQuery = { __typename?: 'Query', jmtNetworks: { __typename?: 'JMTNetworkResponse', JMTnetworks: { __typename?: 'NetworksResponse', collection: Array<{ __typename?: 'Network', id: string, caption: string, description?: string | null, public?: boolean | null, open?: boolean | null, bugTrackerEnabled?: boolean | null, networkRoles?: Array<NetworkRole | null> | null }> } } };

export type RelatedUsersFromMyNetworksQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type RelatedUsersFromMyNetworksQuery = { __typename?: 'Query', networks: { __typename?: 'NetworksResponse', collection: Array<{ __typename?: 'Network', id: string, caption: string, description?: string | null, public?: boolean | null, open?: boolean | null, bugTrackerEnabled?: boolean | null, networkRoles?: Array<NetworkRole | null> | null, image?: string | null, users?: { __typename?: 'NetworkUsersResponse', collection: Array<{ __typename?: 'User', id: string, name: string, status?: string | null, public: boolean, email?: string | null, firstName: string, lastName: string, networkRoles?: Array<NetworkRole> | null, image?: string | null, asset?: string | null, personificationId?: string | null, _created: number, userMetaData?: { __typename?: 'UserMetaDataResponse', user?: { __typename?: 'CurrentUser', _created: number, data?: { __typename?: 'UserMetaData', username: string, aboutMe?: string | null, ageCategory?: Array<AgeCategory | null> | null, birthdate?: string | null, city?: string | null, club?: string | null, country?: string | null, experience?: Array<Experience | null> | null, phone?: string | null, street?: string | null, team?: string | null, userType?: Array<UserType | null> | null, year?: number | null, zip?: string | null, activitiesLastViewed?: string | null, status?: string | null, salutation?: Salutation | null, behavior?: { __typename?: 'UserBehavior', termsAcceptedAt?: string | null, termsVersionAccepted?: number | null, onboardingDone?: Array<string> | null, preferredPerformanceView?: string | null } | null } | null } | null } | null }> } | null }>, meta: { __typename?: 'Meta', range?: { __typename?: 'Range', from: number, to: number, total: number } | null, sortOptions?: Array<{ __typename?: 'MapEntry', key: string, value: string }> | null } } };

export type InvitationsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
}>;


export type InvitationsQuery = { __typename?: 'Query', invitations: { __typename?: 'NetworkInvitationResponse', meta: { __typename?: 'Meta', range?: { __typename?: 'Range', from: number, to: number, total: number } | null, sortOptions?: Array<{ __typename?: 'MapEntry', key: string, value: string }> | null }, collection: Array<{ __typename?: 'NetworkInvitation', id: string, targetUserId?: string | null, message?: string | null, status?: NetworkInvitationStatus | null, type?: NetworkInvitationType | null, networkId?: string | null, targetUser?: { __typename?: 'User', id: string, name: string, status?: string | null, public: boolean, email?: string | null, firstName: string, lastName: string, networkRoles?: Array<NetworkRole> | null, image?: string | null, asset?: string | null, personificationId?: string | null, _created: number } | null, network?: { __typename?: 'Network', id: string, caption: string, description?: string | null, owner?: string | null, public?: boolean | null, open?: boolean | null, bugTrackerEnabled?: boolean | null, networkRoles?: Array<NetworkRole | null> | null, image?: string | null, asset?: string | null } | null }> } };

export type InviteOrApplyToNetworkMutationVariables = Exact<{
  input: NetworkInvitationInput;
}>;


export type InviteOrApplyToNetworkMutation = { __typename?: 'Mutation', inviteOrApplyToNetwork: { __typename?: 'NetworkInvitation', networkId?: string | null, targetUserId?: string | null, type?: NetworkInvitationType | null, message?: string | null, status?: NetworkInvitationStatus | null, network?: { __typename?: 'Network', id: string, caption: string, description?: string | null, owner?: string | null, public?: boolean | null, open?: boolean | null, bugTrackerEnabled?: boolean | null, networkRoles?: Array<NetworkRole | null> | null, image?: string | null, asset?: string | null } | null, targetUser?: { __typename?: 'User', id: string, name: string, status?: string | null, public: boolean, email?: string | null, firstName: string, lastName: string, networkRoles?: Array<NetworkRole> | null, image?: string | null, asset?: string | null, personificationId?: string | null, _created: number } | null } };

export type AcceptOrDeclineNetworkInvitationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: NetworkApplyAnswerInput;
}>;


export type AcceptOrDeclineNetworkInvitationMutation = { __typename?: 'Mutation', acceptOrDeclineNetworkInvitation: { __typename?: 'NetworkInvitation', networkId?: string | null, targetUserId?: string | null, type?: NetworkInvitationType | null, message?: string | null, status?: NetworkInvitationStatus | null, network?: { __typename?: 'Network', id: string, caption: string, description?: string | null, owner?: string | null, public?: boolean | null, open?: boolean | null, bugTrackerEnabled?: boolean | null, networkRoles?: Array<NetworkRole | null> | null, image?: string | null, asset?: string | null } | null, targetUser?: { __typename?: 'User', id: string, name: string, status?: string | null, public: boolean, email?: string | null, firstName: string, lastName: string, networkRoles?: Array<NetworkRole> | null, image?: string | null, asset?: string | null, personificationId?: string | null, _created: number } | null } };

export type CreateNetworkTokenInvitationMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  networkId: Scalars['ID']['input'];
  input: NetworkTokenInvitationInput;
}>;


export type CreateNetworkTokenInvitationMutation = { __typename?: 'Mutation', createNetworkTokenInvitation: { __typename?: 'NetworkTokenInvitation', networkId: string, userId: string, type: string, network: { __typename?: 'Network', id: string, caption: string, description?: string | null, owner?: string | null, public?: boolean | null, open?: boolean | null, bugTrackerEnabled?: boolean | null, networkRoles?: Array<NetworkRole | null> | null, image?: string | null, asset?: string | null }, user: { __typename?: 'User', id: string, name: string, status?: string | null, public: boolean, email?: string | null, firstName: string, lastName: string, networkRoles?: Array<NetworkRole> | null, image?: string | null, asset?: string | null, personificationId?: string | null, _created: number }, tokens: Array<{ __typename?: 'NetworkInvitationToken', email: string, token: string }> } };

export type JoinNetworkByTokenMutationVariables = Exact<{
  input: NetworkTokenInput;
}>;


export type JoinNetworkByTokenMutation = { __typename?: 'Mutation', joinNetworkByToken: { __typename?: 'Network', id: string, caption: string, description?: string | null, owner?: string | null, public?: boolean | null, open?: boolean | null, bugTrackerEnabled?: boolean | null, networkRoles?: Array<NetworkRole | null> | null, image?: string | null, asset?: string | null } };

export type ApplyNetworkWithTalentMutationVariables = Exact<{
  input?: InputMaybe<ApplyNetworkWithTalentInput>;
}>;


export type ApplyNetworkWithTalentMutation = { __typename?: 'Mutation', applyNetworkWithTalent: { __typename?: 'MessageResponse', message: string } };

export type InviteNetworkWithTalentMutationVariables = Exact<{
  input?: InputMaybe<InviteNetworkWithTalentInput>;
}>;


export type InviteNetworkWithTalentMutation = { __typename?: 'Mutation', inviteNetworkWithTalent: { __typename?: 'MessageResponse', message: string } };

export type TalentTransferRequestFragment = { __typename?: 'TalentTransferRequest', id: number, message: string, status: TalentTransferRequestStatus, statusStamp: string, object?: { __typename?: 'Talent', id: string, caption: string, image?: string | null, imageSource?: string | null, playlistCount?: number | null, public?: boolean | null, permissionLevel: PermissionLevel, personification?: boolean | null, rateCount?: number | null, tm_id?: number | null, profileId?: string | null, asset?: string | null, dataViews: Array<{ __typename?: 'TalentDataView', key: number, values: Array<number> }>, metas: { __typename?: 'TalentMeta', date: string, fieldPosition: TalentPosition, fifaCountry: string, firstName: string, lastName: string }, customMeta?: { __typename?: 'TalentCustomMeta', id?: string | null, foot?: string | null, club?: string | null, team?: string | null, height?: number | null, weight?: number | null, rolemodelid?: number | null, topskillsindexes?: Array<number | null> | null, status?: string | null, salutation?: Salutation | null } | null } | null, targetUser: { __typename?: 'User', id: string, name: string, status?: string | null, public: boolean, email?: string | null, firstName: string, lastName: string, networkRoles?: Array<NetworkRole> | null, image?: string | null, asset?: string | null, personificationId?: string | null, _created: number }, from: { __typename?: 'User', id: string, name: string, status?: string | null, public: boolean, email?: string | null, firstName: string, lastName: string, networkRoles?: Array<NetworkRole> | null, image?: string | null, asset?: string | null, personificationId?: string | null, _created: number } };

export type TalentFragment = { __typename?: 'Talent', id: string, caption: string, image?: string | null, imageSource?: string | null, playlistCount?: number | null, public?: boolean | null, permissionLevel: PermissionLevel, personification?: boolean | null, rateCount?: number | null, tm_id?: number | null, profileId?: string | null, asset?: string | null, dataViews: Array<{ __typename?: 'TalentDataView', key: number, values: Array<number> }>, metas: { __typename?: 'TalentMeta', date: string, fieldPosition: TalentPosition, fifaCountry: string, firstName: string, lastName: string }, customMeta?: { __typename?: 'TalentCustomMeta', id?: string | null, foot?: string | null, club?: string | null, team?: string | null, height?: number | null, weight?: number | null, rolemodelid?: number | null, topskillsindexes?: Array<number | null> | null, status?: string | null, salutation?: Salutation | null } | null };

export type SharedTalentFragment = { __typename?: 'Talent', id: string, caption: string, image?: string | null, imageSource?: string | null, playlistCount?: number | null, public?: boolean | null, permissionLevel: PermissionLevel, rateCount?: number | null, tm_id?: number | null, personification?: boolean | null, profileId?: string | null, dataViews: Array<{ __typename?: 'TalentDataView', key: number, values: Array<number> }>, metas: { __typename?: 'TalentMeta', date: string, fieldPosition: TalentPosition, fifaCountry: string, firstName: string, lastName: string }, customMeta?: { __typename?: 'TalentCustomMeta', id?: string | null, foot?: string | null, club?: string | null, team?: string | null, height?: number | null, weight?: number | null, rolemodelid?: number | null, topskillsindexes?: Array<number | null> | null, status?: string | null } | null };

export type VoteFragment = { __typename?: 'Vote', id: string, values: Array<number>, date: number };

export type TalentIdLayerFragment = { __typename?: 'Layer', name: string, dataViews: Array<{ __typename?: 'TalentDataView', key: number, values: Array<number> }> };

export type PerformanceVoteFragment = { __typename?: 'PerformanceVote', talentId: string, private?: Array<number> | null, public?: number | null, privateCount?: number | null, publicDetail?: Array<number> | null };

export type RoleModelIdsQueryVariables = Exact<{ [key: string]: never; }>;


export type RoleModelIdsQuery = { __typename?: 'Query', roleModelIds: Array<number> };

export type TalentQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
  talentId: Scalars['ID']['input'];
}>;


export type TalentQuery = { __typename?: 'Query', talent: { __typename?: 'Talent', id: string, caption: string, image?: string | null, imageSource?: string | null, playlistCount?: number | null, public?: boolean | null, permissionLevel: PermissionLevel, personification?: boolean | null, rateCount?: number | null, tm_id?: number | null, profileId?: string | null, asset?: string | null, dataViews: Array<{ __typename?: 'TalentDataView', key: number, values: Array<number> }>, metas: { __typename?: 'TalentMeta', date: string, fieldPosition: TalentPosition, fifaCountry: string, firstName: string, lastName: string }, customMeta?: { __typename?: 'TalentCustomMeta', id?: string | null, foot?: string | null, club?: string | null, team?: string | null, height?: number | null, weight?: number | null, rolemodelid?: number | null, topskillsindexes?: Array<number | null> | null, status?: string | null, salutation?: Salutation | null } | null } };

export type SharedTalentQueryVariables = Exact<{
  hash: Scalars['ID']['input'];
}>;


export type SharedTalentQuery = { __typename?: 'Query', sharedTalent: { __typename?: 'SharedTalentResponse', sharedRoleModel: boolean, talent: { __typename?: 'Talent', id: string, caption: string, image?: string | null, imageSource?: string | null, playlistCount?: number | null, public?: boolean | null, permissionLevel: PermissionLevel, rateCount?: number | null, tm_id?: number | null, personification?: boolean | null, profileId?: string | null, dataViews: Array<{ __typename?: 'TalentDataView', key: number, values: Array<number> }>, metas: { __typename?: 'TalentMeta', date: string, fieldPosition: TalentPosition, fifaCountry: string, firstName: string, lastName: string }, customMeta?: { __typename?: 'TalentCustomMeta', id?: string | null, foot?: string | null, club?: string | null, team?: string | null, height?: number | null, weight?: number | null, rolemodelid?: number | null, topskillsindexes?: Array<number | null> | null, status?: string | null } | null }, roleModel?: { __typename?: 'Talent', id: string, caption: string, image?: string | null, imageSource?: string | null, playlistCount?: number | null, public?: boolean | null, permissionLevel: PermissionLevel, rateCount?: number | null, tm_id?: number | null, personification?: boolean | null, profileId?: string | null, dataViews: Array<{ __typename?: 'TalentDataView', key: number, values: Array<number> }>, metas: { __typename?: 'TalentMeta', date: string, fieldPosition: TalentPosition, fifaCountry: string, firstName: string, lastName: string }, customMeta?: { __typename?: 'TalentCustomMeta', id?: string | null, foot?: string | null, club?: string | null, team?: string | null, height?: number | null, weight?: number | null, rolemodelid?: number | null, topskillsindexes?: Array<number | null> | null, status?: string | null } | null } | null, talentIds: Array<{ __typename?: 'SharedTalentId', key: string, dataViews: Array<{ __typename?: 'TalentDataView', key: number, values: Array<number> }> }>, talentHistory: Array<{ __typename?: 'HistoryItem', date: string, data: string, id: string, type: string }>, certificates: Array<{ __typename?: 'Certificate', id: string, club: string, talentId: string, image?: string | null, caption?: string | null, firstName: string, player?: string | null, birthday: string, lastName: string, talentClass?: number | null, vote: Array<number>, camp: { __typename?: 'Camp', caption?: string | null, campType?: string | null, end?: string | null, start?: string | null } }> } };

export type ListMyPersonificationsQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
  start?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ListMyPersonificationsQuery = { __typename?: 'Query', listMyPersonifications: { __typename?: 'NetworkTalentsResponse', collection: Array<{ __typename?: 'Talent', id: string, caption: string, image?: string | null, imageSource?: string | null, playlistCount?: number | null, public?: boolean | null, permissionLevel: PermissionLevel, personification?: boolean | null, rateCount?: number | null, tm_id?: number | null, profileId?: string | null, asset?: string | null, dataViews: Array<{ __typename?: 'TalentDataView', key: number, values: Array<number> }>, metas: { __typename?: 'TalentMeta', date: string, fieldPosition: TalentPosition, fifaCountry: string, firstName: string, lastName: string }, customMeta?: { __typename?: 'TalentCustomMeta', id?: string | null, foot?: string | null, club?: string | null, team?: string | null, height?: number | null, weight?: number | null, rolemodelid?: number | null, topskillsindexes?: Array<number | null> | null, status?: string | null, salutation?: Salutation | null } | null }>, meta: { __typename?: 'Meta', range?: { __typename?: 'Range', from: number, to: number, total: number } | null, sortOptions?: Array<{ __typename?: 'MapEntry', key: string, value: string }> | null } } };

export type UserPersonificationQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
  start?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type UserPersonificationQuery = { __typename?: 'Query', userPersonification: { __typename?: 'NetworkTalentsResponse', collection: Array<{ __typename?: 'Talent', id: string, caption: string, image?: string | null, imageSource?: string | null, playlistCount?: number | null, public?: boolean | null, permissionLevel: PermissionLevel, personification?: boolean | null, rateCount?: number | null, tm_id?: number | null, profileId?: string | null, asset?: string | null, dataViews: Array<{ __typename?: 'TalentDataView', key: number, values: Array<number> }>, metas: { __typename?: 'TalentMeta', date: string, fieldPosition: TalentPosition, fifaCountry: string, firstName: string, lastName: string }, customMeta?: { __typename?: 'TalentCustomMeta', id?: string | null, foot?: string | null, club?: string | null, team?: string | null, height?: number | null, weight?: number | null, rolemodelid?: number | null, topskillsindexes?: Array<number | null> | null, status?: string | null, salutation?: Salutation | null } | null }>, meta: { __typename?: 'Meta', range?: { __typename?: 'Range', from: number, to: number, total: number } | null, sortOptions?: Array<{ __typename?: 'MapEntry', key: string, value: string }> | null } } };

export type ListMyTalentsQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
  start?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ListMyTalentsQuery = { __typename?: 'Query', listMyTalents: { __typename?: 'NetworkTalentsResponse', collection: Array<{ __typename?: 'Talent', id: string, caption: string, image?: string | null, imageSource?: string | null, playlistCount?: number | null, public?: boolean | null, permissionLevel: PermissionLevel, personification?: boolean | null, rateCount?: number | null, tm_id?: number | null, profileId?: string | null, asset?: string | null, dataViews: Array<{ __typename?: 'TalentDataView', key: number, values: Array<number> }>, metas: { __typename?: 'TalentMeta', date: string, fieldPosition: TalentPosition, fifaCountry: string, firstName: string, lastName: string }, customMeta?: { __typename?: 'TalentCustomMeta', id?: string | null, foot?: string | null, club?: string | null, team?: string | null, height?: number | null, weight?: number | null, rolemodelid?: number | null, topskillsindexes?: Array<number | null> | null, status?: string | null, salutation?: Salutation | null } | null }>, meta: { __typename?: 'Meta', range?: { __typename?: 'Range', from: number, to: number, total: number } | null, sortOptions?: Array<{ __typename?: 'MapEntry', key: string, value: string }> | null } } };

export type TalentClassQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type TalentClassQuery = { __typename?: 'Query', talentClass: { __typename?: 'TalentClass', id: string, dataViews: Array<{ __typename?: 'TalentClassDataView', id: string, chartType: ChartType, withGroupLabels?: boolean | null, withLabelHover?: boolean | null, backgroundColor?: string | null, borderColor?: string | null, textColor?: string | null, caption: string, voteScalarGroups?: Array<{ __typename?: 'VoteScalarGroup', scalars: Array<{ __typename?: 'Scalar', caption: string, formula: boolean, offset: number }> }> | null }> } };

export type SuggestTalentQueryVariables = Exact<{
  q: Scalars['String']['input'];
}>;


export type SuggestTalentQuery = { __typename?: 'Query', suggestTalent: Array<{ __typename?: 'SuggestUser', name: string }> };

export type SearchTalentQueryVariables = Exact<{
  query: Scalars['String']['input'];
  sort?: InputMaybe<Scalars['String']['input']>;
  ageFrom?: InputMaybe<Scalars['Int']['input']>;
  ageTo?: InputMaybe<Scalars['Int']['input']>;
  classId?: InputMaybe<Scalars['String']['input']>;
  fieldPosition?: InputMaybe<Scalars['String']['input']>;
  fifaCountry?: InputMaybe<Scalars['String']['input']>;
  yearFrom?: InputMaybe<Scalars['Int']['input']>;
  yearTo?: InputMaybe<Scalars['Int']['input']>;
  networkId?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SearchTalentQuery = { __typename?: 'Query', searchTalent: { __typename?: 'SearchTalent', meta: { __typename?: 'Meta', range?: { __typename?: 'Range', from: number, to: number, total: number } | null, sortOptions?: Array<{ __typename?: 'MapEntry', key: string, value: string }> | null }, collection: Array<{ __typename?: 'Talent', id: string, caption: string, image?: string | null, imageSource?: string | null, playlistCount?: number | null, public?: boolean | null, permissionLevel: PermissionLevel, personification?: boolean | null, rateCount?: number | null, tm_id?: number | null, profileId?: string | null, asset?: string | null, dataViews: Array<{ __typename?: 'TalentDataView', key: number, values: Array<number> }>, metas: { __typename?: 'TalentMeta', date: string, fieldPosition: TalentPosition, fifaCountry: string, firstName: string, lastName: string }, customMeta?: { __typename?: 'TalentCustomMeta', id?: string | null, foot?: string | null, club?: string | null, team?: string | null, height?: number | null, weight?: number | null, rolemodelid?: number | null, topskillsindexes?: Array<number | null> | null, status?: string | null, salutation?: Salutation | null } | null }> } };

export type TalentJoinMarketplaceMutationVariables = Exact<{ [key: string]: never; }>;


export type TalentJoinMarketplaceMutation = { __typename?: 'Mutation', talentJoinMarketplace: { __typename?: 'Network', id: string, caption: string, description?: string | null, owner?: string | null, public?: boolean | null, open?: boolean | null, bugTrackerEnabled?: boolean | null, networkRoles?: Array<NetworkRole | null> | null, image?: string | null, asset?: string | null } };

export type CreateTalentMutationVariables = Exact<{
  classId: Scalars['String']['input'];
  input: TalentInput;
}>;


export type CreateTalentMutation = { __typename?: 'Mutation', saveTalent: { __typename?: 'Talent', id: string, caption: string, image?: string | null, imageSource?: string | null, playlistCount?: number | null, public?: boolean | null, permissionLevel: PermissionLevel, personification?: boolean | null, rateCount?: number | null, tm_id?: number | null, profileId?: string | null, asset?: string | null, dataViews: Array<{ __typename?: 'TalentDataView', key: number, values: Array<number> }>, metas: { __typename?: 'TalentMeta', date: string, fieldPosition: TalentPosition, fifaCountry: string, firstName: string, lastName: string }, customMeta?: { __typename?: 'TalentCustomMeta', id?: string | null, foot?: string | null, club?: string | null, team?: string | null, height?: number | null, weight?: number | null, rolemodelid?: number | null, topskillsindexes?: Array<number | null> | null, status?: string | null, salutation?: Salutation | null } | null } };

export type UpdateTalentMutationVariables = Exact<{
  input: TalentInput;
  talentId: Scalars['String']['input'];
}>;


export type UpdateTalentMutation = { __typename?: 'Mutation', saveTalent: { __typename?: 'Talent', id: string, caption: string, image?: string | null, imageSource?: string | null, playlistCount?: number | null, public?: boolean | null, permissionLevel: PermissionLevel, personification?: boolean | null, rateCount?: number | null, tm_id?: number | null, profileId?: string | null, asset?: string | null, dataViews: Array<{ __typename?: 'TalentDataView', key: number, values: Array<number> }>, metas: { __typename?: 'TalentMeta', date: string, fieldPosition: TalentPosition, fifaCountry: string, firstName: string, lastName: string }, customMeta?: { __typename?: 'TalentCustomMeta', id?: string | null, foot?: string | null, club?: string | null, team?: string | null, height?: number | null, weight?: number | null, rolemodelid?: number | null, topskillsindexes?: Array<number | null> | null, status?: string | null, salutation?: Salutation | null } | null } };

export type TalentLinkImageMutationVariables = Exact<{
  url: Scalars['String']['input'];
  talentId: Scalars['String']['input'];
}>;


export type TalentLinkImageMutation = { __typename?: 'Mutation', talentLinkImage: { __typename?: 'Talent', id: string, caption: string, image?: string | null, imageSource?: string | null, playlistCount?: number | null, public?: boolean | null, permissionLevel: PermissionLevel, personification?: boolean | null, rateCount?: number | null, tm_id?: number | null, profileId?: string | null, asset?: string | null, dataViews: Array<{ __typename?: 'TalentDataView', key: number, values: Array<number> }>, metas: { __typename?: 'TalentMeta', date: string, fieldPosition: TalentPosition, fifaCountry: string, firstName: string, lastName: string }, customMeta?: { __typename?: 'TalentCustomMeta', id?: string | null, foot?: string | null, club?: string | null, team?: string | null, height?: number | null, weight?: number | null, rolemodelid?: number | null, topskillsindexes?: Array<number | null> | null, status?: string | null, salutation?: Salutation | null } | null } };

export type TalentUnlinkImageMutationVariables = Exact<{
  url: Scalars['String']['input'];
  talentId: Scalars['String']['input'];
}>;


export type TalentUnlinkImageMutation = { __typename?: 'Mutation', talentUnlinkImage: { __typename?: 'Talent', id: string, caption: string, image?: string | null, imageSource?: string | null, playlistCount?: number | null, public?: boolean | null, permissionLevel: PermissionLevel, personification?: boolean | null, rateCount?: number | null, tm_id?: number | null, profileId?: string | null, asset?: string | null, dataViews: Array<{ __typename?: 'TalentDataView', key: number, values: Array<number> }>, metas: { __typename?: 'TalentMeta', date: string, fieldPosition: TalentPosition, fifaCountry: string, firstName: string, lastName: string }, customMeta?: { __typename?: 'TalentCustomMeta', id?: string | null, foot?: string | null, club?: string | null, team?: string | null, height?: number | null, weight?: number | null, rolemodelid?: number | null, topskillsindexes?: Array<number | null> | null, status?: string | null, salutation?: Salutation | null } | null } };

export type CreateTalentCustomMetaMutationVariables = Exact<{
  input: TalentCustomMetaInput;
  talentId: Scalars['String']['input'];
}>;


export type CreateTalentCustomMetaMutation = { __typename?: 'Mutation', saveTalentCustomMeta: { __typename?: 'TalentCustomMeta', id?: string | null, foot?: string | null, club?: string | null, team?: string | null, height?: number | null, weight?: number | null, status?: string | null } };

export type UpdateTalentCustomMetaMutationVariables = Exact<{
  input: TalentCustomMetaInput;
  talentId: Scalars['String']['input'];
  metaDataId: Scalars['String']['input'];
}>;


export type UpdateTalentCustomMetaMutation = { __typename?: 'Mutation', saveTalentCustomMeta: { __typename?: 'TalentCustomMeta', id?: string | null, foot?: string | null, club?: string | null, team?: string | null, height?: number | null, weight?: number | null, status?: string | null } };

export type TalentLinkUserMutationVariables = Exact<{
  input: LinkUserInput;
  talentId: Scalars['String']['input'];
}>;


export type TalentLinkUserMutation = { __typename?: 'Mutation', talentLinkUser: { __typename?: 'Talent', id: string, caption: string, image?: string | null, imageSource?: string | null, playlistCount?: number | null, public?: boolean | null, permissionLevel: PermissionLevel, personification?: boolean | null, rateCount?: number | null, tm_id?: number | null, profileId?: string | null, asset?: string | null, dataViews: Array<{ __typename?: 'TalentDataView', key: number, values: Array<number> }>, metas: { __typename?: 'TalentMeta', date: string, fieldPosition: TalentPosition, fifaCountry: string, firstName: string, lastName: string }, customMeta?: { __typename?: 'TalentCustomMeta', id?: string | null, foot?: string | null, club?: string | null, team?: string | null, height?: number | null, weight?: number | null, rolemodelid?: number | null, topskillsindexes?: Array<number | null> | null, status?: string | null, salutation?: Salutation | null } | null } };

export type DeleteTalentMutationVariables = Exact<{
  talentId: Scalars['ID']['input'];
}>;


export type DeleteTalentMutation = { __typename?: 'Mutation', deleteTalent?: boolean | null };

export type TalentLatestVoteQueryVariables = Exact<{
  talentId: Scalars['ID']['input'];
  type?: InputMaybe<VoteType>;
}>;


export type TalentLatestVoteQuery = { __typename?: 'Query', talentLatestVote?: { __typename?: 'Vote', id: string, values: Array<number>, date: number } | null };

export type VoteMutationVariables = Exact<{
  talentId: Scalars['ID']['input'];
  input: VoteInput;
}>;


export type VoteMutation = { __typename?: 'Mutation', vote: { __typename?: 'Vote', id: string, values: Array<number>, date: number } };

export type UpdateVoteMutationVariables = Exact<{
  voteId: Scalars['ID']['input'];
  input: VoteInput;
}>;


export type UpdateVoteMutation = { __typename?: 'Mutation', updateVote: { __typename?: 'Vote', id: string, values: Array<number>, date: number } };

export type SimilarQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['String']['input']>;
  talentId?: InputMaybe<Scalars['String']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SimilarQuery = { __typename?: 'Query', similar: { __typename?: 'NetworkTalentsResponse', collection: Array<{ __typename?: 'Talent', id: string, caption: string, image?: string | null, imageSource?: string | null, playlistCount?: number | null, public?: boolean | null, permissionLevel: PermissionLevel, personification?: boolean | null, rateCount?: number | null, tm_id?: number | null, profileId?: string | null, asset?: string | null, dataViews: Array<{ __typename?: 'TalentDataView', key: number, values: Array<number> }>, metas: { __typename?: 'TalentMeta', date: string, fieldPosition: TalentPosition, fifaCountry: string, firstName: string, lastName: string }, customMeta?: { __typename?: 'TalentCustomMeta', id?: string | null, foot?: string | null, club?: string | null, team?: string | null, height?: number | null, weight?: number | null, rolemodelid?: number | null, topskillsindexes?: Array<number | null> | null, status?: string | null, salutation?: Salutation | null } | null }>, meta: { __typename?: 'Meta', range?: { __typename?: 'Range', from: number, to: number, total: number } | null, sortOptions?: Array<{ __typename?: 'MapEntry', key: string, value: string }> | null } } };

export type SimilarNetworkQueryVariables = Exact<{
  queryString?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['ID']['input'];
  networkId: Scalars['ID']['input'];
  start?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SimilarNetworkQuery = { __typename?: 'Query', similarNetwork: { __typename?: 'NetworkTalentsResponse', collection: Array<{ __typename?: 'Talent', id: string, caption: string, image?: string | null, imageSource?: string | null, playlistCount?: number | null, public?: boolean | null, permissionLevel: PermissionLevel, personification?: boolean | null, rateCount?: number | null, tm_id?: number | null, profileId?: string | null, asset?: string | null, dataViews: Array<{ __typename?: 'TalentDataView', key: number, values: Array<number> }>, metas: { __typename?: 'TalentMeta', date: string, fieldPosition: TalentPosition, fifaCountry: string, firstName: string, lastName: string }, customMeta?: { __typename?: 'TalentCustomMeta', id?: string | null, foot?: string | null, club?: string | null, team?: string | null, height?: number | null, weight?: number | null, rolemodelid?: number | null, topskillsindexes?: Array<number | null> | null, status?: string | null, salutation?: Salutation | null } | null }>, meta: { __typename?: 'Meta', range?: { __typename?: 'Range', from: number, to: number, total: number } | null, sortOptions?: Array<{ __typename?: 'MapEntry', key: string, value: string }> | null } } };

export type SimilarNetworkV2QueryVariables = Exact<{
  talentId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
  networkId: Scalars['ID']['input'];
  talentClass: Scalars['String']['input'];
  start?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SimilarNetworkV2Query = { __typename?: 'Query', similarNetworkV2: { __typename?: 'NetworkTalentsResponse', collection: Array<{ __typename?: 'Talent', id: string, caption: string, image?: string | null, imageSource?: string | null, playlistCount?: number | null, public?: boolean | null, permissionLevel: PermissionLevel, personification?: boolean | null, rateCount?: number | null, tm_id?: number | null, profileId?: string | null, asset?: string | null, dataViews: Array<{ __typename?: 'TalentDataView', key: number, values: Array<number> }>, metas: { __typename?: 'TalentMeta', date: string, fieldPosition: TalentPosition, fifaCountry: string, firstName: string, lastName: string }, customMeta?: { __typename?: 'TalentCustomMeta', id?: string | null, foot?: string | null, club?: string | null, team?: string | null, height?: number | null, weight?: number | null, rolemodelid?: number | null, topskillsindexes?: Array<number | null> | null, status?: string | null, salutation?: Salutation | null } | null }>, meta: { __typename?: 'Meta', range?: { __typename?: 'Range', from: number, to: number, total: number } | null, sortOptions?: Array<{ __typename?: 'MapEntry', key: string, value: string }> | null } } };

export type TalentLayerAnimationQueryVariables = Exact<{
  talentId: Scalars['ID']['input'];
}>;


export type TalentLayerAnimationQuery = { __typename?: 'Query', talentLayerAnimation?: Array<{ __typename?: 'AnimationLayer', label: string, total?: number | null, dataViews: Array<{ __typename?: 'TalentDataView', key: number, values: Array<number> }> }> | null };

export type MyTalentLayerQueryVariables = Exact<{
  userId: Scalars['String']['input'];
  talentId: Scalars['ID']['input'];
  layerParams?: InputMaybe<Scalars['String']['input']>;
}>;


export type MyTalentLayerQuery = { __typename?: 'Query', talentLayer?: Array<{ __typename?: 'Layer', name: string, dataViews: Array<{ __typename?: 'TalentDataView', key: number, values: Array<number> }> }> | null };

export type GlobalVoteForDateRangeQueryVariables = Exact<{
  talentId: Scalars['ID']['input'];
  startDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
}>;


export type GlobalVoteForDateRangeQuery = { __typename?: 'Query', globalVoteForDateRange: Array<{ __typename?: 'TalentDataView', key: number, values: Array<number> }> };

export type ShareTalentMutationVariables = Exact<{
  input: ShareTalentInput;
}>;


export type ShareTalentMutation = { __typename?: 'Mutation', shareTalent: { __typename?: 'ShareTalentResponse', publicToken: string } };

export type AddRoleModelMutationVariables = Exact<{
  input: RoleModelInput;
}>;


export type AddRoleModelMutation = { __typename?: 'Mutation', addRoleModel: { __typename?: 'MessageResponse', message: string } };

export type TransferTalentRequestMutationVariables = Exact<{
  input: TransferTalentRequestInput;
}>;


export type TransferTalentRequestMutation = { __typename?: 'Mutation', transferTalentRequest: { __typename?: 'TalentTransferRequest', id: number, message: string, status: TalentTransferRequestStatus, statusStamp: string, object?: { __typename?: 'Talent', id: string, caption: string, image?: string | null, imageSource?: string | null, playlistCount?: number | null, public?: boolean | null, permissionLevel: PermissionLevel, personification?: boolean | null, rateCount?: number | null, tm_id?: number | null, profileId?: string | null, asset?: string | null, dataViews: Array<{ __typename?: 'TalentDataView', key: number, values: Array<number> }>, metas: { __typename?: 'TalentMeta', date: string, fieldPosition: TalentPosition, fifaCountry: string, firstName: string, lastName: string }, customMeta?: { __typename?: 'TalentCustomMeta', id?: string | null, foot?: string | null, club?: string | null, team?: string | null, height?: number | null, weight?: number | null, rolemodelid?: number | null, topskillsindexes?: Array<number | null> | null, status?: string | null, salutation?: Salutation | null } | null } | null, targetUser: { __typename?: 'User', id: string, name: string, status?: string | null, public: boolean, email?: string | null, firstName: string, lastName: string, networkRoles?: Array<NetworkRole> | null, image?: string | null, asset?: string | null, personificationId?: string | null, _created: number }, from: { __typename?: 'User', id: string, name: string, status?: string | null, public: boolean, email?: string | null, firstName: string, lastName: string, networkRoles?: Array<NetworkRole> | null, image?: string | null, asset?: string | null, personificationId?: string | null, _created: number } } };

export type EditTransferTalentRequestMutationVariables = Exact<{
  transferId: Scalars['ID']['input'];
  input: EditTransferTalentRequestInput;
}>;


export type EditTransferTalentRequestMutation = { __typename?: 'Mutation', editTransferTalentRequest: { __typename?: 'TalentTransferRequest', id: number, message: string, status: TalentTransferRequestStatus, statusStamp: string, object?: { __typename?: 'Talent', id: string, caption: string, image?: string | null, imageSource?: string | null, playlistCount?: number | null, public?: boolean | null, permissionLevel: PermissionLevel, personification?: boolean | null, rateCount?: number | null, tm_id?: number | null, profileId?: string | null, asset?: string | null, dataViews: Array<{ __typename?: 'TalentDataView', key: number, values: Array<number> }>, metas: { __typename?: 'TalentMeta', date: string, fieldPosition: TalentPosition, fifaCountry: string, firstName: string, lastName: string }, customMeta?: { __typename?: 'TalentCustomMeta', id?: string | null, foot?: string | null, club?: string | null, team?: string | null, height?: number | null, weight?: number | null, rolemodelid?: number | null, topskillsindexes?: Array<number | null> | null, status?: string | null, salutation?: Salutation | null } | null } | null, targetUser: { __typename?: 'User', id: string, name: string, status?: string | null, public: boolean, email?: string | null, firstName: string, lastName: string, networkRoles?: Array<NetworkRole> | null, image?: string | null, asset?: string | null, personificationId?: string | null, _created: number }, from: { __typename?: 'User', id: string, name: string, status?: string | null, public: boolean, email?: string | null, firstName: string, lastName: string, networkRoles?: Array<NetworkRole> | null, image?: string | null, asset?: string | null, personificationId?: string | null, _created: number } } };

export type TransferTalentRequestsQueryVariables = Exact<{ [key: string]: never; }>;


export type TransferTalentRequestsQuery = { __typename?: 'Query', transferTalentRequests: { __typename?: 'TalentTransferRequests', collection: Array<{ __typename?: 'TalentTransferRequest', id: number, message: string, status: TalentTransferRequestStatus, statusStamp: string, object?: { __typename?: 'Talent', id: string, caption: string, image?: string | null, imageSource?: string | null, playlistCount?: number | null, public?: boolean | null, permissionLevel: PermissionLevel, personification?: boolean | null, rateCount?: number | null, tm_id?: number | null, profileId?: string | null, asset?: string | null, dataViews: Array<{ __typename?: 'TalentDataView', key: number, values: Array<number> }>, metas: { __typename?: 'TalentMeta', date: string, fieldPosition: TalentPosition, fifaCountry: string, firstName: string, lastName: string }, customMeta?: { __typename?: 'TalentCustomMeta', id?: string | null, foot?: string | null, club?: string | null, team?: string | null, height?: number | null, weight?: number | null, rolemodelid?: number | null, topskillsindexes?: Array<number | null> | null, status?: string | null, salutation?: Salutation | null } | null } | null, targetUser: { __typename?: 'User', id: string, name: string, status?: string | null, public: boolean, email?: string | null, firstName: string, lastName: string, networkRoles?: Array<NetworkRole> | null, image?: string | null, asset?: string | null, personificationId?: string | null, _created: number }, from: { __typename?: 'User', id: string, name: string, status?: string | null, public: boolean, email?: string | null, firstName: string, lastName: string, networkRoles?: Array<NetworkRole> | null, image?: string | null, asset?: string | null, personificationId?: string | null, _created: number } }> } };

export type SavePerformanceVoteMutationVariables = Exact<{
  input: PerformanceVoteInput;
}>;


export type SavePerformanceVoteMutation = { __typename?: 'Mutation', savePerformanceVote: { __typename?: 'PerformanceVote', talentId: string, private?: Array<number> | null, public?: number | null, privateCount?: number | null, publicDetail?: Array<number> | null } };

export type PerformanceVoteQueryVariables = Exact<{
  talentId: Scalars['ID']['input'];
  network?: InputMaybe<Scalars['String']['input']>;
}>;


export type PerformanceVoteQuery = { __typename?: 'Query', performanceVote: { __typename?: 'PerformanceVote', talentId: string, private?: Array<number> | null, public?: number | null, privateCount?: number | null, publicDetail?: Array<number> | null } };

export type ShortVoteMutationVariables = Exact<{
  talentId: Scalars['ID']['input'];
  input: VoteInput;
}>;


export type ShortVoteMutation = { __typename?: 'Mutation', shortVote: { __typename?: 'Vote', id: string, values: Array<number>, date: number } };

export type CertificatesQueryVariables = Exact<{
  talentId: Scalars['ID']['input'];
}>;


export type CertificatesQuery = { __typename?: 'Query', certificates: Array<{ __typename?: 'Certificate', id: string, club: string, talentId: string, image?: string | null, caption?: string | null, firstName: string, player?: string | null, birthday: string, lastName: string, talentClass?: number | null, vote: Array<number>, shareKey?: string | null, renderPayload?: string | null, camp: { __typename?: 'Camp', caption?: string | null, campType?: string | null, end?: string | null, start?: string | null } }> };

export type CreateShanghaiTalentMutationVariables = Exact<{
  talentId: Scalars['ID']['input'];
}>;


export type CreateShanghaiTalentMutation = { __typename?: 'Mutation', createShanghaiTalent: Array<string> };

export type ShanghaiTalentQueryVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type ShanghaiTalentQuery = { __typename?: 'Query', shanghaiTalent?: { __typename?: 'Talent', id: string, caption: string, image?: string | null, imageSource?: string | null, playlistCount?: number | null, public?: boolean | null, permissionLevel: PermissionLevel, personification?: boolean | null, rateCount?: number | null, tm_id?: number | null, profileId?: string | null, asset?: string | null, dataViews: Array<{ __typename?: 'TalentDataView', key: number, values: Array<number> }>, metas: { __typename?: 'TalentMeta', date: string, fieldPosition: TalentPosition, fifaCountry: string, firstName: string, lastName: string }, customMeta?: { __typename?: 'TalentCustomMeta', id?: string | null, foot?: string | null, club?: string | null, team?: string | null, height?: number | null, weight?: number | null, rolemodelid?: number | null, topskillsindexes?: Array<number | null> | null, status?: string | null, salutation?: Salutation | null } | null } | null };

export type TalentHistoryQueryVariables = Exact<{
  talentId: Scalars['ID']['input'];
}>;


export type TalentHistoryQuery = { __typename?: 'Query', talentHistory: Array<{ __typename?: 'HistoryItem', date: string, data: string, id: string, type: string }> };

export type CreateHistoryItemMutationVariables = Exact<{
  input: HistoryItemInput;
}>;


export type CreateHistoryItemMutation = { __typename?: 'Mutation', createHistoryItem: { __typename?: 'HistoryItem', date: string, data: string, id: string, type: string } };

export type EditHistoryItemMutationVariables = Exact<{
  input: HistoryItemInput;
}>;


export type EditHistoryItemMutation = { __typename?: 'Mutation', editHistoryItem: { __typename?: 'HistoryItem', date: string, data: string, id: string, type: string } };

export type DeleteHistoryItemMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteHistoryItemMutation = { __typename?: 'Mutation', deleteHistoryItem?: boolean | null };

export type UserFragment = { __typename?: 'User', id: string, name: string, status?: string | null, public: boolean, email?: string | null, firstName: string, lastName: string, networkRoles?: Array<NetworkRole> | null, image?: string | null, asset?: string | null, personificationId?: string | null, _created: number };

export type UserMetadataFragment = { __typename?: 'UserMetaData', username: string, aboutMe?: string | null, ageCategory?: Array<AgeCategory | null> | null, birthdate?: string | null, city?: string | null, club?: string | null, country?: string | null, experience?: Array<Experience | null> | null, phone?: string | null, street?: string | null, team?: string | null, userType?: Array<UserType | null> | null, year?: number | null, zip?: string | null, activitiesLastViewed?: string | null, status?: string | null, salutation?: Salutation | null, behavior?: { __typename?: 'UserBehavior', termsAcceptedAt?: string | null, termsVersionAccepted?: number | null, onboardingDone?: Array<string> | null, preferredPerformanceView?: string | null } | null };

export type ActivityFragment = { __typename?: 'Activity', date: string, id: string, type: string, data: string, targetUserId: string, from: { __typename?: 'User', id: string, name: string, status?: string | null, public: boolean, email?: string | null, firstName: string, lastName: string, networkRoles?: Array<NetworkRole> | null, image?: string | null, asset?: string | null, personificationId?: string | null, _created: number } };

export type UserMetadataResponseFragment = { __typename?: 'UserMetaDataResponse', user?: { __typename?: 'CurrentUser', _created: number, data?: { __typename?: 'UserMetaData', username: string, aboutMe?: string | null, ageCategory?: Array<AgeCategory | null> | null, birthdate?: string | null, city?: string | null, club?: string | null, country?: string | null, experience?: Array<Experience | null> | null, phone?: string | null, street?: string | null, team?: string | null, userType?: Array<UserType | null> | null, year?: number | null, zip?: string | null, activitiesLastViewed?: string | null, status?: string | null, salutation?: Salutation | null, behavior?: { __typename?: 'UserBehavior', termsAcceptedAt?: string | null, termsVersionAccepted?: number | null, onboardingDone?: Array<string> | null, preferredPerformanceView?: string | null } | null } | null } | null };

export type UserMetadataSaveResponseFragment = { __typename?: 'UserMetaDataSaveResponse', current_user?: { __typename?: 'CurrentUser', _created: number, data?: { __typename?: 'UserMetaData', username: string, aboutMe?: string | null, ageCategory?: Array<AgeCategory | null> | null, birthdate?: string | null, city?: string | null, club?: string | null, country?: string | null, experience?: Array<Experience | null> | null, phone?: string | null, street?: string | null, team?: string | null, userType?: Array<UserType | null> | null, year?: number | null, zip?: string | null, activitiesLastViewed?: string | null, status?: string | null, salutation?: Salutation | null, behavior?: { __typename?: 'UserBehavior', termsAcceptedAt?: string | null, termsVersionAccepted?: number | null, onboardingDone?: Array<string> | null, preferredPerformanceView?: string | null } | null } | null } | null };

export type MetaFragment = { __typename?: 'Meta', range?: { __typename?: 'Range', from: number, to: number, total: number } | null, sortOptions?: Array<{ __typename?: 'MapEntry', key: string, value: string }> | null };

export type RecoverUsernameMutationVariables = Exact<{
  input: RecoverUsernameInput;
}>;


export type RecoverUsernameMutation = { __typename?: 'Mutation', recoverUsername: { __typename?: 'UserRecoverCollection', collection: Array<{ __typename?: 'UserRecover', id: string, name: string, firstName: string, lastName: string }>, meta: { __typename?: 'Meta', range?: { __typename?: 'Range', from: number, to: number, total: number } | null, sortOptions?: Array<{ __typename?: 'MapEntry', key: string, value: string }> | null } } };

export type RequestPasswordChangeMutationVariables = Exact<{
  input: RequestPasswordChangeInput;
}>;


export type RequestPasswordChangeMutation = { __typename?: 'Mutation', requestPasswordChange: { __typename?: 'RequestPasswordChangeResponse', token: string, user: { __typename?: 'User', id: string, name: string, firstName: string, lastName: string, email?: string | null } } };

export type CreateUserMetaDataMutationVariables = Exact<{
  input: UserMetaDataInput;
}>;


export type CreateUserMetaDataMutation = { __typename?: 'Mutation', saveUserMetaData: { __typename?: 'UserMetaDataSaveResponse', current_user?: { __typename?: 'CurrentUser', _created: number, data?: { __typename?: 'UserMetaData', username: string, aboutMe?: string | null, ageCategory?: Array<AgeCategory | null> | null, birthdate?: string | null, city?: string | null, club?: string | null, country?: string | null, experience?: Array<Experience | null> | null, phone?: string | null, street?: string | null, team?: string | null, userType?: Array<UserType | null> | null, year?: number | null, zip?: string | null, activitiesLastViewed?: string | null, status?: string | null, salutation?: Salutation | null, behavior?: { __typename?: 'UserBehavior', termsAcceptedAt?: string | null, termsVersionAccepted?: number | null, onboardingDone?: Array<string> | null, preferredPerformanceView?: string | null } | null } | null } | null } };

export type UpdateUserMetaDataMutationVariables = Exact<{
  input: UserMetaDataInput;
}>;


export type UpdateUserMetaDataMutation = { __typename?: 'Mutation', saveUserMetaData: { __typename?: 'UserMetaDataSaveResponse', current_user?: { __typename?: 'CurrentUser', _created: number, data?: { __typename?: 'UserMetaData', username: string, aboutMe?: string | null, ageCategory?: Array<AgeCategory | null> | null, birthdate?: string | null, city?: string | null, club?: string | null, country?: string | null, experience?: Array<Experience | null> | null, phone?: string | null, street?: string | null, team?: string | null, userType?: Array<UserType | null> | null, year?: number | null, zip?: string | null, activitiesLastViewed?: string | null, status?: string | null, salutation?: Salutation | null, behavior?: { __typename?: 'UserBehavior', termsAcceptedAt?: string | null, termsVersionAccepted?: number | null, onboardingDone?: Array<string> | null, preferredPerformanceView?: string | null } | null } | null } | null } };

export type UserMetaDataQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type UserMetaDataQuery = { __typename?: 'Query', userMetaData?: { __typename?: 'UserMetaDataResponse', user?: { __typename?: 'CurrentUser', _created: number, data?: { __typename?: 'UserMetaData', username: string, aboutMe?: string | null, ageCategory?: Array<AgeCategory | null> | null, birthdate?: string | null, city?: string | null, club?: string | null, country?: string | null, experience?: Array<Experience | null> | null, phone?: string | null, street?: string | null, team?: string | null, userType?: Array<UserType | null> | null, year?: number | null, zip?: string | null, activitiesLastViewed?: string | null, status?: string | null, salutation?: Salutation | null, behavior?: { __typename?: 'UserBehavior', termsAcceptedAt?: string | null, termsVersionAccepted?: number | null, onboardingDone?: Array<string> | null, preferredPerformanceView?: string | null } | null } | null } | null } | null };

export type SuggestUserQueryVariables = Exact<{
  q: Scalars['String']['input'];
}>;


export type SuggestUserQuery = { __typename?: 'Query', suggestUser: Array<{ __typename?: 'SuggestUser', name: string }> };

export type SearchUserQueryVariables = Exact<{
  query: Scalars['String']['input'];
  meId: Scalars['String']['input'];
  networkId: Scalars['String']['input'];
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SearchUserQuery = { __typename?: 'Query', searchUser: { __typename?: 'SearchUserCollection', meta: { __typename?: 'Meta', range?: { __typename?: 'Range', from: number, to: number, total: number } | null, sortOptions?: Array<{ __typename?: 'MapEntry', key: string, value: string }> | null }, collection: Array<{ __typename?: 'User', id: string, name: string, status?: string | null, public: boolean, email?: string | null, firstName: string, lastName: string, networkRoles?: Array<NetworkRole> | null, image?: string | null, asset?: string | null, personificationId?: string | null, _created: number }> } };

export type UpdateUserMutationVariables = Exact<{
  input: UserInput;
  userId: Scalars['String']['input'];
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'User', id: string, name: string, status?: string | null, public: boolean, email?: string | null, firstName: string, lastName: string, networkRoles?: Array<NetworkRole> | null, image?: string | null, asset?: string | null, personificationId?: string | null, _created: number } };

export type UpdatePasswordMutationVariables = Exact<{
  input: PasswordInput;
  userId: Scalars['String']['input'];
}>;


export type UpdatePasswordMutation = { __typename?: 'Mutation', updatePassword: { __typename?: 'User', id: string, name: string, status?: string | null, public: boolean, email?: string | null, firstName: string, lastName: string, networkRoles?: Array<NetworkRole> | null, image?: string | null, asset?: string | null, personificationId?: string | null, _created: number } };

export type UserLinkImageMutationVariables = Exact<{
  url: Scalars['String']['input'];
  userId: Scalars['String']['input'];
}>;


export type UserLinkImageMutation = { __typename?: 'Mutation', userLinkImage: { __typename?: 'User', id: string, name: string, status?: string | null, public: boolean, email?: string | null, firstName: string, lastName: string, networkRoles?: Array<NetworkRole> | null, image?: string | null, asset?: string | null, personificationId?: string | null, _created: number } };

export type UserUnlinkImageMutationVariables = Exact<{
  url: Scalars['String']['input'];
  userId: Scalars['String']['input'];
}>;


export type UserUnlinkImageMutation = { __typename?: 'Mutation', userUnlinkImage: { __typename?: 'User', id: string, name: string, status?: string | null, public: boolean, email?: string | null, firstName: string, lastName: string, networkRoles?: Array<NetworkRole> | null, image?: string | null, asset?: string | null, personificationId?: string | null, _created: number } };

export type UserFollowMutationVariables = Exact<{
  url: Scalars['String']['input'];
  userId: Scalars['String']['input'];
  method: Scalars['String']['input'];
}>;


export type UserFollowMutation = { __typename?: 'Mutation', userFollow: { __typename?: 'User', id: string } };

export type UserJoinMarketplaceMutationVariables = Exact<{ [key: string]: never; }>;


export type UserJoinMarketplaceMutation = { __typename?: 'Mutation', userJoinMarketplace: { __typename?: 'Network', id: string, caption: string, description?: string | null, owner?: string | null, public?: boolean | null, open?: boolean | null, bugTrackerEnabled?: boolean | null, networkRoles?: Array<NetworkRole | null> | null, image?: string | null, asset?: string | null } };

export type DeleteAccountMutationVariables = Exact<{
  input: DeleteAccountInput;
}>;


export type DeleteAccountMutation = { __typename?: 'Mutation', deleteAccount: { __typename?: 'DeleteAccountResponse', message: string } };

export type UserQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
  networkId: Scalars['ID']['input'];
}>;


export type UserQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: string, name: string, status?: string | null, public: boolean, email?: string | null, firstName: string, lastName: string, networkRoles?: Array<NetworkRole> | null, image?: string | null, asset?: string | null, personificationId?: string | null, _created: number, userMetaData?: { __typename?: 'UserMetaDataResponse', user?: { __typename?: 'CurrentUser', _created: number, data?: { __typename?: 'UserMetaData', username: string, aboutMe?: string | null, ageCategory?: Array<AgeCategory | null> | null, birthdate?: string | null, city?: string | null, club?: string | null, country?: string | null, experience?: Array<Experience | null> | null, phone?: string | null, street?: string | null, team?: string | null, userType?: Array<UserType | null> | null, year?: number | null, zip?: string | null, activitiesLastViewed?: string | null, status?: string | null, salutation?: Salutation | null, behavior?: { __typename?: 'UserBehavior', termsAcceptedAt?: string | null, termsVersionAccepted?: number | null, onboardingDone?: Array<string> | null, preferredPerformanceView?: string | null } | null } | null } | null } | null } | null };

export type UserStatusQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type UserStatusQuery = { __typename?: 'Query', userStatus: { __typename?: 'UserStatusResponse', selfNetwork?: string | null, selfPlayer?: string | null, selfUser?: string | null, jmtNetworks?: Array<string> | null } };

export type RelationshipsQueryVariables = Exact<{
  start?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type RelationshipsQuery = { __typename?: 'Query', followed?: { __typename?: 'UserCollection', collection: Array<{ __typename?: 'User', isFriend?: boolean | null, id: string, name: string, status?: string | null, public: boolean, email?: string | null, firstName: string, lastName: string, networkRoles?: Array<NetworkRole> | null, image?: string | null, asset?: string | null, personificationId?: string | null, _created: number }>, meta: { __typename?: 'Meta', range?: { __typename?: 'Range', from: number, to: number, total: number } | null, sortOptions?: Array<{ __typename?: 'MapEntry', key: string, value: string }> | null } } | null, follower?: { __typename?: 'UserCollection', collection: Array<{ __typename?: 'User', isFriend?: boolean | null, id: string, name: string, status?: string | null, public: boolean, email?: string | null, firstName: string, lastName: string, networkRoles?: Array<NetworkRole> | null, image?: string | null, asset?: string | null, personificationId?: string | null, _created: number }>, meta: { __typename?: 'Meta', range?: { __typename?: 'Range', from: number, to: number, total: number } | null, sortOptions?: Array<{ __typename?: 'MapEntry', key: string, value: string }> | null } } | null };

export type NewActivitiesQueryVariables = Exact<{
  isoDate: Scalars['String']['input'];
}>;


export type NewActivitiesQuery = { __typename?: 'Query', newActivities: Array<{ __typename?: 'Activity', date: string, id: string, type: string, data: string, targetUserId: string, from: { __typename?: 'User', id: string, name: string, status?: string | null, public: boolean, email?: string | null, firstName: string, lastName: string, networkRoles?: Array<NetworkRole> | null, image?: string | null, asset?: string | null, personificationId?: string | null, _created: number } }> };

export type ActivitiesQueryVariables = Exact<{
  from?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  date: Scalars['String']['input'];
}>;


export type ActivitiesQuery = { __typename?: 'Query', activities: { __typename?: 'ActivitiesResponse', meta: { __typename?: 'ActivityMeta', range: { __typename?: 'ActivityRange', from: number, to: number, total: number } }, collection: Array<{ __typename?: 'Activity', date: string, id: string, type: string, data: string, targetUserId: string, from: { __typename?: 'User', id: string, name: string, status?: string | null, public: boolean, email?: string | null, firstName: string, lastName: string, networkRoles?: Array<NetworkRole> | null, image?: string | null, asset?: string | null, personificationId?: string | null, _created: number } }> } };

export type ActivitylevelQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type ActivitylevelQuery = { __typename?: 'Query', activitylevel: number };

export const ContactRequestFragmentDoc = gql`
    fragment contactRequest on ContactRequest {
  id
  status
  targetType
  targetId
  fromUserId
  conversationId
  message
  createdAt
}
    `;
export const ContactUserFragmentDoc = gql`
    fragment contactUser on User {
  id
  firstName
  lastName
  image
}
    `;
export const ContactTargetFragmentDoc = gql`
    fragment contactTarget on ContactTarget {
  type
  id
  name
  image
}
    `;
export const ContactRequestWithPeopleFragmentDoc = gql`
    fragment contactRequestWithPeople on ContactRequest {
  ...contactRequest
  fromUser {
    ...contactUser
  }
  target {
    ...contactTarget
  }
}
    ${ContactRequestFragmentDoc}
${ContactUserFragmentDoc}
${ContactTargetFragmentDoc}`;
export const ContactMessageFragmentDoc = gql`
    fragment contactMessage on ContactMessage {
  id
  conversationId
  body
  status
  fromUserId
  fromExternal
  createdAt
  readAt
}
    `;
export const ContactConversationFragmentDoc = gql`
    fragment contactConversation on ContactConversation {
  id
  status
  targetType
  targetId
  participantUserIds
  createdAt
  updatedAt
  messages {
    ...contactMessage
  }
}
    ${ContactMessageFragmentDoc}`;
export const ContactConversationListItemFragmentDoc = gql`
    fragment contactConversationListItem on ContactConversation {
  id
  status
  updatedAt
  unreadCount
  counterpart {
    ...contactUser
  }
  request {
    id
    fromUserId
    target {
      ...contactTarget
    }
  }
  lastMessage {
    id
    body
    createdAt
    fromUserId
    status
  }
}
    ${ContactUserFragmentDoc}
${ContactTargetFragmentDoc}`;
export const ContactBlockedUserFragmentDoc = gql`
    fragment contactBlockedUser on ContactBlockedUser {
  userId
  createdAt
  user {
    ...contactUser
  }
}
    ${ContactUserFragmentDoc}`;
export const PlaylistFragmentDoc = gql`
    fragment playlist on Playlist {
  id
  caption
  public
  user
  latestObject {
    image
  }
}
    `;
export const NetworkFragmentDoc = gql`
    fragment network on Network {
  id
  caption
  description
  owner
  public
  open
  bugTrackerEnabled
  networkRoles
  image
  asset
}
    `;
export const NetworkSearchResultFragmentDoc = gql`
    fragment networkSearchResult on Network {
  id
  caption
  description
  owner
  public
  open
  bugTrackerEnabled
  image
}
    `;
export const JmtNetworkFragmentDoc = gql`
    fragment jmtNetwork on Network {
  id
  caption
  description
  public
  open
  bugTrackerEnabled
  networkRoles
}
    `;
export const TalentFragmentDoc = gql`
    fragment talent on Talent {
  id @export(as: "talentId")
  caption
  dataViews {
    key
    values
  }
  image
  imageSource
  metas {
    date
    fieldPosition
    fifaCountry
    firstName
    lastName
  }
  customMeta {
    id
    foot
    club
    team
    height
    weight
    rolemodelid
    topskillsindexes
    status
    salutation
  }
  playlistCount
  public
  permissionLevel
  personification
  rateCount
  tm_id
  profileId
  asset
}
    `;
export const UserFragmentDoc = gql`
    fragment user on User {
  id
  name
  status
  public
  email
  firstName
  lastName
  networkRoles
  image
  asset
  personificationId
  _created
}
    `;
export const TalentTransferRequestFragmentDoc = gql`
    fragment talentTransferRequest on TalentTransferRequest {
  id
  message
  object @type(name: "Talent") {
    ...talent
  }
  status
  statusStamp
  targetUser @type(name: "User") {
    ...user
  }
  from @type(name: "User") {
    ...user
  }
}
    ${TalentFragmentDoc}
${UserFragmentDoc}`;
export const SharedTalentFragmentDoc = gql`
    fragment sharedTalent on Talent {
  id
  caption
  dataViews {
    key
    values
  }
  image
  imageSource
  metas @type(name: "TalentMetas") {
    date
    fieldPosition
    fifaCountry
    firstName
    lastName
  }
  customMeta @type(name: "TalentCustomMeta") {
    id
    foot
    club
    team
    height
    weight
    rolemodelid
    topskillsindexes
    status
  }
  playlistCount
  public
  permissionLevel
  rateCount
  tm_id
  personification
  profileId
}
    `;
export const VoteFragmentDoc = gql`
    fragment vote on Vote {
  id
  values
  date
}
    `;
export const TalentIdLayerFragmentDoc = gql`
    fragment talentIDLayer on Layer {
  name
  dataViews @type(name: "TalentDataView") {
    key
    values
  }
}
    `;
export const PerformanceVoteFragmentDoc = gql`
    fragment performanceVote on PerformanceVote {
  talentId
  private
  public
  privateCount
  publicDetail
}
    `;
export const ActivityFragmentDoc = gql`
    fragment activity on Activity {
  date
  id
  type
  from {
    ...user
  }
  data
  targetUserId
}
    ${UserFragmentDoc}`;
export const UserMetadataFragmentDoc = gql`
    fragment userMetadata on UserMetaData {
  username
  aboutMe
  ageCategory
  behavior {
    termsAcceptedAt
    termsVersionAccepted
    onboardingDone
    preferredPerformanceView
  }
  birthdate
  city
  club
  country
  experience
  phone
  street
  team
  userType
  year
  zip
  activitiesLastViewed
  status
  salutation
}
    `;
export const UserMetadataResponseFragmentDoc = gql`
    fragment userMetadataResponse on UserMetaDataResponse {
  user {
    _created
    data @type(name: "UserMetaData") {
      ...userMetadata
    }
  }
}
    ${UserMetadataFragmentDoc}`;
export const UserMetadataSaveResponseFragmentDoc = gql`
    fragment userMetadataSaveResponse on UserMetaDataSaveResponse {
  current_user {
    _created
    data @type(name: "UserMetaData") {
      ...userMetadata
    }
  }
}
    ${UserMetadataFragmentDoc}`;
export const MetaFragmentDoc = gql`
    fragment meta on Meta {
  range {
    from
    to
    total
  }
  sortOptions @type(name: "MapEntry") {
    key
    value
  }
}
    `;
export const SigninDocument = gql`
    mutation signin($input: AuthenticationFormInput!) {
  signin(input: $input) {
    token
    apiToken
    user {
      ...user
    }
  }
}
    ${UserFragmentDoc}`;
export type SigninMutationFn = Apollo.MutationFunction<SigninMutation, SigninMutationVariables>;

/**
 * __useSigninMutation__
 *
 * To run a mutation, you first call `useSigninMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSigninMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signinMutation, { data, loading, error }] = useSigninMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSigninMutation(baseOptions?: Apollo.MutationHookOptions<SigninMutation, SigninMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SigninMutation, SigninMutationVariables>(SigninDocument, options);
      }
export type SigninMutationHookResult = ReturnType<typeof useSigninMutation>;
export type SigninMutationResult = Apollo.MutationResult<SigninMutation>;
export type SigninMutationOptions = Apollo.BaseMutationOptions<SigninMutation, SigninMutationVariables>;
export const SigninWithTokenDocument = gql`
    mutation signinWithToken($input: AuthenticationTokenInput!) {
  signinWithToken(input: $input) {
    token
    apiToken
    user {
      ...user
    }
  }
}
    ${UserFragmentDoc}`;
export type SigninWithTokenMutationFn = Apollo.MutationFunction<SigninWithTokenMutation, SigninWithTokenMutationVariables>;

/**
 * __useSigninWithTokenMutation__
 *
 * To run a mutation, you first call `useSigninWithTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSigninWithTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signinWithTokenMutation, { data, loading, error }] = useSigninWithTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSigninWithTokenMutation(baseOptions?: Apollo.MutationHookOptions<SigninWithTokenMutation, SigninWithTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SigninWithTokenMutation, SigninWithTokenMutationVariables>(SigninWithTokenDocument, options);
      }
export type SigninWithTokenMutationHookResult = ReturnType<typeof useSigninWithTokenMutation>;
export type SigninWithTokenMutationResult = Apollo.MutationResult<SigninWithTokenMutation>;
export type SigninWithTokenMutationOptions = Apollo.BaseMutationOptions<SigninWithTokenMutation, SigninWithTokenMutationVariables>;
export const SigninWithHsvidCodeDocument = gql`
    mutation signinWithHSVIDCode($input: AuthenticationCodeInput!) {
  signinWithHSVIDCode(input: $input) {
    token
    apiToken
    user {
      ...user
    }
  }
}
    ${UserFragmentDoc}`;
export type SigninWithHsvidCodeMutationFn = Apollo.MutationFunction<SigninWithHsvidCodeMutation, SigninWithHsvidCodeMutationVariables>;

/**
 * __useSigninWithHsvidCodeMutation__
 *
 * To run a mutation, you first call `useSigninWithHsvidCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSigninWithHsvidCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signinWithHsvidCodeMutation, { data, loading, error }] = useSigninWithHsvidCodeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSigninWithHsvidCodeMutation(baseOptions?: Apollo.MutationHookOptions<SigninWithHsvidCodeMutation, SigninWithHsvidCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SigninWithHsvidCodeMutation, SigninWithHsvidCodeMutationVariables>(SigninWithHsvidCodeDocument, options);
      }
export type SigninWithHsvidCodeMutationHookResult = ReturnType<typeof useSigninWithHsvidCodeMutation>;
export type SigninWithHsvidCodeMutationResult = Apollo.MutationResult<SigninWithHsvidCodeMutation>;
export type SigninWithHsvidCodeMutationOptions = Apollo.BaseMutationOptions<SigninWithHsvidCodeMutation, SigninWithHsvidCodeMutationVariables>;
export const RegisterDocument = gql`
    mutation register($input: RegistrationInput!) {
  register(input: $input) @rest(type: "Authentication", path: "/user", method: "POST") {
    token
    user @type(name: "User") {
      ...user
    }
  }
}
    ${UserFragmentDoc}`;
export type RegisterMutationFn = Apollo.MutationFunction<RegisterMutation, RegisterMutationVariables>;

/**
 * __useRegisterMutation__
 *
 * To run a mutation, you first call `useRegisterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerMutation, { data, loading, error }] = useRegisterMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegisterMutation(baseOptions?: Apollo.MutationHookOptions<RegisterMutation, RegisterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterMutation, RegisterMutationVariables>(RegisterDocument, options);
      }
export type RegisterMutationHookResult = ReturnType<typeof useRegisterMutation>;
export type RegisterMutationResult = Apollo.MutationResult<RegisterMutation>;
export type RegisterMutationOptions = Apollo.BaseMutationOptions<RegisterMutation, RegisterMutationVariables>;
export const DoimailDocument = gql`
    mutation doimail($input: DoimailInput!) {
  doimail(input: $input) @rest(type: "Message", path: "/makro/doimail&hash={args.input.token}&email={args.input.email}&subject={args.input.subject}&name={args.input.name}", method: "POST") {
    message
  }
}
    `;
export type DoimailMutationFn = Apollo.MutationFunction<DoimailMutation, DoimailMutationVariables>;

/**
 * __useDoimailMutation__
 *
 * To run a mutation, you first call `useDoimailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDoimailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [doimailMutation, { data, loading, error }] = useDoimailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDoimailMutation(baseOptions?: Apollo.MutationHookOptions<DoimailMutation, DoimailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DoimailMutation, DoimailMutationVariables>(DoimailDocument, options);
      }
export type DoimailMutationHookResult = ReturnType<typeof useDoimailMutation>;
export type DoimailMutationResult = Apollo.MutationResult<DoimailMutation>;
export type DoimailMutationOptions = Apollo.BaseMutationOptions<DoimailMutation, DoimailMutationVariables>;
export const WhoamiDocument = gql`
    query whoami {
  whoami {
    token
    apiToken
    user @type(name: "User") {
      ...user
    }
  }
}
    ${UserFragmentDoc}`;

/**
 * __useWhoamiQuery__
 *
 * To run a query within a React component, call `useWhoamiQuery` and pass it any options that fit your needs.
 * When your component renders, `useWhoamiQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWhoamiQuery({
 *   variables: {
 *   },
 * });
 */
export function useWhoamiQuery(baseOptions?: Apollo.QueryHookOptions<WhoamiQuery, WhoamiQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WhoamiQuery, WhoamiQueryVariables>(WhoamiDocument, options);
      }
export function useWhoamiLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WhoamiQuery, WhoamiQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WhoamiQuery, WhoamiQueryVariables>(WhoamiDocument, options);
        }
// @ts-ignore
export function useWhoamiSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WhoamiQuery, WhoamiQueryVariables>): Apollo.UseSuspenseQueryResult<WhoamiQuery, WhoamiQueryVariables>;
export function useWhoamiSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WhoamiQuery, WhoamiQueryVariables>): Apollo.UseSuspenseQueryResult<WhoamiQuery | undefined, WhoamiQueryVariables>;
export function useWhoamiSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WhoamiQuery, WhoamiQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WhoamiQuery, WhoamiQueryVariables>(WhoamiDocument, options);
        }
export type WhoamiQueryHookResult = ReturnType<typeof useWhoamiQuery>;
export type WhoamiLazyQueryHookResult = ReturnType<typeof useWhoamiLazyQuery>;
export type WhoamiSuspenseQueryHookResult = ReturnType<typeof useWhoamiSuspenseQuery>;
export type WhoamiQueryResult = Apollo.QueryResult<WhoamiQuery, WhoamiQueryVariables>;
export const ContactConversationsDocument = gql`
    query contactConversations($status: ContactRequestStatus, $start: Int, $limit: Int) {
  contactConversations(status: $status, start: $start, limit: $limit) {
    ...contactConversationListItem
  }
}
    ${ContactConversationListItemFragmentDoc}`;

/**
 * __useContactConversationsQuery__
 *
 * To run a query within a React component, call `useContactConversationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactConversationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactConversationsQuery({
 *   variables: {
 *      status: // value for 'status'
 *      start: // value for 'start'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useContactConversationsQuery(baseOptions?: Apollo.QueryHookOptions<ContactConversationsQuery, ContactConversationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactConversationsQuery, ContactConversationsQueryVariables>(ContactConversationsDocument, options);
      }
export function useContactConversationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactConversationsQuery, ContactConversationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactConversationsQuery, ContactConversationsQueryVariables>(ContactConversationsDocument, options);
        }
// @ts-ignore
export function useContactConversationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ContactConversationsQuery, ContactConversationsQueryVariables>): Apollo.UseSuspenseQueryResult<ContactConversationsQuery, ContactConversationsQueryVariables>;
export function useContactConversationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContactConversationsQuery, ContactConversationsQueryVariables>): Apollo.UseSuspenseQueryResult<ContactConversationsQuery | undefined, ContactConversationsQueryVariables>;
export function useContactConversationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContactConversationsQuery, ContactConversationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContactConversationsQuery, ContactConversationsQueryVariables>(ContactConversationsDocument, options);
        }
export type ContactConversationsQueryHookResult = ReturnType<typeof useContactConversationsQuery>;
export type ContactConversationsLazyQueryHookResult = ReturnType<typeof useContactConversationsLazyQuery>;
export type ContactConversationsSuspenseQueryHookResult = ReturnType<typeof useContactConversationsSuspenseQuery>;
export type ContactConversationsQueryResult = Apollo.QueryResult<ContactConversationsQuery, ContactConversationsQueryVariables>;
export const ContactUnreadDocument = gql`
    query contactUnread {
  contactConversations {
    id
    unreadCount
  }
}
    `;

/**
 * __useContactUnreadQuery__
 *
 * To run a query within a React component, call `useContactUnreadQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactUnreadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactUnreadQuery({
 *   variables: {
 *   },
 * });
 */
export function useContactUnreadQuery(baseOptions?: Apollo.QueryHookOptions<ContactUnreadQuery, ContactUnreadQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactUnreadQuery, ContactUnreadQueryVariables>(ContactUnreadDocument, options);
      }
export function useContactUnreadLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactUnreadQuery, ContactUnreadQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactUnreadQuery, ContactUnreadQueryVariables>(ContactUnreadDocument, options);
        }
// @ts-ignore
export function useContactUnreadSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ContactUnreadQuery, ContactUnreadQueryVariables>): Apollo.UseSuspenseQueryResult<ContactUnreadQuery, ContactUnreadQueryVariables>;
export function useContactUnreadSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContactUnreadQuery, ContactUnreadQueryVariables>): Apollo.UseSuspenseQueryResult<ContactUnreadQuery | undefined, ContactUnreadQueryVariables>;
export function useContactUnreadSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContactUnreadQuery, ContactUnreadQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContactUnreadQuery, ContactUnreadQueryVariables>(ContactUnreadDocument, options);
        }
export type ContactUnreadQueryHookResult = ReturnType<typeof useContactUnreadQuery>;
export type ContactUnreadLazyQueryHookResult = ReturnType<typeof useContactUnreadLazyQuery>;
export type ContactUnreadSuspenseQueryHookResult = ReturnType<typeof useContactUnreadSuspenseQuery>;
export type ContactUnreadQueryResult = Apollo.QueryResult<ContactUnreadQuery, ContactUnreadQueryVariables>;
export const ContactBlockedUsersDocument = gql`
    query contactBlockedUsers {
  contactBlockedUsers {
    ...contactBlockedUser
  }
}
    ${ContactBlockedUserFragmentDoc}`;

/**
 * __useContactBlockedUsersQuery__
 *
 * To run a query within a React component, call `useContactBlockedUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactBlockedUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactBlockedUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useContactBlockedUsersQuery(baseOptions?: Apollo.QueryHookOptions<ContactBlockedUsersQuery, ContactBlockedUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactBlockedUsersQuery, ContactBlockedUsersQueryVariables>(ContactBlockedUsersDocument, options);
      }
export function useContactBlockedUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactBlockedUsersQuery, ContactBlockedUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactBlockedUsersQuery, ContactBlockedUsersQueryVariables>(ContactBlockedUsersDocument, options);
        }
// @ts-ignore
export function useContactBlockedUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ContactBlockedUsersQuery, ContactBlockedUsersQueryVariables>): Apollo.UseSuspenseQueryResult<ContactBlockedUsersQuery, ContactBlockedUsersQueryVariables>;
export function useContactBlockedUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContactBlockedUsersQuery, ContactBlockedUsersQueryVariables>): Apollo.UseSuspenseQueryResult<ContactBlockedUsersQuery | undefined, ContactBlockedUsersQueryVariables>;
export function useContactBlockedUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContactBlockedUsersQuery, ContactBlockedUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContactBlockedUsersQuery, ContactBlockedUsersQueryVariables>(ContactBlockedUsersDocument, options);
        }
export type ContactBlockedUsersQueryHookResult = ReturnType<typeof useContactBlockedUsersQuery>;
export type ContactBlockedUsersLazyQueryHookResult = ReturnType<typeof useContactBlockedUsersLazyQuery>;
export type ContactBlockedUsersSuspenseQueryHookResult = ReturnType<typeof useContactBlockedUsersSuspenseQuery>;
export type ContactBlockedUsersQueryResult = Apollo.QueryResult<ContactBlockedUsersQuery, ContactBlockedUsersQueryVariables>;
export const ContactRequestsDocument = gql`
    query contactRequests($status: ContactRequestStatus, $direction: ContactRequestDirection, $start: Int, $limit: Int) {
  contactRequests(
    status: $status
    direction: $direction
    start: $start
    limit: $limit
  ) {
    ...contactRequest
  }
}
    ${ContactRequestFragmentDoc}`;

/**
 * __useContactRequestsQuery__
 *
 * To run a query within a React component, call `useContactRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactRequestsQuery({
 *   variables: {
 *      status: // value for 'status'
 *      direction: // value for 'direction'
 *      start: // value for 'start'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useContactRequestsQuery(baseOptions?: Apollo.QueryHookOptions<ContactRequestsQuery, ContactRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactRequestsQuery, ContactRequestsQueryVariables>(ContactRequestsDocument, options);
      }
export function useContactRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactRequestsQuery, ContactRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactRequestsQuery, ContactRequestsQueryVariables>(ContactRequestsDocument, options);
        }
// @ts-ignore
export function useContactRequestsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ContactRequestsQuery, ContactRequestsQueryVariables>): Apollo.UseSuspenseQueryResult<ContactRequestsQuery, ContactRequestsQueryVariables>;
export function useContactRequestsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContactRequestsQuery, ContactRequestsQueryVariables>): Apollo.UseSuspenseQueryResult<ContactRequestsQuery | undefined, ContactRequestsQueryVariables>;
export function useContactRequestsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContactRequestsQuery, ContactRequestsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContactRequestsQuery, ContactRequestsQueryVariables>(ContactRequestsDocument, options);
        }
export type ContactRequestsQueryHookResult = ReturnType<typeof useContactRequestsQuery>;
export type ContactRequestsLazyQueryHookResult = ReturnType<typeof useContactRequestsLazyQuery>;
export type ContactRequestsSuspenseQueryHookResult = ReturnType<typeof useContactRequestsSuspenseQuery>;
export type ContactRequestsQueryResult = Apollo.QueryResult<ContactRequestsQuery, ContactRequestsQueryVariables>;
export const ContactRequestsWithPeopleDocument = gql`
    query contactRequestsWithPeople($status: ContactRequestStatus, $direction: ContactRequestDirection, $start: Int, $limit: Int) {
  contactRequests(
    status: $status
    direction: $direction
    start: $start
    limit: $limit
  ) {
    ...contactRequestWithPeople
  }
}
    ${ContactRequestWithPeopleFragmentDoc}`;

/**
 * __useContactRequestsWithPeopleQuery__
 *
 * To run a query within a React component, call `useContactRequestsWithPeopleQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactRequestsWithPeopleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactRequestsWithPeopleQuery({
 *   variables: {
 *      status: // value for 'status'
 *      direction: // value for 'direction'
 *      start: // value for 'start'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useContactRequestsWithPeopleQuery(baseOptions?: Apollo.QueryHookOptions<ContactRequestsWithPeopleQuery, ContactRequestsWithPeopleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactRequestsWithPeopleQuery, ContactRequestsWithPeopleQueryVariables>(ContactRequestsWithPeopleDocument, options);
      }
export function useContactRequestsWithPeopleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactRequestsWithPeopleQuery, ContactRequestsWithPeopleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactRequestsWithPeopleQuery, ContactRequestsWithPeopleQueryVariables>(ContactRequestsWithPeopleDocument, options);
        }
// @ts-ignore
export function useContactRequestsWithPeopleSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ContactRequestsWithPeopleQuery, ContactRequestsWithPeopleQueryVariables>): Apollo.UseSuspenseQueryResult<ContactRequestsWithPeopleQuery, ContactRequestsWithPeopleQueryVariables>;
export function useContactRequestsWithPeopleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContactRequestsWithPeopleQuery, ContactRequestsWithPeopleQueryVariables>): Apollo.UseSuspenseQueryResult<ContactRequestsWithPeopleQuery | undefined, ContactRequestsWithPeopleQueryVariables>;
export function useContactRequestsWithPeopleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContactRequestsWithPeopleQuery, ContactRequestsWithPeopleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContactRequestsWithPeopleQuery, ContactRequestsWithPeopleQueryVariables>(ContactRequestsWithPeopleDocument, options);
        }
export type ContactRequestsWithPeopleQueryHookResult = ReturnType<typeof useContactRequestsWithPeopleQuery>;
export type ContactRequestsWithPeopleLazyQueryHookResult = ReturnType<typeof useContactRequestsWithPeopleLazyQuery>;
export type ContactRequestsWithPeopleSuspenseQueryHookResult = ReturnType<typeof useContactRequestsWithPeopleSuspenseQuery>;
export type ContactRequestsWithPeopleQueryResult = Apollo.QueryResult<ContactRequestsWithPeopleQuery, ContactRequestsWithPeopleQueryVariables>;
export const ContactConversationDocument = gql`
    query contactConversation($id: ID!) {
  contactConversation(id: $id) {
    ...contactConversation
  }
}
    ${ContactConversationFragmentDoc}`;

/**
 * __useContactConversationQuery__
 *
 * To run a query within a React component, call `useContactConversationQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactConversationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactConversationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useContactConversationQuery(baseOptions: Apollo.QueryHookOptions<ContactConversationQuery, ContactConversationQueryVariables> & ({ variables: ContactConversationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactConversationQuery, ContactConversationQueryVariables>(ContactConversationDocument, options);
      }
export function useContactConversationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactConversationQuery, ContactConversationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactConversationQuery, ContactConversationQueryVariables>(ContactConversationDocument, options);
        }
// @ts-ignore
export function useContactConversationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ContactConversationQuery, ContactConversationQueryVariables>): Apollo.UseSuspenseQueryResult<ContactConversationQuery, ContactConversationQueryVariables>;
export function useContactConversationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContactConversationQuery, ContactConversationQueryVariables>): Apollo.UseSuspenseQueryResult<ContactConversationQuery | undefined, ContactConversationQueryVariables>;
export function useContactConversationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContactConversationQuery, ContactConversationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContactConversationQuery, ContactConversationQueryVariables>(ContactConversationDocument, options);
        }
export type ContactConversationQueryHookResult = ReturnType<typeof useContactConversationQuery>;
export type ContactConversationLazyQueryHookResult = ReturnType<typeof useContactConversationLazyQuery>;
export type ContactConversationSuspenseQueryHookResult = ReturnType<typeof useContactConversationSuspenseQuery>;
export type ContactConversationQueryResult = Apollo.QueryResult<ContactConversationQuery, ContactConversationQueryVariables>;
export const ContactConversationHeaderDocument = gql`
    query contactConversationHeader($id: ID!) {
  contactConversation(id: $id) {
    id
    status
    counterpart {
      ...contactUser
    }
    request {
      id
      status
      fromUserId
      target {
        ...contactTarget
      }
    }
  }
}
    ${ContactUserFragmentDoc}
${ContactTargetFragmentDoc}`;

/**
 * __useContactConversationHeaderQuery__
 *
 * To run a query within a React component, call `useContactConversationHeaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactConversationHeaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactConversationHeaderQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useContactConversationHeaderQuery(baseOptions: Apollo.QueryHookOptions<ContactConversationHeaderQuery, ContactConversationHeaderQueryVariables> & ({ variables: ContactConversationHeaderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactConversationHeaderQuery, ContactConversationHeaderQueryVariables>(ContactConversationHeaderDocument, options);
      }
export function useContactConversationHeaderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactConversationHeaderQuery, ContactConversationHeaderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactConversationHeaderQuery, ContactConversationHeaderQueryVariables>(ContactConversationHeaderDocument, options);
        }
// @ts-ignore
export function useContactConversationHeaderSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ContactConversationHeaderQuery, ContactConversationHeaderQueryVariables>): Apollo.UseSuspenseQueryResult<ContactConversationHeaderQuery, ContactConversationHeaderQueryVariables>;
export function useContactConversationHeaderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContactConversationHeaderQuery, ContactConversationHeaderQueryVariables>): Apollo.UseSuspenseQueryResult<ContactConversationHeaderQuery | undefined, ContactConversationHeaderQueryVariables>;
export function useContactConversationHeaderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContactConversationHeaderQuery, ContactConversationHeaderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContactConversationHeaderQuery, ContactConversationHeaderQueryVariables>(ContactConversationHeaderDocument, options);
        }
export type ContactConversationHeaderQueryHookResult = ReturnType<typeof useContactConversationHeaderQuery>;
export type ContactConversationHeaderLazyQueryHookResult = ReturnType<typeof useContactConversationHeaderLazyQuery>;
export type ContactConversationHeaderSuspenseQueryHookResult = ReturnType<typeof useContactConversationHeaderSuspenseQuery>;
export type ContactConversationHeaderQueryResult = Apollo.QueryResult<ContactConversationHeaderQuery, ContactConversationHeaderQueryVariables>;
export const CreateContactRequestDocument = gql`
    mutation createContactRequest($input: CreateContactRequestInput!) {
  createContactRequest(input: $input) {
    ...contactRequest
  }
}
    ${ContactRequestFragmentDoc}`;
export type CreateContactRequestMutationFn = Apollo.MutationFunction<CreateContactRequestMutation, CreateContactRequestMutationVariables>;

/**
 * __useCreateContactRequestMutation__
 *
 * To run a mutation, you first call `useCreateContactRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContactRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContactRequestMutation, { data, loading, error }] = useCreateContactRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateContactRequestMutation(baseOptions?: Apollo.MutationHookOptions<CreateContactRequestMutation, CreateContactRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateContactRequestMutation, CreateContactRequestMutationVariables>(CreateContactRequestDocument, options);
      }
export type CreateContactRequestMutationHookResult = ReturnType<typeof useCreateContactRequestMutation>;
export type CreateContactRequestMutationResult = Apollo.MutationResult<CreateContactRequestMutation>;
export type CreateContactRequestMutationOptions = Apollo.BaseMutationOptions<CreateContactRequestMutation, CreateContactRequestMutationVariables>;
export const AcceptContactRequestDocument = gql`
    mutation acceptContactRequest($id: ID!) {
  acceptContactRequest(id: $id) {
    ...contactRequest
  }
}
    ${ContactRequestFragmentDoc}`;
export type AcceptContactRequestMutationFn = Apollo.MutationFunction<AcceptContactRequestMutation, AcceptContactRequestMutationVariables>;

/**
 * __useAcceptContactRequestMutation__
 *
 * To run a mutation, you first call `useAcceptContactRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptContactRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptContactRequestMutation, { data, loading, error }] = useAcceptContactRequestMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAcceptContactRequestMutation(baseOptions?: Apollo.MutationHookOptions<AcceptContactRequestMutation, AcceptContactRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptContactRequestMutation, AcceptContactRequestMutationVariables>(AcceptContactRequestDocument, options);
      }
export type AcceptContactRequestMutationHookResult = ReturnType<typeof useAcceptContactRequestMutation>;
export type AcceptContactRequestMutationResult = Apollo.MutationResult<AcceptContactRequestMutation>;
export type AcceptContactRequestMutationOptions = Apollo.BaseMutationOptions<AcceptContactRequestMutation, AcceptContactRequestMutationVariables>;
export const DeclineContactRequestDocument = gql`
    mutation declineContactRequest($id: ID!) {
  declineContactRequest(id: $id) {
    ...contactRequest
  }
}
    ${ContactRequestFragmentDoc}`;
export type DeclineContactRequestMutationFn = Apollo.MutationFunction<DeclineContactRequestMutation, DeclineContactRequestMutationVariables>;

/**
 * __useDeclineContactRequestMutation__
 *
 * To run a mutation, you first call `useDeclineContactRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeclineContactRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [declineContactRequestMutation, { data, loading, error }] = useDeclineContactRequestMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeclineContactRequestMutation(baseOptions?: Apollo.MutationHookOptions<DeclineContactRequestMutation, DeclineContactRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeclineContactRequestMutation, DeclineContactRequestMutationVariables>(DeclineContactRequestDocument, options);
      }
export type DeclineContactRequestMutationHookResult = ReturnType<typeof useDeclineContactRequestMutation>;
export type DeclineContactRequestMutationResult = Apollo.MutationResult<DeclineContactRequestMutation>;
export type DeclineContactRequestMutationOptions = Apollo.BaseMutationOptions<DeclineContactRequestMutation, DeclineContactRequestMutationVariables>;
export const WithdrawContactRequestDocument = gql`
    mutation withdrawContactRequest($id: ID!) {
  withdrawContactRequest(id: $id) {
    ...contactRequest
  }
}
    ${ContactRequestFragmentDoc}`;
export type WithdrawContactRequestMutationFn = Apollo.MutationFunction<WithdrawContactRequestMutation, WithdrawContactRequestMutationVariables>;

/**
 * __useWithdrawContactRequestMutation__
 *
 * To run a mutation, you first call `useWithdrawContactRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWithdrawContactRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [withdrawContactRequestMutation, { data, loading, error }] = useWithdrawContactRequestMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useWithdrawContactRequestMutation(baseOptions?: Apollo.MutationHookOptions<WithdrawContactRequestMutation, WithdrawContactRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WithdrawContactRequestMutation, WithdrawContactRequestMutationVariables>(WithdrawContactRequestDocument, options);
      }
export type WithdrawContactRequestMutationHookResult = ReturnType<typeof useWithdrawContactRequestMutation>;
export type WithdrawContactRequestMutationResult = Apollo.MutationResult<WithdrawContactRequestMutation>;
export type WithdrawContactRequestMutationOptions = Apollo.BaseMutationOptions<WithdrawContactRequestMutation, WithdrawContactRequestMutationVariables>;
export const SendContactMessageDocument = gql`
    mutation sendContactMessage($input: SendContactMessageInput!) {
  sendContactMessage(input: $input) {
    ...contactMessage
  }
}
    ${ContactMessageFragmentDoc}`;
export type SendContactMessageMutationFn = Apollo.MutationFunction<SendContactMessageMutation, SendContactMessageMutationVariables>;

/**
 * __useSendContactMessageMutation__
 *
 * To run a mutation, you first call `useSendContactMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendContactMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendContactMessageMutation, { data, loading, error }] = useSendContactMessageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendContactMessageMutation(baseOptions?: Apollo.MutationHookOptions<SendContactMessageMutation, SendContactMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendContactMessageMutation, SendContactMessageMutationVariables>(SendContactMessageDocument, options);
      }
export type SendContactMessageMutationHookResult = ReturnType<typeof useSendContactMessageMutation>;
export type SendContactMessageMutationResult = Apollo.MutationResult<SendContactMessageMutation>;
export type SendContactMessageMutationOptions = Apollo.BaseMutationOptions<SendContactMessageMutation, SendContactMessageMutationVariables>;
export const DeleteContactConversationDocument = gql`
    mutation deleteContactConversation($id: ID!) {
  deleteContactConversation(id: $id)
}
    `;
export type DeleteContactConversationMutationFn = Apollo.MutationFunction<DeleteContactConversationMutation, DeleteContactConversationMutationVariables>;

/**
 * __useDeleteContactConversationMutation__
 *
 * To run a mutation, you first call `useDeleteContactConversationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContactConversationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteContactConversationMutation, { data, loading, error }] = useDeleteContactConversationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteContactConversationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteContactConversationMutation, DeleteContactConversationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteContactConversationMutation, DeleteContactConversationMutationVariables>(DeleteContactConversationDocument, options);
      }
export type DeleteContactConversationMutationHookResult = ReturnType<typeof useDeleteContactConversationMutation>;
export type DeleteContactConversationMutationResult = Apollo.MutationResult<DeleteContactConversationMutation>;
export type DeleteContactConversationMutationOptions = Apollo.BaseMutationOptions<DeleteContactConversationMutation, DeleteContactConversationMutationVariables>;
export const BlockContactUserDocument = gql`
    mutation blockContactUser($conversationId: ID!) {
  blockContactUser(conversationId: $conversationId)
}
    `;
export type BlockContactUserMutationFn = Apollo.MutationFunction<BlockContactUserMutation, BlockContactUserMutationVariables>;

/**
 * __useBlockContactUserMutation__
 *
 * To run a mutation, you first call `useBlockContactUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBlockContactUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [blockContactUserMutation, { data, loading, error }] = useBlockContactUserMutation({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *   },
 * });
 */
export function useBlockContactUserMutation(baseOptions?: Apollo.MutationHookOptions<BlockContactUserMutation, BlockContactUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BlockContactUserMutation, BlockContactUserMutationVariables>(BlockContactUserDocument, options);
      }
export type BlockContactUserMutationHookResult = ReturnType<typeof useBlockContactUserMutation>;
export type BlockContactUserMutationResult = Apollo.MutationResult<BlockContactUserMutation>;
export type BlockContactUserMutationOptions = Apollo.BaseMutationOptions<BlockContactUserMutation, BlockContactUserMutationVariables>;
export const UnblockContactUserDocument = gql`
    mutation unblockContactUser($userId: ID!) {
  unblockContactUser(userId: $userId)
}
    `;
export type UnblockContactUserMutationFn = Apollo.MutationFunction<UnblockContactUserMutation, UnblockContactUserMutationVariables>;

/**
 * __useUnblockContactUserMutation__
 *
 * To run a mutation, you first call `useUnblockContactUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnblockContactUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unblockContactUserMutation, { data, loading, error }] = useUnblockContactUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUnblockContactUserMutation(baseOptions?: Apollo.MutationHookOptions<UnblockContactUserMutation, UnblockContactUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnblockContactUserMutation, UnblockContactUserMutationVariables>(UnblockContactUserDocument, options);
      }
export type UnblockContactUserMutationHookResult = ReturnType<typeof useUnblockContactUserMutation>;
export type UnblockContactUserMutationResult = Apollo.MutationResult<UnblockContactUserMutation>;
export type UnblockContactUserMutationOptions = Apollo.BaseMutationOptions<UnblockContactUserMutation, UnblockContactUserMutationVariables>;
export const ReportContactUserDocument = gql`
    mutation reportContactUser($input: CreateContactReportInput!) {
  reportContactUser(input: $input)
}
    `;
export type ReportContactUserMutationFn = Apollo.MutationFunction<ReportContactUserMutation, ReportContactUserMutationVariables>;

/**
 * __useReportContactUserMutation__
 *
 * To run a mutation, you first call `useReportContactUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReportContactUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reportContactUserMutation, { data, loading, error }] = useReportContactUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReportContactUserMutation(baseOptions?: Apollo.MutationHookOptions<ReportContactUserMutation, ReportContactUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReportContactUserMutation, ReportContactUserMutationVariables>(ReportContactUserDocument, options);
      }
export type ReportContactUserMutationHookResult = ReturnType<typeof useReportContactUserMutation>;
export type ReportContactUserMutationResult = Apollo.MutationResult<ReportContactUserMutation>;
export type ReportContactUserMutationOptions = Apollo.BaseMutationOptions<ReportContactUserMutation, ReportContactUserMutationVariables>;
export const MarkContactConversationReadDocument = gql`
    mutation markContactConversationRead($id: ID!) {
  markContactConversationRead(id: $id) {
    ...contactConversation
  }
}
    ${ContactConversationFragmentDoc}`;
export type MarkContactConversationReadMutationFn = Apollo.MutationFunction<MarkContactConversationReadMutation, MarkContactConversationReadMutationVariables>;

/**
 * __useMarkContactConversationReadMutation__
 *
 * To run a mutation, you first call `useMarkContactConversationReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkContactConversationReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markContactConversationReadMutation, { data, loading, error }] = useMarkContactConversationReadMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMarkContactConversationReadMutation(baseOptions?: Apollo.MutationHookOptions<MarkContactConversationReadMutation, MarkContactConversationReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkContactConversationReadMutation, MarkContactConversationReadMutationVariables>(MarkContactConversationReadDocument, options);
      }
export type MarkContactConversationReadMutationHookResult = ReturnType<typeof useMarkContactConversationReadMutation>;
export type MarkContactConversationReadMutationResult = Apollo.MutationResult<MarkContactConversationReadMutation>;
export type MarkContactConversationReadMutationOptions = Apollo.BaseMutationOptions<MarkContactConversationReadMutation, MarkContactConversationReadMutationVariables>;
export const UploadImageDocument = gql`
    mutation uploadImage($input: String!) {
  uploadImage(input: $input) @rest(type: "FileUploadResponse", path: "/asset&contentType=image", method: "POST", bodySerializer: "imageEncode") {
    id
    token
    url
    user
    _links {
      self {
        rel
        url
      }
    }
    _created
    _updated
  }
}
    `;
export type UploadImageMutationFn = Apollo.MutationFunction<UploadImageMutation, UploadImageMutationVariables>;

/**
 * __useUploadImageMutation__
 *
 * To run a mutation, you first call `useUploadImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadImageMutation, { data, loading, error }] = useUploadImageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUploadImageMutation(baseOptions?: Apollo.MutationHookOptions<UploadImageMutation, UploadImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadImageMutation, UploadImageMutationVariables>(UploadImageDocument, options);
      }
export type UploadImageMutationHookResult = ReturnType<typeof useUploadImageMutation>;
export type UploadImageMutationResult = Apollo.MutationResult<UploadImageMutation>;
export type UploadImageMutationOptions = Apollo.BaseMutationOptions<UploadImageMutation, UploadImageMutationVariables>;
export const NetworksOfUserDocument = gql`
    query networksOfUser($userId: ID!, $search: String = "", $start: Int, $limit: Int) {
  networks(userId: $userId, search: $search, start: $start, limit: $limit) @rest(type: "Networks", path: "/user/{args.userId}/network{args.search}", method: "GET") {
    collection @type(name: "Network") {
      ...network
    }
    meta {
      range {
        from
        to
        total
      }
      sortOptions {
        key
        value
      }
    }
  }
}
    ${NetworkFragmentDoc}`;

/**
 * __useNetworksOfUserQuery__
 *
 * To run a query within a React component, call `useNetworksOfUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useNetworksOfUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNetworksOfUserQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      search: // value for 'search'
 *      start: // value for 'start'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useNetworksOfUserQuery(baseOptions: Apollo.QueryHookOptions<NetworksOfUserQuery, NetworksOfUserQueryVariables> & ({ variables: NetworksOfUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NetworksOfUserQuery, NetworksOfUserQueryVariables>(NetworksOfUserDocument, options);
      }
export function useNetworksOfUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NetworksOfUserQuery, NetworksOfUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NetworksOfUserQuery, NetworksOfUserQueryVariables>(NetworksOfUserDocument, options);
        }
// @ts-ignore
export function useNetworksOfUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<NetworksOfUserQuery, NetworksOfUserQueryVariables>): Apollo.UseSuspenseQueryResult<NetworksOfUserQuery, NetworksOfUserQueryVariables>;
export function useNetworksOfUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NetworksOfUserQuery, NetworksOfUserQueryVariables>): Apollo.UseSuspenseQueryResult<NetworksOfUserQuery | undefined, NetworksOfUserQueryVariables>;
export function useNetworksOfUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NetworksOfUserQuery, NetworksOfUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NetworksOfUserQuery, NetworksOfUserQueryVariables>(NetworksOfUserDocument, options);
        }
export type NetworksOfUserQueryHookResult = ReturnType<typeof useNetworksOfUserQuery>;
export type NetworksOfUserLazyQueryHookResult = ReturnType<typeof useNetworksOfUserLazyQuery>;
export type NetworksOfUserSuspenseQueryHookResult = ReturnType<typeof useNetworksOfUserSuspenseQuery>;
export type NetworksOfUserQueryResult = Apollo.QueryResult<NetworksOfUserQuery, NetworksOfUserQueryVariables>;
export const NetworksDocument = gql`
    query networks($userId: ID!, $search: String = "", $start: Int, $limit: Int) {
  networks(userId: $userId, search: $search, start: $start, limit: $limit) @rest(type: "Networks", path: "/my/{args.userId}/network{args.search}", method: "GET") {
    collection @type(name: "Network") {
      ...network
    }
    meta {
      range {
        from
        to
        total
      }
      sortOptions {
        key
        value
      }
    }
  }
}
    ${NetworkFragmentDoc}`;

/**
 * __useNetworksQuery__
 *
 * To run a query within a React component, call `useNetworksQuery` and pass it any options that fit your needs.
 * When your component renders, `useNetworksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNetworksQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      search: // value for 'search'
 *      start: // value for 'start'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useNetworksQuery(baseOptions: Apollo.QueryHookOptions<NetworksQuery, NetworksQueryVariables> & ({ variables: NetworksQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NetworksQuery, NetworksQueryVariables>(NetworksDocument, options);
      }
export function useNetworksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NetworksQuery, NetworksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NetworksQuery, NetworksQueryVariables>(NetworksDocument, options);
        }
// @ts-ignore
export function useNetworksSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<NetworksQuery, NetworksQueryVariables>): Apollo.UseSuspenseQueryResult<NetworksQuery, NetworksQueryVariables>;
export function useNetworksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NetworksQuery, NetworksQueryVariables>): Apollo.UseSuspenseQueryResult<NetworksQuery | undefined, NetworksQueryVariables>;
export function useNetworksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NetworksQuery, NetworksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NetworksQuery, NetworksQueryVariables>(NetworksDocument, options);
        }
export type NetworksQueryHookResult = ReturnType<typeof useNetworksQuery>;
export type NetworksLazyQueryHookResult = ReturnType<typeof useNetworksLazyQuery>;
export type NetworksSuspenseQueryHookResult = ReturnType<typeof useNetworksSuspenseQuery>;
export type NetworksQueryResult = Apollo.QueryResult<NetworksQuery, NetworksQueryVariables>;
export const NetworkDocument = gql`
    query network($userId: ID!, $networkId: ID!) {
  network(userId: $userId, networkId: $networkId) @rest(type: "Network", path: "/my/{args.userId}/network/{args.networkId}", method: "GET") {
    ...network
  }
}
    ${NetworkFragmentDoc}`;

/**
 * __useNetworkQuery__
 *
 * To run a query within a React component, call `useNetworkQuery` and pass it any options that fit your needs.
 * When your component renders, `useNetworkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNetworkQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      networkId: // value for 'networkId'
 *   },
 * });
 */
export function useNetworkQuery(baseOptions: Apollo.QueryHookOptions<NetworkQuery, NetworkQueryVariables> & ({ variables: NetworkQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NetworkQuery, NetworkQueryVariables>(NetworkDocument, options);
      }
export function useNetworkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NetworkQuery, NetworkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NetworkQuery, NetworkQueryVariables>(NetworkDocument, options);
        }
// @ts-ignore
export function useNetworkSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<NetworkQuery, NetworkQueryVariables>): Apollo.UseSuspenseQueryResult<NetworkQuery, NetworkQueryVariables>;
export function useNetworkSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NetworkQuery, NetworkQueryVariables>): Apollo.UseSuspenseQueryResult<NetworkQuery | undefined, NetworkQueryVariables>;
export function useNetworkSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NetworkQuery, NetworkQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NetworkQuery, NetworkQueryVariables>(NetworkDocument, options);
        }
export type NetworkQueryHookResult = ReturnType<typeof useNetworkQuery>;
export type NetworkLazyQueryHookResult = ReturnType<typeof useNetworkLazyQuery>;
export type NetworkSuspenseQueryHookResult = ReturnType<typeof useNetworkSuspenseQuery>;
export type NetworkQueryResult = Apollo.QueryResult<NetworkQuery, NetworkQueryVariables>;
export const PlaylistTalentsDocument = gql`
    query playlistTalents($userId: String!, $id: ID!, $start: Int, $limit: Int) {
  playlistTalents(userId: $userId, id: $id, start: $start, limit: $limit) @rest(type: "PlaylistTalentResponse", path: "/my/{args.userId}/playlist/{args.id}/object", method: "GET") {
    collection @type(name: "Talent") {
      ...talent
    }
    meta {
      range {
        from
        to
        total
      }
      sortOptions {
        key
        value
      }
    }
  }
}
    ${TalentFragmentDoc}`;

/**
 * __usePlaylistTalentsQuery__
 *
 * To run a query within a React component, call `usePlaylistTalentsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlaylistTalentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlaylistTalentsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      id: // value for 'id'
 *      start: // value for 'start'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function usePlaylistTalentsQuery(baseOptions: Apollo.QueryHookOptions<PlaylistTalentsQuery, PlaylistTalentsQueryVariables> & ({ variables: PlaylistTalentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlaylistTalentsQuery, PlaylistTalentsQueryVariables>(PlaylistTalentsDocument, options);
      }
export function usePlaylistTalentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlaylistTalentsQuery, PlaylistTalentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlaylistTalentsQuery, PlaylistTalentsQueryVariables>(PlaylistTalentsDocument, options);
        }
// @ts-ignore
export function usePlaylistTalentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PlaylistTalentsQuery, PlaylistTalentsQueryVariables>): Apollo.UseSuspenseQueryResult<PlaylistTalentsQuery, PlaylistTalentsQueryVariables>;
export function usePlaylistTalentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlaylistTalentsQuery, PlaylistTalentsQueryVariables>): Apollo.UseSuspenseQueryResult<PlaylistTalentsQuery | undefined, PlaylistTalentsQueryVariables>;
export function usePlaylistTalentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlaylistTalentsQuery, PlaylistTalentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PlaylistTalentsQuery, PlaylistTalentsQueryVariables>(PlaylistTalentsDocument, options);
        }
export type PlaylistTalentsQueryHookResult = ReturnType<typeof usePlaylistTalentsQuery>;
export type PlaylistTalentsLazyQueryHookResult = ReturnType<typeof usePlaylistTalentsLazyQuery>;
export type PlaylistTalentsSuspenseQueryHookResult = ReturnType<typeof usePlaylistTalentsSuspenseQuery>;
export type PlaylistTalentsQueryResult = Apollo.QueryResult<PlaylistTalentsQuery, PlaylistTalentsQueryVariables>;
export const PlaylistDocument = gql`
    query playlist($userId: String!, $id: String!) {
  playlist(userId: $userId, id: $id) @rest(type: "Playlist", path: "/my/{args.userId}/playlist/{args.id}", method: "GET") {
    ...playlist
  }
}
    ${PlaylistFragmentDoc}`;

/**
 * __usePlaylistQuery__
 *
 * To run a query within a React component, call `usePlaylistQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlaylistQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlaylistQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePlaylistQuery(baseOptions: Apollo.QueryHookOptions<PlaylistQuery, PlaylistQueryVariables> & ({ variables: PlaylistQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlaylistQuery, PlaylistQueryVariables>(PlaylistDocument, options);
      }
export function usePlaylistLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlaylistQuery, PlaylistQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlaylistQuery, PlaylistQueryVariables>(PlaylistDocument, options);
        }
// @ts-ignore
export function usePlaylistSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PlaylistQuery, PlaylistQueryVariables>): Apollo.UseSuspenseQueryResult<PlaylistQuery, PlaylistQueryVariables>;
export function usePlaylistSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlaylistQuery, PlaylistQueryVariables>): Apollo.UseSuspenseQueryResult<PlaylistQuery | undefined, PlaylistQueryVariables>;
export function usePlaylistSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlaylistQuery, PlaylistQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PlaylistQuery, PlaylistQueryVariables>(PlaylistDocument, options);
        }
export type PlaylistQueryHookResult = ReturnType<typeof usePlaylistQuery>;
export type PlaylistLazyQueryHookResult = ReturnType<typeof usePlaylistLazyQuery>;
export type PlaylistSuspenseQueryHookResult = ReturnType<typeof usePlaylistSuspenseQuery>;
export type PlaylistQueryResult = Apollo.QueryResult<PlaylistQuery, PlaylistQueryVariables>;
export const PlaylistsDocument = gql`
    query playlists($userId: String!, $start: Int, $limit: Int) {
  playlists(userId: $userId, start: $start, limit: $limit) @rest(type: "Playlists", path: "/my/{args.userId}/playlist", method: "GET") {
    collection @type(name: "Playlist") {
      ...playlist
    }
    meta {
      range {
        from
        to
        total
      }
      sortOptions {
        key
        value
      }
    }
  }
}
    ${PlaylistFragmentDoc}`;

/**
 * __usePlaylistsQuery__
 *
 * To run a query within a React component, call `usePlaylistsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlaylistsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlaylistsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      start: // value for 'start'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function usePlaylistsQuery(baseOptions: Apollo.QueryHookOptions<PlaylistsQuery, PlaylistsQueryVariables> & ({ variables: PlaylistsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlaylistsQuery, PlaylistsQueryVariables>(PlaylistsDocument, options);
      }
export function usePlaylistsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlaylistsQuery, PlaylistsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlaylistsQuery, PlaylistsQueryVariables>(PlaylistsDocument, options);
        }
// @ts-ignore
export function usePlaylistsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PlaylistsQuery, PlaylistsQueryVariables>): Apollo.UseSuspenseQueryResult<PlaylistsQuery, PlaylistsQueryVariables>;
export function usePlaylistsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlaylistsQuery, PlaylistsQueryVariables>): Apollo.UseSuspenseQueryResult<PlaylistsQuery | undefined, PlaylistsQueryVariables>;
export function usePlaylistsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlaylistsQuery, PlaylistsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PlaylistsQuery, PlaylistsQueryVariables>(PlaylistsDocument, options);
        }
export type PlaylistsQueryHookResult = ReturnType<typeof usePlaylistsQuery>;
export type PlaylistsLazyQueryHookResult = ReturnType<typeof usePlaylistsLazyQuery>;
export type PlaylistsSuspenseQueryHookResult = ReturnType<typeof usePlaylistsSuspenseQuery>;
export type PlaylistsQueryResult = Apollo.QueryResult<PlaylistsQuery, PlaylistsQueryVariables>;
export const AddPlaylistDocument = gql`
    mutation addPlaylist($input: PlaylistInput!) {
  addPlaylist(input: $input) @rest(type: "Playlist", path: "/playlist", method: "POST") {
    ...playlist
  }
}
    ${PlaylistFragmentDoc}`;
export type AddPlaylistMutationFn = Apollo.MutationFunction<AddPlaylistMutation, AddPlaylistMutationVariables>;

/**
 * __useAddPlaylistMutation__
 *
 * To run a mutation, you first call `useAddPlaylistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPlaylistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPlaylistMutation, { data, loading, error }] = useAddPlaylistMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddPlaylistMutation(baseOptions?: Apollo.MutationHookOptions<AddPlaylistMutation, AddPlaylistMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPlaylistMutation, AddPlaylistMutationVariables>(AddPlaylistDocument, options);
      }
export type AddPlaylistMutationHookResult = ReturnType<typeof useAddPlaylistMutation>;
export type AddPlaylistMutationResult = Apollo.MutationResult<AddPlaylistMutation>;
export type AddPlaylistMutationOptions = Apollo.BaseMutationOptions<AddPlaylistMutation, AddPlaylistMutationVariables>;
export const EditPlaylistDocument = gql`
    mutation editPlaylist($id: String!, $input: PlaylistInput!) {
  editPlaylist(id: $id, input: $input) @rest(type: "Playlist", path: "/playlist/{args.id}", method: "PATCH") {
    ...playlist
  }
}
    ${PlaylistFragmentDoc}`;
export type EditPlaylistMutationFn = Apollo.MutationFunction<EditPlaylistMutation, EditPlaylistMutationVariables>;

/**
 * __useEditPlaylistMutation__
 *
 * To run a mutation, you first call `useEditPlaylistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditPlaylistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editPlaylistMutation, { data, loading, error }] = useEditPlaylistMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditPlaylistMutation(baseOptions?: Apollo.MutationHookOptions<EditPlaylistMutation, EditPlaylistMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditPlaylistMutation, EditPlaylistMutationVariables>(EditPlaylistDocument, options);
      }
export type EditPlaylistMutationHookResult = ReturnType<typeof useEditPlaylistMutation>;
export type EditPlaylistMutationResult = Apollo.MutationResult<EditPlaylistMutation>;
export type EditPlaylistMutationOptions = Apollo.BaseMutationOptions<EditPlaylistMutation, EditPlaylistMutationVariables>;
export const DeletePlaylistDocument = gql`
    mutation deletePlaylist($id: String!) {
  deletePlaylist(id: $id) @rest(type: "Network", path: "/playlist/{args.id}", method: "DELETE")
}
    `;
export type DeletePlaylistMutationFn = Apollo.MutationFunction<DeletePlaylistMutation, DeletePlaylistMutationVariables>;

/**
 * __useDeletePlaylistMutation__
 *
 * To run a mutation, you first call `useDeletePlaylistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePlaylistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePlaylistMutation, { data, loading, error }] = useDeletePlaylistMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePlaylistMutation(baseOptions?: Apollo.MutationHookOptions<DeletePlaylistMutation, DeletePlaylistMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePlaylistMutation, DeletePlaylistMutationVariables>(DeletePlaylistDocument, options);
      }
export type DeletePlaylistMutationHookResult = ReturnType<typeof useDeletePlaylistMutation>;
export type DeletePlaylistMutationResult = Apollo.MutationResult<DeletePlaylistMutation>;
export type DeletePlaylistMutationOptions = Apollo.BaseMutationOptions<DeletePlaylistMutation, DeletePlaylistMutationVariables>;
export const AddTalentsToPlaylistDocument = gql`
    mutation addTalentsToPlaylist($id: String!, $talents: PlaylistTalentsInput!) {
  addTalentsToPlaylist(id: $id, input: $talents) @rest(type: "Playlist", path: "/playlist/{args.id}&method=LINK", method: "PUT") {
    ...playlist
  }
}
    ${PlaylistFragmentDoc}`;
export type AddTalentsToPlaylistMutationFn = Apollo.MutationFunction<AddTalentsToPlaylistMutation, AddTalentsToPlaylistMutationVariables>;

/**
 * __useAddTalentsToPlaylistMutation__
 *
 * To run a mutation, you first call `useAddTalentsToPlaylistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTalentsToPlaylistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTalentsToPlaylistMutation, { data, loading, error }] = useAddTalentsToPlaylistMutation({
 *   variables: {
 *      id: // value for 'id'
 *      talents: // value for 'talents'
 *   },
 * });
 */
export function useAddTalentsToPlaylistMutation(baseOptions?: Apollo.MutationHookOptions<AddTalentsToPlaylistMutation, AddTalentsToPlaylistMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddTalentsToPlaylistMutation, AddTalentsToPlaylistMutationVariables>(AddTalentsToPlaylistDocument, options);
      }
export type AddTalentsToPlaylistMutationHookResult = ReturnType<typeof useAddTalentsToPlaylistMutation>;
export type AddTalentsToPlaylistMutationResult = Apollo.MutationResult<AddTalentsToPlaylistMutation>;
export type AddTalentsToPlaylistMutationOptions = Apollo.BaseMutationOptions<AddTalentsToPlaylistMutation, AddTalentsToPlaylistMutationVariables>;
export const RemoveTalentsFromPlaylistDocument = gql`
    mutation removeTalentsFromPlaylist($id: String!, $talents: PlaylistTalentsInput!) {
  removeTalentsFromPlaylist(id: $id, input: $talents) @rest(type: "Playlist", path: "/playlist/{args.id}&method=UNLINK", method: "PUT") {
    ...playlist
  }
}
    ${PlaylistFragmentDoc}`;
export type RemoveTalentsFromPlaylistMutationFn = Apollo.MutationFunction<RemoveTalentsFromPlaylistMutation, RemoveTalentsFromPlaylistMutationVariables>;

/**
 * __useRemoveTalentsFromPlaylistMutation__
 *
 * To run a mutation, you first call `useRemoveTalentsFromPlaylistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveTalentsFromPlaylistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeTalentsFromPlaylistMutation, { data, loading, error }] = useRemoveTalentsFromPlaylistMutation({
 *   variables: {
 *      id: // value for 'id'
 *      talents: // value for 'talents'
 *   },
 * });
 */
export function useRemoveTalentsFromPlaylistMutation(baseOptions?: Apollo.MutationHookOptions<RemoveTalentsFromPlaylistMutation, RemoveTalentsFromPlaylistMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveTalentsFromPlaylistMutation, RemoveTalentsFromPlaylistMutationVariables>(RemoveTalentsFromPlaylistDocument, options);
      }
export type RemoveTalentsFromPlaylistMutationHookResult = ReturnType<typeof useRemoveTalentsFromPlaylistMutation>;
export type RemoveTalentsFromPlaylistMutationResult = Apollo.MutationResult<RemoveTalentsFromPlaylistMutation>;
export type RemoveTalentsFromPlaylistMutationOptions = Apollo.BaseMutationOptions<RemoveTalentsFromPlaylistMutation, RemoveTalentsFromPlaylistMutationVariables>;
export const IsTalentInNetworkDocument = gql`
    query isTalentInNetwork($talentId: ID!, $networkId: ID!) {
  isTalentInNetwork(talentId: $talentId, networkId: $networkId) @rest(type: "InNetworkState", path: "/my/{args.userId}/network/{args.networkId}/object/{args.talentId}", method: "GET") {
    state
  }
}
    `;

/**
 * __useIsTalentInNetworkQuery__
 *
 * To run a query within a React component, call `useIsTalentInNetworkQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsTalentInNetworkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsTalentInNetworkQuery({
 *   variables: {
 *      talentId: // value for 'talentId'
 *      networkId: // value for 'networkId'
 *   },
 * });
 */
export function useIsTalentInNetworkQuery(baseOptions: Apollo.QueryHookOptions<IsTalentInNetworkQuery, IsTalentInNetworkQueryVariables> & ({ variables: IsTalentInNetworkQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsTalentInNetworkQuery, IsTalentInNetworkQueryVariables>(IsTalentInNetworkDocument, options);
      }
export function useIsTalentInNetworkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsTalentInNetworkQuery, IsTalentInNetworkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsTalentInNetworkQuery, IsTalentInNetworkQueryVariables>(IsTalentInNetworkDocument, options);
        }
// @ts-ignore
export function useIsTalentInNetworkSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<IsTalentInNetworkQuery, IsTalentInNetworkQueryVariables>): Apollo.UseSuspenseQueryResult<IsTalentInNetworkQuery, IsTalentInNetworkQueryVariables>;
export function useIsTalentInNetworkSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IsTalentInNetworkQuery, IsTalentInNetworkQueryVariables>): Apollo.UseSuspenseQueryResult<IsTalentInNetworkQuery | undefined, IsTalentInNetworkQueryVariables>;
export function useIsTalentInNetworkSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IsTalentInNetworkQuery, IsTalentInNetworkQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IsTalentInNetworkQuery, IsTalentInNetworkQueryVariables>(IsTalentInNetworkDocument, options);
        }
export type IsTalentInNetworkQueryHookResult = ReturnType<typeof useIsTalentInNetworkQuery>;
export type IsTalentInNetworkLazyQueryHookResult = ReturnType<typeof useIsTalentInNetworkLazyQuery>;
export type IsTalentInNetworkSuspenseQueryHookResult = ReturnType<typeof useIsTalentInNetworkSuspenseQuery>;
export type IsTalentInNetworkQueryResult = Apollo.QueryResult<IsTalentInNetworkQuery, IsTalentInNetworkQueryVariables>;
export const MyspaceDocument = gql`
    query myspace {
  myspace @rest(type: "Network", path: "/makro/getmynetwork", method: "GET") {
    ...network
  }
}
    ${NetworkFragmentDoc}`;

/**
 * __useMyspaceQuery__
 *
 * To run a query within a React component, call `useMyspaceQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyspaceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyspaceQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyspaceQuery(baseOptions?: Apollo.QueryHookOptions<MyspaceQuery, MyspaceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyspaceQuery, MyspaceQueryVariables>(MyspaceDocument, options);
      }
export function useMyspaceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyspaceQuery, MyspaceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyspaceQuery, MyspaceQueryVariables>(MyspaceDocument, options);
        }
// @ts-ignore
export function useMyspaceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MyspaceQuery, MyspaceQueryVariables>): Apollo.UseSuspenseQueryResult<MyspaceQuery, MyspaceQueryVariables>;
export function useMyspaceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyspaceQuery, MyspaceQueryVariables>): Apollo.UseSuspenseQueryResult<MyspaceQuery | undefined, MyspaceQueryVariables>;
export function useMyspaceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyspaceQuery, MyspaceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyspaceQuery, MyspaceQueryVariables>(MyspaceDocument, options);
        }
export type MyspaceQueryHookResult = ReturnType<typeof useMyspaceQuery>;
export type MyspaceLazyQueryHookResult = ReturnType<typeof useMyspaceLazyQuery>;
export type MyspaceSuspenseQueryHookResult = ReturnType<typeof useMyspaceSuspenseQuery>;
export type MyspaceQueryResult = Apollo.QueryResult<MyspaceQuery, MyspaceQueryVariables>;
export const MyspaceTalentsDocument = gql`
    query myspaceTalents($query: String!, $start: Int, $limit: Int) {
  myspaceTalents(query: $query, start: $start, limit: $limit) @rest(type: "MySpaceTalentsResponse", path: "/makro/myplacetalents", method: "GET") {
    meta {
      range {
        from
        to
        total
      }
      sortOptions {
        key
        value
      }
    }
    collection {
      network @type(name: "Network") {
        ...network
      }
      talent @type(name: "Talent") {
        ...talent
      }
    }
  }
}
    ${NetworkFragmentDoc}
${TalentFragmentDoc}`;

/**
 * __useMyspaceTalentsQuery__
 *
 * To run a query within a React component, call `useMyspaceTalentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyspaceTalentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyspaceTalentsQuery({
 *   variables: {
 *      query: // value for 'query'
 *      start: // value for 'start'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useMyspaceTalentsQuery(baseOptions: Apollo.QueryHookOptions<MyspaceTalentsQuery, MyspaceTalentsQueryVariables> & ({ variables: MyspaceTalentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyspaceTalentsQuery, MyspaceTalentsQueryVariables>(MyspaceTalentsDocument, options);
      }
export function useMyspaceTalentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyspaceTalentsQuery, MyspaceTalentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyspaceTalentsQuery, MyspaceTalentsQueryVariables>(MyspaceTalentsDocument, options);
        }
// @ts-ignore
export function useMyspaceTalentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MyspaceTalentsQuery, MyspaceTalentsQueryVariables>): Apollo.UseSuspenseQueryResult<MyspaceTalentsQuery, MyspaceTalentsQueryVariables>;
export function useMyspaceTalentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyspaceTalentsQuery, MyspaceTalentsQueryVariables>): Apollo.UseSuspenseQueryResult<MyspaceTalentsQuery | undefined, MyspaceTalentsQueryVariables>;
export function useMyspaceTalentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyspaceTalentsQuery, MyspaceTalentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyspaceTalentsQuery, MyspaceTalentsQueryVariables>(MyspaceTalentsDocument, options);
        }
export type MyspaceTalentsQueryHookResult = ReturnType<typeof useMyspaceTalentsQuery>;
export type MyspaceTalentsLazyQueryHookResult = ReturnType<typeof useMyspaceTalentsLazyQuery>;
export type MyspaceTalentsSuspenseQueryHookResult = ReturnType<typeof useMyspaceTalentsSuspenseQuery>;
export type MyspaceTalentsQueryResult = Apollo.QueryResult<MyspaceTalentsQuery, MyspaceTalentsQueryVariables>;
export const NetworkUsersDocument = gql`
    query networkUsers($networkId: ID!, $start: Int, $limit: Int) {
  networkUsers(networkId: $networkId, start: $start, limit: $limit) @rest(type: "NetworkUsers", path: "/my/{args.userId}/network/{args.networkId}/user", method: "GET") {
    collection @type(name: "User") {
      ...user
      userMetaData {
        ...userMetadataResponse
      }
    }
    meta {
      range {
        from
        to
        total
      }
      sortOptions {
        key
        value
      }
    }
  }
}
    ${UserFragmentDoc}
${UserMetadataResponseFragmentDoc}`;

/**
 * __useNetworkUsersQuery__
 *
 * To run a query within a React component, call `useNetworkUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useNetworkUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNetworkUsersQuery({
 *   variables: {
 *      networkId: // value for 'networkId'
 *      start: // value for 'start'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useNetworkUsersQuery(baseOptions: Apollo.QueryHookOptions<NetworkUsersQuery, NetworkUsersQueryVariables> & ({ variables: NetworkUsersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NetworkUsersQuery, NetworkUsersQueryVariables>(NetworkUsersDocument, options);
      }
export function useNetworkUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NetworkUsersQuery, NetworkUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NetworkUsersQuery, NetworkUsersQueryVariables>(NetworkUsersDocument, options);
        }
// @ts-ignore
export function useNetworkUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<NetworkUsersQuery, NetworkUsersQueryVariables>): Apollo.UseSuspenseQueryResult<NetworkUsersQuery, NetworkUsersQueryVariables>;
export function useNetworkUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NetworkUsersQuery, NetworkUsersQueryVariables>): Apollo.UseSuspenseQueryResult<NetworkUsersQuery | undefined, NetworkUsersQueryVariables>;
export function useNetworkUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NetworkUsersQuery, NetworkUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NetworkUsersQuery, NetworkUsersQueryVariables>(NetworkUsersDocument, options);
        }
export type NetworkUsersQueryHookResult = ReturnType<typeof useNetworkUsersQuery>;
export type NetworkUsersLazyQueryHookResult = ReturnType<typeof useNetworkUsersLazyQuery>;
export type NetworkUsersSuspenseQueryHookResult = ReturnType<typeof useNetworkUsersSuspenseQuery>;
export type NetworkUsersQueryResult = Apollo.QueryResult<NetworkUsersQuery, NetworkUsersQueryVariables>;
export const NetworkFriendsDocument = gql`
    query networkFriends($userId: String!, $networkId: String!, $start: Int, $limit: Int) {
  networkFriends(
    userId: $userId
    networkId: $networkId
    start: $start
    limit: $limit
  ) @rest(type: "NetworkUsersResponse", path: "/my/{args.userId}/network/{args.networkId}/friend", method: "GET") {
    collection @type(name: "User") {
      ...user
    }
    meta {
      range {
        from
        to
        total
      }
      sortOptions {
        key
        value
      }
    }
  }
}
    ${UserFragmentDoc}`;

/**
 * __useNetworkFriendsQuery__
 *
 * To run a query within a React component, call `useNetworkFriendsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNetworkFriendsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNetworkFriendsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      networkId: // value for 'networkId'
 *      start: // value for 'start'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useNetworkFriendsQuery(baseOptions: Apollo.QueryHookOptions<NetworkFriendsQuery, NetworkFriendsQueryVariables> & ({ variables: NetworkFriendsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NetworkFriendsQuery, NetworkFriendsQueryVariables>(NetworkFriendsDocument, options);
      }
export function useNetworkFriendsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NetworkFriendsQuery, NetworkFriendsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NetworkFriendsQuery, NetworkFriendsQueryVariables>(NetworkFriendsDocument, options);
        }
// @ts-ignore
export function useNetworkFriendsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<NetworkFriendsQuery, NetworkFriendsQueryVariables>): Apollo.UseSuspenseQueryResult<NetworkFriendsQuery, NetworkFriendsQueryVariables>;
export function useNetworkFriendsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NetworkFriendsQuery, NetworkFriendsQueryVariables>): Apollo.UseSuspenseQueryResult<NetworkFriendsQuery | undefined, NetworkFriendsQueryVariables>;
export function useNetworkFriendsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NetworkFriendsQuery, NetworkFriendsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NetworkFriendsQuery, NetworkFriendsQueryVariables>(NetworkFriendsDocument, options);
        }
export type NetworkFriendsQueryHookResult = ReturnType<typeof useNetworkFriendsQuery>;
export type NetworkFriendsLazyQueryHookResult = ReturnType<typeof useNetworkFriendsLazyQuery>;
export type NetworkFriendsSuspenseQueryHookResult = ReturnType<typeof useNetworkFriendsSuspenseQuery>;
export type NetworkFriendsQueryResult = Apollo.QueryResult<NetworkFriendsQuery, NetworkFriendsQueryVariables>;
export const NetworkTalentsDocument = gql`
    query networkTalents($networkId: ID!, $start: Int, $limit: Int) {
  networkTalents(networkId: $networkId, start: $start, limit: $limit) {
    collection {
      ...talent
    }
    meta {
      range {
        from
        to
        total
      }
      sortOptions {
        key
        value
      }
    }
  }
}
    ${TalentFragmentDoc}`;

/**
 * __useNetworkTalentsQuery__
 *
 * To run a query within a React component, call `useNetworkTalentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNetworkTalentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNetworkTalentsQuery({
 *   variables: {
 *      networkId: // value for 'networkId'
 *      start: // value for 'start'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useNetworkTalentsQuery(baseOptions: Apollo.QueryHookOptions<NetworkTalentsQuery, NetworkTalentsQueryVariables> & ({ variables: NetworkTalentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NetworkTalentsQuery, NetworkTalentsQueryVariables>(NetworkTalentsDocument, options);
      }
export function useNetworkTalentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NetworkTalentsQuery, NetworkTalentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NetworkTalentsQuery, NetworkTalentsQueryVariables>(NetworkTalentsDocument, options);
        }
// @ts-ignore
export function useNetworkTalentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<NetworkTalentsQuery, NetworkTalentsQueryVariables>): Apollo.UseSuspenseQueryResult<NetworkTalentsQuery, NetworkTalentsQueryVariables>;
export function useNetworkTalentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NetworkTalentsQuery, NetworkTalentsQueryVariables>): Apollo.UseSuspenseQueryResult<NetworkTalentsQuery | undefined, NetworkTalentsQueryVariables>;
export function useNetworkTalentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NetworkTalentsQuery, NetworkTalentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NetworkTalentsQuery, NetworkTalentsQueryVariables>(NetworkTalentsDocument, options);
        }
export type NetworkTalentsQueryHookResult = ReturnType<typeof useNetworkTalentsQuery>;
export type NetworkTalentsLazyQueryHookResult = ReturnType<typeof useNetworkTalentsLazyQuery>;
export type NetworkTalentsSuspenseQueryHookResult = ReturnType<typeof useNetworkTalentsSuspenseQuery>;
export type NetworkTalentsQueryResult = Apollo.QueryResult<NetworkTalentsQuery, NetworkTalentsQueryVariables>;
export const AddNetworkDocument = gql`
    mutation addNetwork($input: NetworkInput!) {
  addNetwork(input: $input) @rest(type: "Network", path: "/network", method: "POST") {
    ...network
  }
}
    ${NetworkFragmentDoc}`;
export type AddNetworkMutationFn = Apollo.MutationFunction<AddNetworkMutation, AddNetworkMutationVariables>;

/**
 * __useAddNetworkMutation__
 *
 * To run a mutation, you first call `useAddNetworkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddNetworkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addNetworkMutation, { data, loading, error }] = useAddNetworkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddNetworkMutation(baseOptions?: Apollo.MutationHookOptions<AddNetworkMutation, AddNetworkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddNetworkMutation, AddNetworkMutationVariables>(AddNetworkDocument, options);
      }
export type AddNetworkMutationHookResult = ReturnType<typeof useAddNetworkMutation>;
export type AddNetworkMutationResult = Apollo.MutationResult<AddNetworkMutation>;
export type AddNetworkMutationOptions = Apollo.BaseMutationOptions<AddNetworkMutation, AddNetworkMutationVariables>;
export const EditNetworkDocument = gql`
    mutation editNetwork($id: ID!, $input: NetworkInput!) {
  editNetwork(id: $id, input: $input) @rest(type: "Network", path: "/network/{args.id}", method: "PATCH") {
    ...network
  }
}
    ${NetworkFragmentDoc}`;
export type EditNetworkMutationFn = Apollo.MutationFunction<EditNetworkMutation, EditNetworkMutationVariables>;

/**
 * __useEditNetworkMutation__
 *
 * To run a mutation, you first call `useEditNetworkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditNetworkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editNetworkMutation, { data, loading, error }] = useEditNetworkMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditNetworkMutation(baseOptions?: Apollo.MutationHookOptions<EditNetworkMutation, EditNetworkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditNetworkMutation, EditNetworkMutationVariables>(EditNetworkDocument, options);
      }
export type EditNetworkMutationHookResult = ReturnType<typeof useEditNetworkMutation>;
export type EditNetworkMutationResult = Apollo.MutationResult<EditNetworkMutation>;
export type EditNetworkMutationOptions = Apollo.BaseMutationOptions<EditNetworkMutation, EditNetworkMutationVariables>;
export const DeleteNetworkDocument = gql`
    mutation deleteNetwork($id: ID!) {
  deleteNetwork(id: $id) @rest(path: "/network/{args.id}", method: "DELETE")
}
    `;
export type DeleteNetworkMutationFn = Apollo.MutationFunction<DeleteNetworkMutation, DeleteNetworkMutationVariables>;

/**
 * __useDeleteNetworkMutation__
 *
 * To run a mutation, you first call `useDeleteNetworkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteNetworkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteNetworkMutation, { data, loading, error }] = useDeleteNetworkMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteNetworkMutation(baseOptions?: Apollo.MutationHookOptions<DeleteNetworkMutation, DeleteNetworkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteNetworkMutation, DeleteNetworkMutationVariables>(DeleteNetworkDocument, options);
      }
export type DeleteNetworkMutationHookResult = ReturnType<typeof useDeleteNetworkMutation>;
export type DeleteNetworkMutationResult = Apollo.MutationResult<DeleteNetworkMutation>;
export type DeleteNetworkMutationOptions = Apollo.BaseMutationOptions<DeleteNetworkMutation, DeleteNetworkMutationVariables>;
export const AddTalentsToNetworkDocument = gql`
    mutation addTalentsToNetwork($id: ID!, $talents: NetworkTalentsInput!) {
  addTalentsToNetwork(id: $id, input: $talents) @rest(type: "Network", path: "/network/{args.id}&method=LINK", method: "PUT") {
    ...network
  }
}
    ${NetworkFragmentDoc}`;
export type AddTalentsToNetworkMutationFn = Apollo.MutationFunction<AddTalentsToNetworkMutation, AddTalentsToNetworkMutationVariables>;

/**
 * __useAddTalentsToNetworkMutation__
 *
 * To run a mutation, you first call `useAddTalentsToNetworkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTalentsToNetworkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTalentsToNetworkMutation, { data, loading, error }] = useAddTalentsToNetworkMutation({
 *   variables: {
 *      id: // value for 'id'
 *      talents: // value for 'talents'
 *   },
 * });
 */
export function useAddTalentsToNetworkMutation(baseOptions?: Apollo.MutationHookOptions<AddTalentsToNetworkMutation, AddTalentsToNetworkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddTalentsToNetworkMutation, AddTalentsToNetworkMutationVariables>(AddTalentsToNetworkDocument, options);
      }
export type AddTalentsToNetworkMutationHookResult = ReturnType<typeof useAddTalentsToNetworkMutation>;
export type AddTalentsToNetworkMutationResult = Apollo.MutationResult<AddTalentsToNetworkMutation>;
export type AddTalentsToNetworkMutationOptions = Apollo.BaseMutationOptions<AddTalentsToNetworkMutation, AddTalentsToNetworkMutationVariables>;
export const AddUsersToNetworkDocument = gql`
    mutation addUsersToNetwork($id: ID!, $user: NetworkUsersInput!) {
  addUsersToNetwork(id: $id, input: $user) @rest(type: "Network", path: "/network/{args.id}&method=LINK", method: "PUT") {
    ...network
  }
}
    ${NetworkFragmentDoc}`;
export type AddUsersToNetworkMutationFn = Apollo.MutationFunction<AddUsersToNetworkMutation, AddUsersToNetworkMutationVariables>;

/**
 * __useAddUsersToNetworkMutation__
 *
 * To run a mutation, you first call `useAddUsersToNetworkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUsersToNetworkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUsersToNetworkMutation, { data, loading, error }] = useAddUsersToNetworkMutation({
 *   variables: {
 *      id: // value for 'id'
 *      user: // value for 'user'
 *   },
 * });
 */
export function useAddUsersToNetworkMutation(baseOptions?: Apollo.MutationHookOptions<AddUsersToNetworkMutation, AddUsersToNetworkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUsersToNetworkMutation, AddUsersToNetworkMutationVariables>(AddUsersToNetworkDocument, options);
      }
export type AddUsersToNetworkMutationHookResult = ReturnType<typeof useAddUsersToNetworkMutation>;
export type AddUsersToNetworkMutationResult = Apollo.MutationResult<AddUsersToNetworkMutation>;
export type AddUsersToNetworkMutationOptions = Apollo.BaseMutationOptions<AddUsersToNetworkMutation, AddUsersToNetworkMutationVariables>;
export const RemoveUserFromNetworkDocument = gql`
    mutation removeUserFromNetwork($id: ID!, $user: NetworkUsersInput!) {
  removeUserFromNetwork(id: $id, input: $user) @rest(type: "Network", path: "/network/{args.id}&method=UNLINK", method: "PUT") {
    ...network
  }
}
    ${NetworkFragmentDoc}`;
export type RemoveUserFromNetworkMutationFn = Apollo.MutationFunction<RemoveUserFromNetworkMutation, RemoveUserFromNetworkMutationVariables>;

/**
 * __useRemoveUserFromNetworkMutation__
 *
 * To run a mutation, you first call `useRemoveUserFromNetworkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUserFromNetworkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUserFromNetworkMutation, { data, loading, error }] = useRemoveUserFromNetworkMutation({
 *   variables: {
 *      id: // value for 'id'
 *      user: // value for 'user'
 *   },
 * });
 */
export function useRemoveUserFromNetworkMutation(baseOptions?: Apollo.MutationHookOptions<RemoveUserFromNetworkMutation, RemoveUserFromNetworkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveUserFromNetworkMutation, RemoveUserFromNetworkMutationVariables>(RemoveUserFromNetworkDocument, options);
      }
export type RemoveUserFromNetworkMutationHookResult = ReturnType<typeof useRemoveUserFromNetworkMutation>;
export type RemoveUserFromNetworkMutationResult = Apollo.MutationResult<RemoveUserFromNetworkMutation>;
export type RemoveUserFromNetworkMutationOptions = Apollo.BaseMutationOptions<RemoveUserFromNetworkMutation, RemoveUserFromNetworkMutationVariables>;
export const ToggleModDocument = gql`
    mutation toggleMod($id: String!, $networkId: String!, $idUserTarget: String!) {
  toggleMod(
    id: $id
    networkId: $networkId
    idUserTarget: $idUserTarget
    input: "💩"
  ) @rest(type: "Network", path: "/my/{args.id}/network/{args.networkId}/toggle_mod&idUserTarget={args.idUserTarget}", method: "PATCH", bodySerializer: "noBody") {
    id
  }
}
    `;
export type ToggleModMutationFn = Apollo.MutationFunction<ToggleModMutation, ToggleModMutationVariables>;

/**
 * __useToggleModMutation__
 *
 * To run a mutation, you first call `useToggleModMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleModMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleModMutation, { data, loading, error }] = useToggleModMutation({
 *   variables: {
 *      id: // value for 'id'
 *      networkId: // value for 'networkId'
 *      idUserTarget: // value for 'idUserTarget'
 *   },
 * });
 */
export function useToggleModMutation(baseOptions?: Apollo.MutationHookOptions<ToggleModMutation, ToggleModMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleModMutation, ToggleModMutationVariables>(ToggleModDocument, options);
      }
export type ToggleModMutationHookResult = ReturnType<typeof useToggleModMutation>;
export type ToggleModMutationResult = Apollo.MutationResult<ToggleModMutation>;
export type ToggleModMutationOptions = Apollo.BaseMutationOptions<ToggleModMutation, ToggleModMutationVariables>;
export const TransferOwnerDocument = gql`
    mutation transferOwner($id: String!, $networkId: String!, $idUserTarget: String!) {
  transferOwner(
    id: $id
    networkId: $networkId
    idUserTarget: $idUserTarget
    input: "💩"
  ) @rest(type: "Network", path: "/my/{args.id}/network/{args.networkId}/transfer_owner&idUserTarget={args.idUserTarget}", method: "PATCH", bodySerializer: "noBody") {
    id
  }
}
    `;
export type TransferOwnerMutationFn = Apollo.MutationFunction<TransferOwnerMutation, TransferOwnerMutationVariables>;

/**
 * __useTransferOwnerMutation__
 *
 * To run a mutation, you first call `useTransferOwnerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransferOwnerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transferOwnerMutation, { data, loading, error }] = useTransferOwnerMutation({
 *   variables: {
 *      id: // value for 'id'
 *      networkId: // value for 'networkId'
 *      idUserTarget: // value for 'idUserTarget'
 *   },
 * });
 */
export function useTransferOwnerMutation(baseOptions?: Apollo.MutationHookOptions<TransferOwnerMutation, TransferOwnerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TransferOwnerMutation, TransferOwnerMutationVariables>(TransferOwnerDocument, options);
      }
export type TransferOwnerMutationHookResult = ReturnType<typeof useTransferOwnerMutation>;
export type TransferOwnerMutationResult = Apollo.MutationResult<TransferOwnerMutation>;
export type TransferOwnerMutationOptions = Apollo.BaseMutationOptions<TransferOwnerMutation, TransferOwnerMutationVariables>;
export const RemoveTalentFromNetworkDocument = gql`
    mutation removeTalentFromNetwork($id: ID!, $talent: NetworkTalentsInput!) {
  removeTalentFromNetwork(id: $id, input: $talent) @rest(type: "Network", path: "/network/{args.id}&method=UNLINK", method: "PUT") {
    ...network
  }
}
    ${NetworkFragmentDoc}`;
export type RemoveTalentFromNetworkMutationFn = Apollo.MutationFunction<RemoveTalentFromNetworkMutation, RemoveTalentFromNetworkMutationVariables>;

/**
 * __useRemoveTalentFromNetworkMutation__
 *
 * To run a mutation, you first call `useRemoveTalentFromNetworkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveTalentFromNetworkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeTalentFromNetworkMutation, { data, loading, error }] = useRemoveTalentFromNetworkMutation({
 *   variables: {
 *      id: // value for 'id'
 *      talent: // value for 'talent'
 *   },
 * });
 */
export function useRemoveTalentFromNetworkMutation(baseOptions?: Apollo.MutationHookOptions<RemoveTalentFromNetworkMutation, RemoveTalentFromNetworkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveTalentFromNetworkMutation, RemoveTalentFromNetworkMutationVariables>(RemoveTalentFromNetworkDocument, options);
      }
export type RemoveTalentFromNetworkMutationHookResult = ReturnType<typeof useRemoveTalentFromNetworkMutation>;
export type RemoveTalentFromNetworkMutationResult = Apollo.MutationResult<RemoveTalentFromNetworkMutation>;
export type RemoveTalentFromNetworkMutationOptions = Apollo.BaseMutationOptions<RemoveTalentFromNetworkMutation, RemoveTalentFromNetworkMutationVariables>;
export const NetworkLinkImageDocument = gql`
    mutation networkLinkImage($url: String!, $networkId: String!) {
  networkLinkImage(input: {_links: {image: {url: $url}}}, networkId: $networkId) @rest(type: "Network", method: "PUT", path: "/network/{args.networkId}&method=LINK") {
    ...network
  }
}
    ${NetworkFragmentDoc}`;
export type NetworkLinkImageMutationFn = Apollo.MutationFunction<NetworkLinkImageMutation, NetworkLinkImageMutationVariables>;

/**
 * __useNetworkLinkImageMutation__
 *
 * To run a mutation, you first call `useNetworkLinkImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNetworkLinkImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [networkLinkImageMutation, { data, loading, error }] = useNetworkLinkImageMutation({
 *   variables: {
 *      url: // value for 'url'
 *      networkId: // value for 'networkId'
 *   },
 * });
 */
export function useNetworkLinkImageMutation(baseOptions?: Apollo.MutationHookOptions<NetworkLinkImageMutation, NetworkLinkImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NetworkLinkImageMutation, NetworkLinkImageMutationVariables>(NetworkLinkImageDocument, options);
      }
export type NetworkLinkImageMutationHookResult = ReturnType<typeof useNetworkLinkImageMutation>;
export type NetworkLinkImageMutationResult = Apollo.MutationResult<NetworkLinkImageMutation>;
export type NetworkLinkImageMutationOptions = Apollo.BaseMutationOptions<NetworkLinkImageMutation, NetworkLinkImageMutationVariables>;
export const NetworkUnlinkImageDocument = gql`
    mutation networkUnlinkImage($url: String!, $networkId: String!) {
  networkUnlinkImage(input: {_links: {image: {url: $url}}}, networkId: $networkId) @rest(type: "Network", method: "PUT", path: "/network/{args.networkId}&method=UNLINK") {
    ...network
  }
}
    ${NetworkFragmentDoc}`;
export type NetworkUnlinkImageMutationFn = Apollo.MutationFunction<NetworkUnlinkImageMutation, NetworkUnlinkImageMutationVariables>;

/**
 * __useNetworkUnlinkImageMutation__
 *
 * To run a mutation, you first call `useNetworkUnlinkImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNetworkUnlinkImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [networkUnlinkImageMutation, { data, loading, error }] = useNetworkUnlinkImageMutation({
 *   variables: {
 *      url: // value for 'url'
 *      networkId: // value for 'networkId'
 *   },
 * });
 */
export function useNetworkUnlinkImageMutation(baseOptions?: Apollo.MutationHookOptions<NetworkUnlinkImageMutation, NetworkUnlinkImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NetworkUnlinkImageMutation, NetworkUnlinkImageMutationVariables>(NetworkUnlinkImageDocument, options);
      }
export type NetworkUnlinkImageMutationHookResult = ReturnType<typeof useNetworkUnlinkImageMutation>;
export type NetworkUnlinkImageMutationResult = Apollo.MutationResult<NetworkUnlinkImageMutation>;
export type NetworkUnlinkImageMutationOptions = Apollo.BaseMutationOptions<NetworkUnlinkImageMutation, NetworkUnlinkImageMutationVariables>;
export const SearchNetworkDocument = gql`
    query searchNetwork($query: String!, $sort: String = "&sort=newestFirst", $start: Int, $limit: Int) {
  searchNetwork(query: $query, sort: $sort, start: $start, limit: $limit) @rest(type: "SearchNetworkCollection", path: "/network/search&query={args.query}{args.sort}", method: "GET") {
    meta {
      range {
        from
        to
        total
      }
      sortOptions {
        value
        key
      }
    }
    collection @type(name: "Network") {
      ...networkSearchResult
    }
  }
}
    ${NetworkSearchResultFragmentDoc}`;

/**
 * __useSearchNetworkQuery__
 *
 * To run a query within a React component, call `useSearchNetworkQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchNetworkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchNetworkQuery({
 *   variables: {
 *      query: // value for 'query'
 *      sort: // value for 'sort'
 *      start: // value for 'start'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useSearchNetworkQuery(baseOptions: Apollo.QueryHookOptions<SearchNetworkQuery, SearchNetworkQueryVariables> & ({ variables: SearchNetworkQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchNetworkQuery, SearchNetworkQueryVariables>(SearchNetworkDocument, options);
      }
export function useSearchNetworkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchNetworkQuery, SearchNetworkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchNetworkQuery, SearchNetworkQueryVariables>(SearchNetworkDocument, options);
        }
// @ts-ignore
export function useSearchNetworkSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchNetworkQuery, SearchNetworkQueryVariables>): Apollo.UseSuspenseQueryResult<SearchNetworkQuery, SearchNetworkQueryVariables>;
export function useSearchNetworkSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchNetworkQuery, SearchNetworkQueryVariables>): Apollo.UseSuspenseQueryResult<SearchNetworkQuery | undefined, SearchNetworkQueryVariables>;
export function useSearchNetworkSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchNetworkQuery, SearchNetworkQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchNetworkQuery, SearchNetworkQueryVariables>(SearchNetworkDocument, options);
        }
export type SearchNetworkQueryHookResult = ReturnType<typeof useSearchNetworkQuery>;
export type SearchNetworkLazyQueryHookResult = ReturnType<typeof useSearchNetworkLazyQuery>;
export type SearchNetworkSuspenseQueryHookResult = ReturnType<typeof useSearchNetworkSuspenseQuery>;
export type SearchNetworkQueryResult = Apollo.QueryResult<SearchNetworkQuery, SearchNetworkQueryVariables>;
export const JmtNetworksDocument = gql`
    query jmtNetworks {
  jmtNetworks @rest(type: "Network", path: "/makro/jmtnetworks", method: "GET") {
    JMTnetworks {
      collection @type(name: "Network") {
        ...jmtNetwork
      }
    }
  }
}
    ${JmtNetworkFragmentDoc}`;

/**
 * __useJmtNetworksQuery__
 *
 * To run a query within a React component, call `useJmtNetworksQuery` and pass it any options that fit your needs.
 * When your component renders, `useJmtNetworksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJmtNetworksQuery({
 *   variables: {
 *   },
 * });
 */
export function useJmtNetworksQuery(baseOptions?: Apollo.QueryHookOptions<JmtNetworksQuery, JmtNetworksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JmtNetworksQuery, JmtNetworksQueryVariables>(JmtNetworksDocument, options);
      }
export function useJmtNetworksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JmtNetworksQuery, JmtNetworksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JmtNetworksQuery, JmtNetworksQueryVariables>(JmtNetworksDocument, options);
        }
// @ts-ignore
export function useJmtNetworksSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<JmtNetworksQuery, JmtNetworksQueryVariables>): Apollo.UseSuspenseQueryResult<JmtNetworksQuery, JmtNetworksQueryVariables>;
export function useJmtNetworksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<JmtNetworksQuery, JmtNetworksQueryVariables>): Apollo.UseSuspenseQueryResult<JmtNetworksQuery | undefined, JmtNetworksQueryVariables>;
export function useJmtNetworksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<JmtNetworksQuery, JmtNetworksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<JmtNetworksQuery, JmtNetworksQueryVariables>(JmtNetworksDocument, options);
        }
export type JmtNetworksQueryHookResult = ReturnType<typeof useJmtNetworksQuery>;
export type JmtNetworksLazyQueryHookResult = ReturnType<typeof useJmtNetworksLazyQuery>;
export type JmtNetworksSuspenseQueryHookResult = ReturnType<typeof useJmtNetworksSuspenseQuery>;
export type JmtNetworksQueryResult = Apollo.QueryResult<JmtNetworksQuery, JmtNetworksQueryVariables>;
export const RelatedUsersFromMyNetworksDocument = gql`
    query relatedUsersFromMyNetworks($userId: ID!) {
  networks(userId: $userId) {
    collection {
      id
      caption
      description
      public
      open
      bugTrackerEnabled
      networkRoles
      image
      users {
        collection {
          ...user
          id
          userMetaData {
            ...userMetadataResponse
          }
        }
      }
    }
    meta {
      range {
        from
        to
        total
      }
      sortOptions {
        key
        value
      }
    }
  }
}
    ${UserFragmentDoc}
${UserMetadataResponseFragmentDoc}`;

/**
 * __useRelatedUsersFromMyNetworksQuery__
 *
 * To run a query within a React component, call `useRelatedUsersFromMyNetworksQuery` and pass it any options that fit your needs.
 * When your component renders, `useRelatedUsersFromMyNetworksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRelatedUsersFromMyNetworksQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useRelatedUsersFromMyNetworksQuery(baseOptions: Apollo.QueryHookOptions<RelatedUsersFromMyNetworksQuery, RelatedUsersFromMyNetworksQueryVariables> & ({ variables: RelatedUsersFromMyNetworksQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RelatedUsersFromMyNetworksQuery, RelatedUsersFromMyNetworksQueryVariables>(RelatedUsersFromMyNetworksDocument, options);
      }
export function useRelatedUsersFromMyNetworksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RelatedUsersFromMyNetworksQuery, RelatedUsersFromMyNetworksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RelatedUsersFromMyNetworksQuery, RelatedUsersFromMyNetworksQueryVariables>(RelatedUsersFromMyNetworksDocument, options);
        }
// @ts-ignore
export function useRelatedUsersFromMyNetworksSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RelatedUsersFromMyNetworksQuery, RelatedUsersFromMyNetworksQueryVariables>): Apollo.UseSuspenseQueryResult<RelatedUsersFromMyNetworksQuery, RelatedUsersFromMyNetworksQueryVariables>;
export function useRelatedUsersFromMyNetworksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RelatedUsersFromMyNetworksQuery, RelatedUsersFromMyNetworksQueryVariables>): Apollo.UseSuspenseQueryResult<RelatedUsersFromMyNetworksQuery | undefined, RelatedUsersFromMyNetworksQueryVariables>;
export function useRelatedUsersFromMyNetworksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RelatedUsersFromMyNetworksQuery, RelatedUsersFromMyNetworksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RelatedUsersFromMyNetworksQuery, RelatedUsersFromMyNetworksQueryVariables>(RelatedUsersFromMyNetworksDocument, options);
        }
export type RelatedUsersFromMyNetworksQueryHookResult = ReturnType<typeof useRelatedUsersFromMyNetworksQuery>;
export type RelatedUsersFromMyNetworksLazyQueryHookResult = ReturnType<typeof useRelatedUsersFromMyNetworksLazyQuery>;
export type RelatedUsersFromMyNetworksSuspenseQueryHookResult = ReturnType<typeof useRelatedUsersFromMyNetworksSuspenseQuery>;
export type RelatedUsersFromMyNetworksQueryResult = Apollo.QueryResult<RelatedUsersFromMyNetworksQuery, RelatedUsersFromMyNetworksQueryVariables>;
export const InvitationsDocument = gql`
    query invitations($limit: Int, $start: Int) {
  invitations(start: $start, limit: $limit) {
    meta {
      ...meta
    }
    collection {
      id
      targetUserId
      targetUser {
        ...user
      }
      message
      network {
        ...network
      }
      status
      type
      networkId
    }
  }
}
    ${MetaFragmentDoc}
${UserFragmentDoc}
${NetworkFragmentDoc}`;

/**
 * __useInvitationsQuery__
 *
 * To run a query within a React component, call `useInvitationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvitationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvitationsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      start: // value for 'start'
 *   },
 * });
 */
export function useInvitationsQuery(baseOptions?: Apollo.QueryHookOptions<InvitationsQuery, InvitationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvitationsQuery, InvitationsQueryVariables>(InvitationsDocument, options);
      }
export function useInvitationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvitationsQuery, InvitationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvitationsQuery, InvitationsQueryVariables>(InvitationsDocument, options);
        }
// @ts-ignore
export function useInvitationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InvitationsQuery, InvitationsQueryVariables>): Apollo.UseSuspenseQueryResult<InvitationsQuery, InvitationsQueryVariables>;
export function useInvitationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InvitationsQuery, InvitationsQueryVariables>): Apollo.UseSuspenseQueryResult<InvitationsQuery | undefined, InvitationsQueryVariables>;
export function useInvitationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InvitationsQuery, InvitationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InvitationsQuery, InvitationsQueryVariables>(InvitationsDocument, options);
        }
export type InvitationsQueryHookResult = ReturnType<typeof useInvitationsQuery>;
export type InvitationsLazyQueryHookResult = ReturnType<typeof useInvitationsLazyQuery>;
export type InvitationsSuspenseQueryHookResult = ReturnType<typeof useInvitationsSuspenseQuery>;
export type InvitationsQueryResult = Apollo.QueryResult<InvitationsQuery, InvitationsQueryVariables>;
export const InviteOrApplyToNetworkDocument = gql`
    mutation inviteOrApplyToNetwork($input: NetworkInvitationInput!) {
  inviteOrApplyToNetwork(input: $input) @rest(type: "NetworkInvitation", path: "/invitation", method: "POST") {
    networkId
    network @type(name: "Network") {
      ...network
    }
    targetUser @type(name: "User") {
      ...user
    }
    targetUserId
    type
    message
    status
  }
}
    ${NetworkFragmentDoc}
${UserFragmentDoc}`;
export type InviteOrApplyToNetworkMutationFn = Apollo.MutationFunction<InviteOrApplyToNetworkMutation, InviteOrApplyToNetworkMutationVariables>;

/**
 * __useInviteOrApplyToNetworkMutation__
 *
 * To run a mutation, you first call `useInviteOrApplyToNetworkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteOrApplyToNetworkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteOrApplyToNetworkMutation, { data, loading, error }] = useInviteOrApplyToNetworkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInviteOrApplyToNetworkMutation(baseOptions?: Apollo.MutationHookOptions<InviteOrApplyToNetworkMutation, InviteOrApplyToNetworkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InviteOrApplyToNetworkMutation, InviteOrApplyToNetworkMutationVariables>(InviteOrApplyToNetworkDocument, options);
      }
export type InviteOrApplyToNetworkMutationHookResult = ReturnType<typeof useInviteOrApplyToNetworkMutation>;
export type InviteOrApplyToNetworkMutationResult = Apollo.MutationResult<InviteOrApplyToNetworkMutation>;
export type InviteOrApplyToNetworkMutationOptions = Apollo.BaseMutationOptions<InviteOrApplyToNetworkMutation, InviteOrApplyToNetworkMutationVariables>;
export const AcceptOrDeclineNetworkInvitationDocument = gql`
    mutation acceptOrDeclineNetworkInvitation($id: ID!, $input: NetworkApplyAnswerInput!) {
  acceptOrDeclineNetworkInvitation(id: $id, input: $input) @rest(type: "NetworkInvitation", path: "/invitation/{args.id}", method: "PATCH") {
    networkId
    network @type(name: "Network") {
      ...network
    }
    targetUser @type(name: "User") {
      ...user
    }
    targetUserId
    type
    message
    status
  }
}
    ${NetworkFragmentDoc}
${UserFragmentDoc}`;
export type AcceptOrDeclineNetworkInvitationMutationFn = Apollo.MutationFunction<AcceptOrDeclineNetworkInvitationMutation, AcceptOrDeclineNetworkInvitationMutationVariables>;

/**
 * __useAcceptOrDeclineNetworkInvitationMutation__
 *
 * To run a mutation, you first call `useAcceptOrDeclineNetworkInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptOrDeclineNetworkInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptOrDeclineNetworkInvitationMutation, { data, loading, error }] = useAcceptOrDeclineNetworkInvitationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAcceptOrDeclineNetworkInvitationMutation(baseOptions?: Apollo.MutationHookOptions<AcceptOrDeclineNetworkInvitationMutation, AcceptOrDeclineNetworkInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptOrDeclineNetworkInvitationMutation, AcceptOrDeclineNetworkInvitationMutationVariables>(AcceptOrDeclineNetworkInvitationDocument, options);
      }
export type AcceptOrDeclineNetworkInvitationMutationHookResult = ReturnType<typeof useAcceptOrDeclineNetworkInvitationMutation>;
export type AcceptOrDeclineNetworkInvitationMutationResult = Apollo.MutationResult<AcceptOrDeclineNetworkInvitationMutation>;
export type AcceptOrDeclineNetworkInvitationMutationOptions = Apollo.BaseMutationOptions<AcceptOrDeclineNetworkInvitationMutation, AcceptOrDeclineNetworkInvitationMutationVariables>;
export const CreateNetworkTokenInvitationDocument = gql`
    mutation createNetworkTokenInvitation($userId: ID!, $networkId: ID!, $input: NetworkTokenInvitationInput!) {
  createNetworkTokenInvitation(
    input: $input
    networkId: $networkId
    userId: $userId
  ) @rest(type: "NetworkTokenInvitation", path: "/my/{args.userId}/network/{args.networkId}/invitation", method: "POST") {
    networkId
    network @type(name: "Network") {
      ...network
    }
    user @type(name: "User") {
      ...user
    }
    userId
    type
    tokens @type(name: "NetworkInvitationToken") {
      email
      token
    }
  }
}
    ${NetworkFragmentDoc}
${UserFragmentDoc}`;
export type CreateNetworkTokenInvitationMutationFn = Apollo.MutationFunction<CreateNetworkTokenInvitationMutation, CreateNetworkTokenInvitationMutationVariables>;

/**
 * __useCreateNetworkTokenInvitationMutation__
 *
 * To run a mutation, you first call `useCreateNetworkTokenInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNetworkTokenInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNetworkTokenInvitationMutation, { data, loading, error }] = useCreateNetworkTokenInvitationMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      networkId: // value for 'networkId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateNetworkTokenInvitationMutation(baseOptions?: Apollo.MutationHookOptions<CreateNetworkTokenInvitationMutation, CreateNetworkTokenInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateNetworkTokenInvitationMutation, CreateNetworkTokenInvitationMutationVariables>(CreateNetworkTokenInvitationDocument, options);
      }
export type CreateNetworkTokenInvitationMutationHookResult = ReturnType<typeof useCreateNetworkTokenInvitationMutation>;
export type CreateNetworkTokenInvitationMutationResult = Apollo.MutationResult<CreateNetworkTokenInvitationMutation>;
export type CreateNetworkTokenInvitationMutationOptions = Apollo.BaseMutationOptions<CreateNetworkTokenInvitationMutation, CreateNetworkTokenInvitationMutationVariables>;
export const JoinNetworkByTokenDocument = gql`
    mutation joinNetworkByToken($input: NetworkTokenInput!) {
  joinNetworkByToken(input: $input) @rest(type: "Network", path: "/user/doi", method: "POST") {
    ...network
  }
}
    ${NetworkFragmentDoc}`;
export type JoinNetworkByTokenMutationFn = Apollo.MutationFunction<JoinNetworkByTokenMutation, JoinNetworkByTokenMutationVariables>;

/**
 * __useJoinNetworkByTokenMutation__
 *
 * To run a mutation, you first call `useJoinNetworkByTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJoinNetworkByTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [joinNetworkByTokenMutation, { data, loading, error }] = useJoinNetworkByTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useJoinNetworkByTokenMutation(baseOptions?: Apollo.MutationHookOptions<JoinNetworkByTokenMutation, JoinNetworkByTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<JoinNetworkByTokenMutation, JoinNetworkByTokenMutationVariables>(JoinNetworkByTokenDocument, options);
      }
export type JoinNetworkByTokenMutationHookResult = ReturnType<typeof useJoinNetworkByTokenMutation>;
export type JoinNetworkByTokenMutationResult = Apollo.MutationResult<JoinNetworkByTokenMutation>;
export type JoinNetworkByTokenMutationOptions = Apollo.BaseMutationOptions<JoinNetworkByTokenMutation, JoinNetworkByTokenMutationVariables>;
export const ApplyNetworkWithTalentDocument = gql`
    mutation applyNetworkWithTalent($input: ApplyNetworkWithTalentInput) {
  applyNetworkWithTalent(input: $input) @rest(type: "MessageResponse", path: "/makro/applynetworkwithtalent", method: "POST") {
    message
  }
}
    `;
export type ApplyNetworkWithTalentMutationFn = Apollo.MutationFunction<ApplyNetworkWithTalentMutation, ApplyNetworkWithTalentMutationVariables>;

/**
 * __useApplyNetworkWithTalentMutation__
 *
 * To run a mutation, you first call `useApplyNetworkWithTalentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyNetworkWithTalentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyNetworkWithTalentMutation, { data, loading, error }] = useApplyNetworkWithTalentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApplyNetworkWithTalentMutation(baseOptions?: Apollo.MutationHookOptions<ApplyNetworkWithTalentMutation, ApplyNetworkWithTalentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApplyNetworkWithTalentMutation, ApplyNetworkWithTalentMutationVariables>(ApplyNetworkWithTalentDocument, options);
      }
export type ApplyNetworkWithTalentMutationHookResult = ReturnType<typeof useApplyNetworkWithTalentMutation>;
export type ApplyNetworkWithTalentMutationResult = Apollo.MutationResult<ApplyNetworkWithTalentMutation>;
export type ApplyNetworkWithTalentMutationOptions = Apollo.BaseMutationOptions<ApplyNetworkWithTalentMutation, ApplyNetworkWithTalentMutationVariables>;
export const InviteNetworkWithTalentDocument = gql`
    mutation inviteNetworkWithTalent($input: InviteNetworkWithTalentInput) {
  inviteNetworkWithTalent(input: $input) @rest(type: "MessageResponse", path: "/makro/invitenetworkwithtalent", method: "POST") {
    message
  }
}
    `;
export type InviteNetworkWithTalentMutationFn = Apollo.MutationFunction<InviteNetworkWithTalentMutation, InviteNetworkWithTalentMutationVariables>;

/**
 * __useInviteNetworkWithTalentMutation__
 *
 * To run a mutation, you first call `useInviteNetworkWithTalentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteNetworkWithTalentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteNetworkWithTalentMutation, { data, loading, error }] = useInviteNetworkWithTalentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInviteNetworkWithTalentMutation(baseOptions?: Apollo.MutationHookOptions<InviteNetworkWithTalentMutation, InviteNetworkWithTalentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InviteNetworkWithTalentMutation, InviteNetworkWithTalentMutationVariables>(InviteNetworkWithTalentDocument, options);
      }
export type InviteNetworkWithTalentMutationHookResult = ReturnType<typeof useInviteNetworkWithTalentMutation>;
export type InviteNetworkWithTalentMutationResult = Apollo.MutationResult<InviteNetworkWithTalentMutation>;
export type InviteNetworkWithTalentMutationOptions = Apollo.BaseMutationOptions<InviteNetworkWithTalentMutation, InviteNetworkWithTalentMutationVariables>;
export const RoleModelIdsDocument = gql`
    query roleModelIds {
  roleModelIds @rest(type: "Int", path: "/makro/rolemodelids")
}
    `;

/**
 * __useRoleModelIdsQuery__
 *
 * To run a query within a React component, call `useRoleModelIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRoleModelIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRoleModelIdsQuery({
 *   variables: {
 *   },
 * });
 */
export function useRoleModelIdsQuery(baseOptions?: Apollo.QueryHookOptions<RoleModelIdsQuery, RoleModelIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RoleModelIdsQuery, RoleModelIdsQueryVariables>(RoleModelIdsDocument, options);
      }
export function useRoleModelIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RoleModelIdsQuery, RoleModelIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RoleModelIdsQuery, RoleModelIdsQueryVariables>(RoleModelIdsDocument, options);
        }
// @ts-ignore
export function useRoleModelIdsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RoleModelIdsQuery, RoleModelIdsQueryVariables>): Apollo.UseSuspenseQueryResult<RoleModelIdsQuery, RoleModelIdsQueryVariables>;
export function useRoleModelIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RoleModelIdsQuery, RoleModelIdsQueryVariables>): Apollo.UseSuspenseQueryResult<RoleModelIdsQuery | undefined, RoleModelIdsQueryVariables>;
export function useRoleModelIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RoleModelIdsQuery, RoleModelIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RoleModelIdsQuery, RoleModelIdsQueryVariables>(RoleModelIdsDocument, options);
        }
export type RoleModelIdsQueryHookResult = ReturnType<typeof useRoleModelIdsQuery>;
export type RoleModelIdsLazyQueryHookResult = ReturnType<typeof useRoleModelIdsLazyQuery>;
export type RoleModelIdsSuspenseQueryHookResult = ReturnType<typeof useRoleModelIdsSuspenseQuery>;
export type RoleModelIdsQueryResult = Apollo.QueryResult<RoleModelIdsQuery, RoleModelIdsQueryVariables>;
export const TalentDocument = gql`
    query talent($userId: ID!, $talentId: ID!) {
  talent(userId: $userId, talentId: $talentId) @rest(type: "Talent", path: "/my/{args.userId}/object/{args.talentId}", method: "GET") {
    ...talent
  }
}
    ${TalentFragmentDoc}`;

/**
 * __useTalentQuery__
 *
 * To run a query within a React component, call `useTalentQuery` and pass it any options that fit your needs.
 * When your component renders, `useTalentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTalentQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      talentId: // value for 'talentId'
 *   },
 * });
 */
export function useTalentQuery(baseOptions: Apollo.QueryHookOptions<TalentQuery, TalentQueryVariables> & ({ variables: TalentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TalentQuery, TalentQueryVariables>(TalentDocument, options);
      }
export function useTalentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TalentQuery, TalentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TalentQuery, TalentQueryVariables>(TalentDocument, options);
        }
// @ts-ignore
export function useTalentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TalentQuery, TalentQueryVariables>): Apollo.UseSuspenseQueryResult<TalentQuery, TalentQueryVariables>;
export function useTalentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TalentQuery, TalentQueryVariables>): Apollo.UseSuspenseQueryResult<TalentQuery | undefined, TalentQueryVariables>;
export function useTalentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TalentQuery, TalentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TalentQuery, TalentQueryVariables>(TalentDocument, options);
        }
export type TalentQueryHookResult = ReturnType<typeof useTalentQuery>;
export type TalentLazyQueryHookResult = ReturnType<typeof useTalentLazyQuery>;
export type TalentSuspenseQueryHookResult = ReturnType<typeof useTalentSuspenseQuery>;
export type TalentQueryResult = Apollo.QueryResult<TalentQuery, TalentQueryVariables>;
export const SharedTalentDocument = gql`
    query sharedTalent($hash: ID!) {
  sharedTalent(hash: $hash) @rest(type: "SharedTalentResponse", path: "/makro/shareTalent/{args.hash}", method: "GET") {
    talent @type(name: "Talent") {
      ...sharedTalent
    }
    roleModel @type(name: "Talent") {
      ...sharedTalent
    }
    sharedRoleModel
    talentIds {
      dataViews {
        key
        values
      }
      key
    }
    talentHistory {
      date
      data
      id
      type
    }
    certificates {
      id
      club
      talentId
      image
      caption
      firstName
      player
      birthday
      lastName
      talentClass
      camp {
        caption
        campType
        end
        start
      }
      vote
    }
  }
}
    ${SharedTalentFragmentDoc}`;

/**
 * __useSharedTalentQuery__
 *
 * To run a query within a React component, call `useSharedTalentQuery` and pass it any options that fit your needs.
 * When your component renders, `useSharedTalentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSharedTalentQuery({
 *   variables: {
 *      hash: // value for 'hash'
 *   },
 * });
 */
export function useSharedTalentQuery(baseOptions: Apollo.QueryHookOptions<SharedTalentQuery, SharedTalentQueryVariables> & ({ variables: SharedTalentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SharedTalentQuery, SharedTalentQueryVariables>(SharedTalentDocument, options);
      }
export function useSharedTalentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SharedTalentQuery, SharedTalentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SharedTalentQuery, SharedTalentQueryVariables>(SharedTalentDocument, options);
        }
// @ts-ignore
export function useSharedTalentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SharedTalentQuery, SharedTalentQueryVariables>): Apollo.UseSuspenseQueryResult<SharedTalentQuery, SharedTalentQueryVariables>;
export function useSharedTalentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SharedTalentQuery, SharedTalentQueryVariables>): Apollo.UseSuspenseQueryResult<SharedTalentQuery | undefined, SharedTalentQueryVariables>;
export function useSharedTalentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SharedTalentQuery, SharedTalentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SharedTalentQuery, SharedTalentQueryVariables>(SharedTalentDocument, options);
        }
export type SharedTalentQueryHookResult = ReturnType<typeof useSharedTalentQuery>;
export type SharedTalentLazyQueryHookResult = ReturnType<typeof useSharedTalentLazyQuery>;
export type SharedTalentSuspenseQueryHookResult = ReturnType<typeof useSharedTalentSuspenseQuery>;
export type SharedTalentQueryResult = Apollo.QueryResult<SharedTalentQuery, SharedTalentQueryVariables>;
export const ListMyPersonificationsDocument = gql`
    query listMyPersonifications($userId: ID!, $start: Int, $limit: Int) {
  listMyPersonifications(userId: $userId, start: $start, limit: $limit) @rest(type: "NetworkTalentResponse", path: "/my/{args.userId}/user/{args.userId}/personification", method: "GET") {
    collection @type(name: "Talent") {
      ...talent
    }
    meta {
      range {
        from
        to
        total
      }
      sortOptions {
        key
        value
      }
    }
  }
}
    ${TalentFragmentDoc}`;

/**
 * __useListMyPersonificationsQuery__
 *
 * To run a query within a React component, call `useListMyPersonificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListMyPersonificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListMyPersonificationsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      start: // value for 'start'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useListMyPersonificationsQuery(baseOptions: Apollo.QueryHookOptions<ListMyPersonificationsQuery, ListMyPersonificationsQueryVariables> & ({ variables: ListMyPersonificationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListMyPersonificationsQuery, ListMyPersonificationsQueryVariables>(ListMyPersonificationsDocument, options);
      }
export function useListMyPersonificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListMyPersonificationsQuery, ListMyPersonificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListMyPersonificationsQuery, ListMyPersonificationsQueryVariables>(ListMyPersonificationsDocument, options);
        }
// @ts-ignore
export function useListMyPersonificationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListMyPersonificationsQuery, ListMyPersonificationsQueryVariables>): Apollo.UseSuspenseQueryResult<ListMyPersonificationsQuery, ListMyPersonificationsQueryVariables>;
export function useListMyPersonificationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListMyPersonificationsQuery, ListMyPersonificationsQueryVariables>): Apollo.UseSuspenseQueryResult<ListMyPersonificationsQuery | undefined, ListMyPersonificationsQueryVariables>;
export function useListMyPersonificationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListMyPersonificationsQuery, ListMyPersonificationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListMyPersonificationsQuery, ListMyPersonificationsQueryVariables>(ListMyPersonificationsDocument, options);
        }
export type ListMyPersonificationsQueryHookResult = ReturnType<typeof useListMyPersonificationsQuery>;
export type ListMyPersonificationsLazyQueryHookResult = ReturnType<typeof useListMyPersonificationsLazyQuery>;
export type ListMyPersonificationsSuspenseQueryHookResult = ReturnType<typeof useListMyPersonificationsSuspenseQuery>;
export type ListMyPersonificationsQueryResult = Apollo.QueryResult<ListMyPersonificationsQuery, ListMyPersonificationsQueryVariables>;
export const UserPersonificationDocument = gql`
    query userPersonification($userId: ID!, $start: Int, $limit: Int) {
  userPersonification(userId: $userId, start: $start, limit: $limit) @rest(type: "User", method: "GET", path: "/user/{args.userId}/personification") {
    collection @type(name: "Talent") {
      ...talent
    }
    meta {
      range {
        from
        to
        total
      }
      sortOptions {
        key
        value
      }
    }
  }
}
    ${TalentFragmentDoc}`;

/**
 * __useUserPersonificationQuery__
 *
 * To run a query within a React component, call `useUserPersonificationQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserPersonificationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserPersonificationQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      start: // value for 'start'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useUserPersonificationQuery(baseOptions: Apollo.QueryHookOptions<UserPersonificationQuery, UserPersonificationQueryVariables> & ({ variables: UserPersonificationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserPersonificationQuery, UserPersonificationQueryVariables>(UserPersonificationDocument, options);
      }
export function useUserPersonificationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserPersonificationQuery, UserPersonificationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserPersonificationQuery, UserPersonificationQueryVariables>(UserPersonificationDocument, options);
        }
// @ts-ignore
export function useUserPersonificationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserPersonificationQuery, UserPersonificationQueryVariables>): Apollo.UseSuspenseQueryResult<UserPersonificationQuery, UserPersonificationQueryVariables>;
export function useUserPersonificationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserPersonificationQuery, UserPersonificationQueryVariables>): Apollo.UseSuspenseQueryResult<UserPersonificationQuery | undefined, UserPersonificationQueryVariables>;
export function useUserPersonificationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserPersonificationQuery, UserPersonificationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserPersonificationQuery, UserPersonificationQueryVariables>(UserPersonificationDocument, options);
        }
export type UserPersonificationQueryHookResult = ReturnType<typeof useUserPersonificationQuery>;
export type UserPersonificationLazyQueryHookResult = ReturnType<typeof useUserPersonificationLazyQuery>;
export type UserPersonificationSuspenseQueryHookResult = ReturnType<typeof useUserPersonificationSuspenseQuery>;
export type UserPersonificationQueryResult = Apollo.QueryResult<UserPersonificationQuery, UserPersonificationQueryVariables>;
export const ListMyTalentsDocument = gql`
    query listMyTalents($userId: ID!, $start: Int, $limit: Int) {
  listMyTalents(userId: $userId, start: $start, limit: $limit) @rest(type: "NetworkMyTalentResponse", path: "/my/{args.userId}/object", method: "GET") {
    collection @type(name: "Talent") {
      ...talent
    }
    meta {
      range {
        from
        to
        total
      }
      sortOptions {
        key
        value
      }
    }
  }
}
    ${TalentFragmentDoc}`;

/**
 * __useListMyTalentsQuery__
 *
 * To run a query within a React component, call `useListMyTalentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListMyTalentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListMyTalentsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      start: // value for 'start'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useListMyTalentsQuery(baseOptions: Apollo.QueryHookOptions<ListMyTalentsQuery, ListMyTalentsQueryVariables> & ({ variables: ListMyTalentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListMyTalentsQuery, ListMyTalentsQueryVariables>(ListMyTalentsDocument, options);
      }
export function useListMyTalentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListMyTalentsQuery, ListMyTalentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListMyTalentsQuery, ListMyTalentsQueryVariables>(ListMyTalentsDocument, options);
        }
// @ts-ignore
export function useListMyTalentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListMyTalentsQuery, ListMyTalentsQueryVariables>): Apollo.UseSuspenseQueryResult<ListMyTalentsQuery, ListMyTalentsQueryVariables>;
export function useListMyTalentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListMyTalentsQuery, ListMyTalentsQueryVariables>): Apollo.UseSuspenseQueryResult<ListMyTalentsQuery | undefined, ListMyTalentsQueryVariables>;
export function useListMyTalentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListMyTalentsQuery, ListMyTalentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListMyTalentsQuery, ListMyTalentsQueryVariables>(ListMyTalentsDocument, options);
        }
export type ListMyTalentsQueryHookResult = ReturnType<typeof useListMyTalentsQuery>;
export type ListMyTalentsLazyQueryHookResult = ReturnType<typeof useListMyTalentsLazyQuery>;
export type ListMyTalentsSuspenseQueryHookResult = ReturnType<typeof useListMyTalentsSuspenseQuery>;
export type ListMyTalentsQueryResult = Apollo.QueryResult<ListMyTalentsQuery, ListMyTalentsQueryVariables>;
export const TalentClassDocument = gql`
    query talentClass($id: ID!) {
  talentClass(id: $id) @rest(type: "TalentClass", path: "/class/{args.id}", method: "GET") {
    id
    dataViews {
      id
      chartType
      withGroupLabels
      withLabelHover
      backgroundColor
      borderColor
      textColor
      caption
      voteScalarGroups {
        scalars {
          caption
          formula
          offset
        }
      }
    }
  }
}
    `;

/**
 * __useTalentClassQuery__
 *
 * To run a query within a React component, call `useTalentClassQuery` and pass it any options that fit your needs.
 * When your component renders, `useTalentClassQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTalentClassQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTalentClassQuery(baseOptions: Apollo.QueryHookOptions<TalentClassQuery, TalentClassQueryVariables> & ({ variables: TalentClassQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TalentClassQuery, TalentClassQueryVariables>(TalentClassDocument, options);
      }
export function useTalentClassLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TalentClassQuery, TalentClassQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TalentClassQuery, TalentClassQueryVariables>(TalentClassDocument, options);
        }
// @ts-ignore
export function useTalentClassSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TalentClassQuery, TalentClassQueryVariables>): Apollo.UseSuspenseQueryResult<TalentClassQuery, TalentClassQueryVariables>;
export function useTalentClassSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TalentClassQuery, TalentClassQueryVariables>): Apollo.UseSuspenseQueryResult<TalentClassQuery | undefined, TalentClassQueryVariables>;
export function useTalentClassSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TalentClassQuery, TalentClassQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TalentClassQuery, TalentClassQueryVariables>(TalentClassDocument, options);
        }
export type TalentClassQueryHookResult = ReturnType<typeof useTalentClassQuery>;
export type TalentClassLazyQueryHookResult = ReturnType<typeof useTalentClassLazyQuery>;
export type TalentClassSuspenseQueryHookResult = ReturnType<typeof useTalentClassSuspenseQuery>;
export type TalentClassQueryResult = Apollo.QueryResult<TalentClassQuery, TalentClassQueryVariables>;
export const SuggestTalentDocument = gql`
    query suggestTalent($q: String!) {
  suggestTalent(q: $q) @rest(type: "SuggestUser", path: "/object/suggest?q={args.q}", method: "GET") {
    name
  }
}
    `;

/**
 * __useSuggestTalentQuery__
 *
 * To run a query within a React component, call `useSuggestTalentQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuggestTalentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuggestTalentQuery({
 *   variables: {
 *      q: // value for 'q'
 *   },
 * });
 */
export function useSuggestTalentQuery(baseOptions: Apollo.QueryHookOptions<SuggestTalentQuery, SuggestTalentQueryVariables> & ({ variables: SuggestTalentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SuggestTalentQuery, SuggestTalentQueryVariables>(SuggestTalentDocument, options);
      }
export function useSuggestTalentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SuggestTalentQuery, SuggestTalentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SuggestTalentQuery, SuggestTalentQueryVariables>(SuggestTalentDocument, options);
        }
// @ts-ignore
export function useSuggestTalentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SuggestTalentQuery, SuggestTalentQueryVariables>): Apollo.UseSuspenseQueryResult<SuggestTalentQuery, SuggestTalentQueryVariables>;
export function useSuggestTalentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SuggestTalentQuery, SuggestTalentQueryVariables>): Apollo.UseSuspenseQueryResult<SuggestTalentQuery | undefined, SuggestTalentQueryVariables>;
export function useSuggestTalentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SuggestTalentQuery, SuggestTalentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SuggestTalentQuery, SuggestTalentQueryVariables>(SuggestTalentDocument, options);
        }
export type SuggestTalentQueryHookResult = ReturnType<typeof useSuggestTalentQuery>;
export type SuggestTalentLazyQueryHookResult = ReturnType<typeof useSuggestTalentLazyQuery>;
export type SuggestTalentSuspenseQueryHookResult = ReturnType<typeof useSuggestTalentSuspenseQuery>;
export type SuggestTalentQueryResult = Apollo.QueryResult<SuggestTalentQuery, SuggestTalentQueryVariables>;
export const SearchTalentDocument = gql`
    query searchTalent($query: String!, $sort: String = "&sort=newestFirst", $ageFrom: Int, $ageTo: Int, $classId: String = "", $fieldPosition: String = "", $fifaCountry: String = "", $yearFrom: Int, $yearTo: Int, $networkId: String = "", $start: Int, $limit: Int) {
  searchTalent(
    query: $query
    sort: $sort
    ageFrom: $ageFrom
    ageTo: $ageTo
    classId: $classId
    fieldPosition: $fieldPosition
    fifaCountry: $fifaCountry
    yearFrom: $yearFrom
    yearTo: $yearTo
    networkId: $networkId
    start: $start
    limit: $limit
  ) @rest(type: "SearchTalent", path: "/network/{args.networkId}/object/search&query={args.query}{args.sort}{args.age}{args.classId}{args.fieldPosition}{args.fifaCountry}{args.yearFrom}{args.yearTo}", method: "GET") {
    meta {
      range {
        from
        to
        total
      }
      sortOptions {
        key
        value
      }
    }
    collection @type(name: "Talent") {
      ...talent
    }
  }
}
    ${TalentFragmentDoc}`;

/**
 * __useSearchTalentQuery__
 *
 * To run a query within a React component, call `useSearchTalentQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchTalentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchTalentQuery({
 *   variables: {
 *      query: // value for 'query'
 *      sort: // value for 'sort'
 *      ageFrom: // value for 'ageFrom'
 *      ageTo: // value for 'ageTo'
 *      classId: // value for 'classId'
 *      fieldPosition: // value for 'fieldPosition'
 *      fifaCountry: // value for 'fifaCountry'
 *      yearFrom: // value for 'yearFrom'
 *      yearTo: // value for 'yearTo'
 *      networkId: // value for 'networkId'
 *      start: // value for 'start'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useSearchTalentQuery(baseOptions: Apollo.QueryHookOptions<SearchTalentQuery, SearchTalentQueryVariables> & ({ variables: SearchTalentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchTalentQuery, SearchTalentQueryVariables>(SearchTalentDocument, options);
      }
export function useSearchTalentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchTalentQuery, SearchTalentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchTalentQuery, SearchTalentQueryVariables>(SearchTalentDocument, options);
        }
// @ts-ignore
export function useSearchTalentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchTalentQuery, SearchTalentQueryVariables>): Apollo.UseSuspenseQueryResult<SearchTalentQuery, SearchTalentQueryVariables>;
export function useSearchTalentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchTalentQuery, SearchTalentQueryVariables>): Apollo.UseSuspenseQueryResult<SearchTalentQuery | undefined, SearchTalentQueryVariables>;
export function useSearchTalentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchTalentQuery, SearchTalentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchTalentQuery, SearchTalentQueryVariables>(SearchTalentDocument, options);
        }
export type SearchTalentQueryHookResult = ReturnType<typeof useSearchTalentQuery>;
export type SearchTalentLazyQueryHookResult = ReturnType<typeof useSearchTalentLazyQuery>;
export type SearchTalentSuspenseQueryHookResult = ReturnType<typeof useSearchTalentSuspenseQuery>;
export type SearchTalentQueryResult = Apollo.QueryResult<SearchTalentQuery, SearchTalentQueryVariables>;
export const TalentJoinMarketplaceDocument = gql`
    mutation talentJoinMarketplace {
  talentJoinMarketplace(input: "💩") @rest(type: "Network", method: "POST", path: "/makro/joinmarketplacewithtalent", bodySerializer: "noBody") {
    ...network
  }
}
    ${NetworkFragmentDoc}`;
export type TalentJoinMarketplaceMutationFn = Apollo.MutationFunction<TalentJoinMarketplaceMutation, TalentJoinMarketplaceMutationVariables>;

/**
 * __useTalentJoinMarketplaceMutation__
 *
 * To run a mutation, you first call `useTalentJoinMarketplaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTalentJoinMarketplaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [talentJoinMarketplaceMutation, { data, loading, error }] = useTalentJoinMarketplaceMutation({
 *   variables: {
 *   },
 * });
 */
export function useTalentJoinMarketplaceMutation(baseOptions?: Apollo.MutationHookOptions<TalentJoinMarketplaceMutation, TalentJoinMarketplaceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TalentJoinMarketplaceMutation, TalentJoinMarketplaceMutationVariables>(TalentJoinMarketplaceDocument, options);
      }
export type TalentJoinMarketplaceMutationHookResult = ReturnType<typeof useTalentJoinMarketplaceMutation>;
export type TalentJoinMarketplaceMutationResult = Apollo.MutationResult<TalentJoinMarketplaceMutation>;
export type TalentJoinMarketplaceMutationOptions = Apollo.BaseMutationOptions<TalentJoinMarketplaceMutation, TalentJoinMarketplaceMutationVariables>;
export const CreateTalentDocument = gql`
    mutation createTalent($classId: String!, $input: TalentInput!) {
  saveTalent(classId: $classId, input: $input) @rest(type: "Talent", path: "/class/{args.classId}/object", method: "POST") {
    ...talent
  }
}
    ${TalentFragmentDoc}`;
export type CreateTalentMutationFn = Apollo.MutationFunction<CreateTalentMutation, CreateTalentMutationVariables>;

/**
 * __useCreateTalentMutation__
 *
 * To run a mutation, you first call `useCreateTalentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTalentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTalentMutation, { data, loading, error }] = useCreateTalentMutation({
 *   variables: {
 *      classId: // value for 'classId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTalentMutation(baseOptions?: Apollo.MutationHookOptions<CreateTalentMutation, CreateTalentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTalentMutation, CreateTalentMutationVariables>(CreateTalentDocument, options);
      }
export type CreateTalentMutationHookResult = ReturnType<typeof useCreateTalentMutation>;
export type CreateTalentMutationResult = Apollo.MutationResult<CreateTalentMutation>;
export type CreateTalentMutationOptions = Apollo.BaseMutationOptions<CreateTalentMutation, CreateTalentMutationVariables>;
export const UpdateTalentDocument = gql`
    mutation updateTalent($input: TalentInput!, $talentId: String!) {
  saveTalent(input: $input, talentId: $talentId) @rest(type: "Talent", path: "/object/{args.talentId}", method: "PATCH") {
    ...talent
  }
}
    ${TalentFragmentDoc}`;
export type UpdateTalentMutationFn = Apollo.MutationFunction<UpdateTalentMutation, UpdateTalentMutationVariables>;

/**
 * __useUpdateTalentMutation__
 *
 * To run a mutation, you first call `useUpdateTalentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTalentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTalentMutation, { data, loading, error }] = useUpdateTalentMutation({
 *   variables: {
 *      input: // value for 'input'
 *      talentId: // value for 'talentId'
 *   },
 * });
 */
export function useUpdateTalentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTalentMutation, UpdateTalentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTalentMutation, UpdateTalentMutationVariables>(UpdateTalentDocument, options);
      }
export type UpdateTalentMutationHookResult = ReturnType<typeof useUpdateTalentMutation>;
export type UpdateTalentMutationResult = Apollo.MutationResult<UpdateTalentMutation>;
export type UpdateTalentMutationOptions = Apollo.BaseMutationOptions<UpdateTalentMutation, UpdateTalentMutationVariables>;
export const TalentLinkImageDocument = gql`
    mutation talentLinkImage($url: String!, $talentId: String!) {
  talentLinkImage(input: {_links: {image: {url: $url}}}, talentId: $talentId) @rest(type: "Talent", method: "PUT", path: "/object/{args.talentId}&method=LINK") {
    ...talent
  }
}
    ${TalentFragmentDoc}`;
export type TalentLinkImageMutationFn = Apollo.MutationFunction<TalentLinkImageMutation, TalentLinkImageMutationVariables>;

/**
 * __useTalentLinkImageMutation__
 *
 * To run a mutation, you first call `useTalentLinkImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTalentLinkImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [talentLinkImageMutation, { data, loading, error }] = useTalentLinkImageMutation({
 *   variables: {
 *      url: // value for 'url'
 *      talentId: // value for 'talentId'
 *   },
 * });
 */
export function useTalentLinkImageMutation(baseOptions?: Apollo.MutationHookOptions<TalentLinkImageMutation, TalentLinkImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TalentLinkImageMutation, TalentLinkImageMutationVariables>(TalentLinkImageDocument, options);
      }
export type TalentLinkImageMutationHookResult = ReturnType<typeof useTalentLinkImageMutation>;
export type TalentLinkImageMutationResult = Apollo.MutationResult<TalentLinkImageMutation>;
export type TalentLinkImageMutationOptions = Apollo.BaseMutationOptions<TalentLinkImageMutation, TalentLinkImageMutationVariables>;
export const TalentUnlinkImageDocument = gql`
    mutation talentUnlinkImage($url: String!, $talentId: String!) {
  talentUnlinkImage(input: {_links: {image: {url: $url}}}, talentId: $talentId) @rest(type: "Talent", method: "PUT", path: "/object/{args.talentId}&method=UNLINK") {
    ...talent
  }
}
    ${TalentFragmentDoc}`;
export type TalentUnlinkImageMutationFn = Apollo.MutationFunction<TalentUnlinkImageMutation, TalentUnlinkImageMutationVariables>;

/**
 * __useTalentUnlinkImageMutation__
 *
 * To run a mutation, you first call `useTalentUnlinkImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTalentUnlinkImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [talentUnlinkImageMutation, { data, loading, error }] = useTalentUnlinkImageMutation({
 *   variables: {
 *      url: // value for 'url'
 *      talentId: // value for 'talentId'
 *   },
 * });
 */
export function useTalentUnlinkImageMutation(baseOptions?: Apollo.MutationHookOptions<TalentUnlinkImageMutation, TalentUnlinkImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TalentUnlinkImageMutation, TalentUnlinkImageMutationVariables>(TalentUnlinkImageDocument, options);
      }
export type TalentUnlinkImageMutationHookResult = ReturnType<typeof useTalentUnlinkImageMutation>;
export type TalentUnlinkImageMutationResult = Apollo.MutationResult<TalentUnlinkImageMutation>;
export type TalentUnlinkImageMutationOptions = Apollo.BaseMutationOptions<TalentUnlinkImageMutation, TalentUnlinkImageMutationVariables>;
export const CreateTalentCustomMetaDocument = gql`
    mutation createTalentCustomMeta($input: TalentCustomMetaInput!, $talentId: String!) {
  saveTalentCustomMeta(talentId: $talentId, input: $input) @rest(type: "TalentCustomMeta", method: "POST", path: "/object/{args.talentId}/custom-meta-data&json2json=true", bodySerializer: "talentCustomMeta") {
    id
    foot
    club
    team
    height
    weight
    status
  }
}
    `;
export type CreateTalentCustomMetaMutationFn = Apollo.MutationFunction<CreateTalentCustomMetaMutation, CreateTalentCustomMetaMutationVariables>;

/**
 * __useCreateTalentCustomMetaMutation__
 *
 * To run a mutation, you first call `useCreateTalentCustomMetaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTalentCustomMetaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTalentCustomMetaMutation, { data, loading, error }] = useCreateTalentCustomMetaMutation({
 *   variables: {
 *      input: // value for 'input'
 *      talentId: // value for 'talentId'
 *   },
 * });
 */
export function useCreateTalentCustomMetaMutation(baseOptions?: Apollo.MutationHookOptions<CreateTalentCustomMetaMutation, CreateTalentCustomMetaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTalentCustomMetaMutation, CreateTalentCustomMetaMutationVariables>(CreateTalentCustomMetaDocument, options);
      }
export type CreateTalentCustomMetaMutationHookResult = ReturnType<typeof useCreateTalentCustomMetaMutation>;
export type CreateTalentCustomMetaMutationResult = Apollo.MutationResult<CreateTalentCustomMetaMutation>;
export type CreateTalentCustomMetaMutationOptions = Apollo.BaseMutationOptions<CreateTalentCustomMetaMutation, CreateTalentCustomMetaMutationVariables>;
export const UpdateTalentCustomMetaDocument = gql`
    mutation updateTalentCustomMeta($input: TalentCustomMetaInput!, $talentId: String!, $metaDataId: String!) {
  saveTalentCustomMeta(
    talentId: $talentId
    input: $input
    metaDataId: $metaDataId
  ) @rest(type: "TalentCustomMeta", method: "PATCH", path: "/object/{args.talentId}/custom-meta-data/{args.metaDataId}&json2json=true", bodySerializer: "talentCustomMeta") {
    id
    foot
    club
    team
    height
    weight
    status
  }
}
    `;
export type UpdateTalentCustomMetaMutationFn = Apollo.MutationFunction<UpdateTalentCustomMetaMutation, UpdateTalentCustomMetaMutationVariables>;

/**
 * __useUpdateTalentCustomMetaMutation__
 *
 * To run a mutation, you first call `useUpdateTalentCustomMetaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTalentCustomMetaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTalentCustomMetaMutation, { data, loading, error }] = useUpdateTalentCustomMetaMutation({
 *   variables: {
 *      input: // value for 'input'
 *      talentId: // value for 'talentId'
 *      metaDataId: // value for 'metaDataId'
 *   },
 * });
 */
export function useUpdateTalentCustomMetaMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTalentCustomMetaMutation, UpdateTalentCustomMetaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTalentCustomMetaMutation, UpdateTalentCustomMetaMutationVariables>(UpdateTalentCustomMetaDocument, options);
      }
export type UpdateTalentCustomMetaMutationHookResult = ReturnType<typeof useUpdateTalentCustomMetaMutation>;
export type UpdateTalentCustomMetaMutationResult = Apollo.MutationResult<UpdateTalentCustomMetaMutation>;
export type UpdateTalentCustomMetaMutationOptions = Apollo.BaseMutationOptions<UpdateTalentCustomMetaMutation, UpdateTalentCustomMetaMutationVariables>;
export const TalentLinkUserDocument = gql`
    mutation talentLinkUser($input: LinkUserInput!, $talentId: String!) {
  talentLinkUser(input: $input, talentId: $talentId) @rest(type: "Talent", method: "PUT", path: "/object/{args.talentId}&method=LINK") {
    ...talent
  }
}
    ${TalentFragmentDoc}`;
export type TalentLinkUserMutationFn = Apollo.MutationFunction<TalentLinkUserMutation, TalentLinkUserMutationVariables>;

/**
 * __useTalentLinkUserMutation__
 *
 * To run a mutation, you first call `useTalentLinkUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTalentLinkUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [talentLinkUserMutation, { data, loading, error }] = useTalentLinkUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *      talentId: // value for 'talentId'
 *   },
 * });
 */
export function useTalentLinkUserMutation(baseOptions?: Apollo.MutationHookOptions<TalentLinkUserMutation, TalentLinkUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TalentLinkUserMutation, TalentLinkUserMutationVariables>(TalentLinkUserDocument, options);
      }
export type TalentLinkUserMutationHookResult = ReturnType<typeof useTalentLinkUserMutation>;
export type TalentLinkUserMutationResult = Apollo.MutationResult<TalentLinkUserMutation>;
export type TalentLinkUserMutationOptions = Apollo.BaseMutationOptions<TalentLinkUserMutation, TalentLinkUserMutationVariables>;
export const DeleteTalentDocument = gql`
    mutation deleteTalent($talentId: ID!) {
  deleteTalent(talentId: $talentId) @rest(type: "Void", method: "DELETE", path: "/object/{args.talentId}")
}
    `;
export type DeleteTalentMutationFn = Apollo.MutationFunction<DeleteTalentMutation, DeleteTalentMutationVariables>;

/**
 * __useDeleteTalentMutation__
 *
 * To run a mutation, you first call `useDeleteTalentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTalentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTalentMutation, { data, loading, error }] = useDeleteTalentMutation({
 *   variables: {
 *      talentId: // value for 'talentId'
 *   },
 * });
 */
export function useDeleteTalentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTalentMutation, DeleteTalentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTalentMutation, DeleteTalentMutationVariables>(DeleteTalentDocument, options);
      }
export type DeleteTalentMutationHookResult = ReturnType<typeof useDeleteTalentMutation>;
export type DeleteTalentMutationResult = Apollo.MutationResult<DeleteTalentMutation>;
export type DeleteTalentMutationOptions = Apollo.BaseMutationOptions<DeleteTalentMutation, DeleteTalentMutationVariables>;
export const TalentLatestVoteDocument = gql`
    query talentLatestVote($talentId: ID!, $type: VoteType) {
  talentLatestVote(talentId: $talentId, type: $type) {
    ...vote
  }
}
    ${VoteFragmentDoc}`;

/**
 * __useTalentLatestVoteQuery__
 *
 * To run a query within a React component, call `useTalentLatestVoteQuery` and pass it any options that fit your needs.
 * When your component renders, `useTalentLatestVoteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTalentLatestVoteQuery({
 *   variables: {
 *      talentId: // value for 'talentId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useTalentLatestVoteQuery(baseOptions: Apollo.QueryHookOptions<TalentLatestVoteQuery, TalentLatestVoteQueryVariables> & ({ variables: TalentLatestVoteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TalentLatestVoteQuery, TalentLatestVoteQueryVariables>(TalentLatestVoteDocument, options);
      }
export function useTalentLatestVoteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TalentLatestVoteQuery, TalentLatestVoteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TalentLatestVoteQuery, TalentLatestVoteQueryVariables>(TalentLatestVoteDocument, options);
        }
// @ts-ignore
export function useTalentLatestVoteSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TalentLatestVoteQuery, TalentLatestVoteQueryVariables>): Apollo.UseSuspenseQueryResult<TalentLatestVoteQuery, TalentLatestVoteQueryVariables>;
export function useTalentLatestVoteSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TalentLatestVoteQuery, TalentLatestVoteQueryVariables>): Apollo.UseSuspenseQueryResult<TalentLatestVoteQuery | undefined, TalentLatestVoteQueryVariables>;
export function useTalentLatestVoteSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TalentLatestVoteQuery, TalentLatestVoteQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TalentLatestVoteQuery, TalentLatestVoteQueryVariables>(TalentLatestVoteDocument, options);
        }
export type TalentLatestVoteQueryHookResult = ReturnType<typeof useTalentLatestVoteQuery>;
export type TalentLatestVoteLazyQueryHookResult = ReturnType<typeof useTalentLatestVoteLazyQuery>;
export type TalentLatestVoteSuspenseQueryHookResult = ReturnType<typeof useTalentLatestVoteSuspenseQuery>;
export type TalentLatestVoteQueryResult = Apollo.QueryResult<TalentLatestVoteQuery, TalentLatestVoteQueryVariables>;
export const VoteDocument = gql`
    mutation vote($talentId: ID!, $input: VoteInput!) {
  vote(talentId: $talentId, input: $input) @rest(type: "Vote", path: "/object/{args.talentId}/vote", method: "POST") {
    ...vote
  }
}
    ${VoteFragmentDoc}`;
export type VoteMutationFn = Apollo.MutationFunction<VoteMutation, VoteMutationVariables>;

/**
 * __useVoteMutation__
 *
 * To run a mutation, you first call `useVoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [voteMutation, { data, loading, error }] = useVoteMutation({
 *   variables: {
 *      talentId: // value for 'talentId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVoteMutation(baseOptions?: Apollo.MutationHookOptions<VoteMutation, VoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VoteMutation, VoteMutationVariables>(VoteDocument, options);
      }
export type VoteMutationHookResult = ReturnType<typeof useVoteMutation>;
export type VoteMutationResult = Apollo.MutationResult<VoteMutation>;
export type VoteMutationOptions = Apollo.BaseMutationOptions<VoteMutation, VoteMutationVariables>;
export const UpdateVoteDocument = gql`
    mutation updateVote($voteId: ID!, $input: VoteInput!) {
  updateVote(id: $voteId, input: $input) @rest(type: "Vote", path: "/vote/{args.id}", method: "PATCH") {
    ...vote
  }
}
    ${VoteFragmentDoc}`;
export type UpdateVoteMutationFn = Apollo.MutationFunction<UpdateVoteMutation, UpdateVoteMutationVariables>;

/**
 * __useUpdateVoteMutation__
 *
 * To run a mutation, you first call `useUpdateVoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVoteMutation, { data, loading, error }] = useUpdateVoteMutation({
 *   variables: {
 *      voteId: // value for 'voteId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateVoteMutation(baseOptions?: Apollo.MutationHookOptions<UpdateVoteMutation, UpdateVoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateVoteMutation, UpdateVoteMutationVariables>(UpdateVoteDocument, options);
      }
export type UpdateVoteMutationHookResult = ReturnType<typeof useUpdateVoteMutation>;
export type UpdateVoteMutationResult = Apollo.MutationResult<UpdateVoteMutation>;
export type UpdateVoteMutationOptions = Apollo.BaseMutationOptions<UpdateVoteMutation, UpdateVoteMutationVariables>;
export const SimilarDocument = gql`
    query similar($userId: String, $talentId: String, $queryString: String, $start: Int, $limit: Int) {
  similar(
    userId: $userId
    talentId: $talentId
    queryString: $queryString
    start: $start
    limit: $limit
  ) @rest(type: "NetworkTalents", path: "/my/{args.userId}/object/{args.talentId}/similar{args.queryString}", method: "GET") {
    collection @type(name: "Talent") {
      ...talent
    }
    meta {
      range {
        from
        to
        total
      }
      sortOptions {
        key
        value
      }
    }
  }
}
    ${TalentFragmentDoc}`;

/**
 * __useSimilarQuery__
 *
 * To run a query within a React component, call `useSimilarQuery` and pass it any options that fit your needs.
 * When your component renders, `useSimilarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSimilarQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      talentId: // value for 'talentId'
 *      queryString: // value for 'queryString'
 *      start: // value for 'start'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useSimilarQuery(baseOptions?: Apollo.QueryHookOptions<SimilarQuery, SimilarQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SimilarQuery, SimilarQueryVariables>(SimilarDocument, options);
      }
export function useSimilarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SimilarQuery, SimilarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SimilarQuery, SimilarQueryVariables>(SimilarDocument, options);
        }
// @ts-ignore
export function useSimilarSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SimilarQuery, SimilarQueryVariables>): Apollo.UseSuspenseQueryResult<SimilarQuery, SimilarQueryVariables>;
export function useSimilarSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SimilarQuery, SimilarQueryVariables>): Apollo.UseSuspenseQueryResult<SimilarQuery | undefined, SimilarQueryVariables>;
export function useSimilarSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SimilarQuery, SimilarQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SimilarQuery, SimilarQueryVariables>(SimilarDocument, options);
        }
export type SimilarQueryHookResult = ReturnType<typeof useSimilarQuery>;
export type SimilarLazyQueryHookResult = ReturnType<typeof useSimilarLazyQuery>;
export type SimilarSuspenseQueryHookResult = ReturnType<typeof useSimilarSuspenseQuery>;
export type SimilarQueryResult = Apollo.QueryResult<SimilarQuery, SimilarQueryVariables>;
export const SimilarNetworkDocument = gql`
    query similarNetwork($queryString: String = "", $userId: ID!, $networkId: ID!, $start: Int, $limit: Int) {
  similarNetwork(
    queryString: $queryString
    userId: $userId
    networkId: $networkId
    start: $start
    limit: $limit
  ) @rest(type: "NetworkTalents", path: "/my/{args.userId}/network/{args.networkId}/object/similar{args.queryString}", method: "GET") {
    collection @type(name: "Talent") {
      ...talent
    }
    meta {
      range {
        from
        to
        total
      }
      sortOptions {
        key
        value
      }
    }
  }
}
    ${TalentFragmentDoc}`;

/**
 * __useSimilarNetworkQuery__
 *
 * To run a query within a React component, call `useSimilarNetworkQuery` and pass it any options that fit your needs.
 * When your component renders, `useSimilarNetworkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSimilarNetworkQuery({
 *   variables: {
 *      queryString: // value for 'queryString'
 *      userId: // value for 'userId'
 *      networkId: // value for 'networkId'
 *      start: // value for 'start'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useSimilarNetworkQuery(baseOptions: Apollo.QueryHookOptions<SimilarNetworkQuery, SimilarNetworkQueryVariables> & ({ variables: SimilarNetworkQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SimilarNetworkQuery, SimilarNetworkQueryVariables>(SimilarNetworkDocument, options);
      }
export function useSimilarNetworkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SimilarNetworkQuery, SimilarNetworkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SimilarNetworkQuery, SimilarNetworkQueryVariables>(SimilarNetworkDocument, options);
        }
// @ts-ignore
export function useSimilarNetworkSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SimilarNetworkQuery, SimilarNetworkQueryVariables>): Apollo.UseSuspenseQueryResult<SimilarNetworkQuery, SimilarNetworkQueryVariables>;
export function useSimilarNetworkSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SimilarNetworkQuery, SimilarNetworkQueryVariables>): Apollo.UseSuspenseQueryResult<SimilarNetworkQuery | undefined, SimilarNetworkQueryVariables>;
export function useSimilarNetworkSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SimilarNetworkQuery, SimilarNetworkQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SimilarNetworkQuery, SimilarNetworkQueryVariables>(SimilarNetworkDocument, options);
        }
export type SimilarNetworkQueryHookResult = ReturnType<typeof useSimilarNetworkQuery>;
export type SimilarNetworkLazyQueryHookResult = ReturnType<typeof useSimilarNetworkLazyQuery>;
export type SimilarNetworkSuspenseQueryHookResult = ReturnType<typeof useSimilarNetworkSuspenseQuery>;
export type SimilarNetworkQueryResult = Apollo.QueryResult<SimilarNetworkQuery, SimilarNetworkQueryVariables>;
export const SimilarNetworkV2Document = gql`
    query similarNetworkV2($talentId: ID!, $userId: ID!, $networkId: ID!, $talentClass: String!, $start: Int, $limit: Int) {
  similarNetworkV2(
    talentId: $talentId
    userId: $userId
    networkId: $networkId
    talentClass: $talentClass
    start: $start
    limit: $limit
  ) {
    collection @type(name: "Talent") {
      ...talent
    }
    meta {
      range {
        from
        to
        total
      }
      sortOptions {
        key
        value
      }
    }
  }
}
    ${TalentFragmentDoc}`;

/**
 * __useSimilarNetworkV2Query__
 *
 * To run a query within a React component, call `useSimilarNetworkV2Query` and pass it any options that fit your needs.
 * When your component renders, `useSimilarNetworkV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSimilarNetworkV2Query({
 *   variables: {
 *      talentId: // value for 'talentId'
 *      userId: // value for 'userId'
 *      networkId: // value for 'networkId'
 *      talentClass: // value for 'talentClass'
 *      start: // value for 'start'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useSimilarNetworkV2Query(baseOptions: Apollo.QueryHookOptions<SimilarNetworkV2Query, SimilarNetworkV2QueryVariables> & ({ variables: SimilarNetworkV2QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SimilarNetworkV2Query, SimilarNetworkV2QueryVariables>(SimilarNetworkV2Document, options);
      }
export function useSimilarNetworkV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SimilarNetworkV2Query, SimilarNetworkV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SimilarNetworkV2Query, SimilarNetworkV2QueryVariables>(SimilarNetworkV2Document, options);
        }
// @ts-ignore
export function useSimilarNetworkV2SuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SimilarNetworkV2Query, SimilarNetworkV2QueryVariables>): Apollo.UseSuspenseQueryResult<SimilarNetworkV2Query, SimilarNetworkV2QueryVariables>;
export function useSimilarNetworkV2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SimilarNetworkV2Query, SimilarNetworkV2QueryVariables>): Apollo.UseSuspenseQueryResult<SimilarNetworkV2Query | undefined, SimilarNetworkV2QueryVariables>;
export function useSimilarNetworkV2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SimilarNetworkV2Query, SimilarNetworkV2QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SimilarNetworkV2Query, SimilarNetworkV2QueryVariables>(SimilarNetworkV2Document, options);
        }
export type SimilarNetworkV2QueryHookResult = ReturnType<typeof useSimilarNetworkV2Query>;
export type SimilarNetworkV2LazyQueryHookResult = ReturnType<typeof useSimilarNetworkV2LazyQuery>;
export type SimilarNetworkV2SuspenseQueryHookResult = ReturnType<typeof useSimilarNetworkV2SuspenseQuery>;
export type SimilarNetworkV2QueryResult = Apollo.QueryResult<SimilarNetworkV2Query, SimilarNetworkV2QueryVariables>;
export const TalentLayerAnimationDocument = gql`
    query talentLayerAnimation($talentId: ID!) {
  talentLayerAnimation(talentId: $talentId) {
    dataViews {
      key
      values
    }
    label
    total
  }
}
    `;

/**
 * __useTalentLayerAnimationQuery__
 *
 * To run a query within a React component, call `useTalentLayerAnimationQuery` and pass it any options that fit your needs.
 * When your component renders, `useTalentLayerAnimationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTalentLayerAnimationQuery({
 *   variables: {
 *      talentId: // value for 'talentId'
 *   },
 * });
 */
export function useTalentLayerAnimationQuery(baseOptions: Apollo.QueryHookOptions<TalentLayerAnimationQuery, TalentLayerAnimationQueryVariables> & ({ variables: TalentLayerAnimationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TalentLayerAnimationQuery, TalentLayerAnimationQueryVariables>(TalentLayerAnimationDocument, options);
      }
export function useTalentLayerAnimationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TalentLayerAnimationQuery, TalentLayerAnimationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TalentLayerAnimationQuery, TalentLayerAnimationQueryVariables>(TalentLayerAnimationDocument, options);
        }
// @ts-ignore
export function useTalentLayerAnimationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TalentLayerAnimationQuery, TalentLayerAnimationQueryVariables>): Apollo.UseSuspenseQueryResult<TalentLayerAnimationQuery, TalentLayerAnimationQueryVariables>;
export function useTalentLayerAnimationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TalentLayerAnimationQuery, TalentLayerAnimationQueryVariables>): Apollo.UseSuspenseQueryResult<TalentLayerAnimationQuery | undefined, TalentLayerAnimationQueryVariables>;
export function useTalentLayerAnimationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TalentLayerAnimationQuery, TalentLayerAnimationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TalentLayerAnimationQuery, TalentLayerAnimationQueryVariables>(TalentLayerAnimationDocument, options);
        }
export type TalentLayerAnimationQueryHookResult = ReturnType<typeof useTalentLayerAnimationQuery>;
export type TalentLayerAnimationLazyQueryHookResult = ReturnType<typeof useTalentLayerAnimationLazyQuery>;
export type TalentLayerAnimationSuspenseQueryHookResult = ReturnType<typeof useTalentLayerAnimationSuspenseQuery>;
export type TalentLayerAnimationQueryResult = Apollo.QueryResult<TalentLayerAnimationQuery, TalentLayerAnimationQueryVariables>;
export const MyTalentLayerDocument = gql`
    query myTalentLayer($userId: String!, $talentId: ID!, $layerParams: String) {
  talentLayer(contextId: $userId, talentId: $talentId, layerParams: $layerParams) {
    ...talentIDLayer
  }
}
    ${TalentIdLayerFragmentDoc}`;

/**
 * __useMyTalentLayerQuery__
 *
 * To run a query within a React component, call `useMyTalentLayerQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyTalentLayerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyTalentLayerQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      talentId: // value for 'talentId'
 *      layerParams: // value for 'layerParams'
 *   },
 * });
 */
export function useMyTalentLayerQuery(baseOptions: Apollo.QueryHookOptions<MyTalentLayerQuery, MyTalentLayerQueryVariables> & ({ variables: MyTalentLayerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyTalentLayerQuery, MyTalentLayerQueryVariables>(MyTalentLayerDocument, options);
      }
export function useMyTalentLayerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyTalentLayerQuery, MyTalentLayerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyTalentLayerQuery, MyTalentLayerQueryVariables>(MyTalentLayerDocument, options);
        }
// @ts-ignore
export function useMyTalentLayerSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MyTalentLayerQuery, MyTalentLayerQueryVariables>): Apollo.UseSuspenseQueryResult<MyTalentLayerQuery, MyTalentLayerQueryVariables>;
export function useMyTalentLayerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyTalentLayerQuery, MyTalentLayerQueryVariables>): Apollo.UseSuspenseQueryResult<MyTalentLayerQuery | undefined, MyTalentLayerQueryVariables>;
export function useMyTalentLayerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyTalentLayerQuery, MyTalentLayerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyTalentLayerQuery, MyTalentLayerQueryVariables>(MyTalentLayerDocument, options);
        }
export type MyTalentLayerQueryHookResult = ReturnType<typeof useMyTalentLayerQuery>;
export type MyTalentLayerLazyQueryHookResult = ReturnType<typeof useMyTalentLayerLazyQuery>;
export type MyTalentLayerSuspenseQueryHookResult = ReturnType<typeof useMyTalentLayerSuspenseQuery>;
export type MyTalentLayerQueryResult = Apollo.QueryResult<MyTalentLayerQuery, MyTalentLayerQueryVariables>;
export const GlobalVoteForDateRangeDocument = gql`
    query globalVoteForDateRange($talentId: ID!, $startDate: String!, $endDate: String!) {
  globalVoteForDateRange(
    talentId: $talentId
    startDate: $startDate
    endDate: $endDate
  ) {
    key
    values
  }
}
    `;

/**
 * __useGlobalVoteForDateRangeQuery__
 *
 * To run a query within a React component, call `useGlobalVoteForDateRangeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGlobalVoteForDateRangeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGlobalVoteForDateRangeQuery({
 *   variables: {
 *      talentId: // value for 'talentId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGlobalVoteForDateRangeQuery(baseOptions: Apollo.QueryHookOptions<GlobalVoteForDateRangeQuery, GlobalVoteForDateRangeQueryVariables> & ({ variables: GlobalVoteForDateRangeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GlobalVoteForDateRangeQuery, GlobalVoteForDateRangeQueryVariables>(GlobalVoteForDateRangeDocument, options);
      }
export function useGlobalVoteForDateRangeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GlobalVoteForDateRangeQuery, GlobalVoteForDateRangeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GlobalVoteForDateRangeQuery, GlobalVoteForDateRangeQueryVariables>(GlobalVoteForDateRangeDocument, options);
        }
// @ts-ignore
export function useGlobalVoteForDateRangeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GlobalVoteForDateRangeQuery, GlobalVoteForDateRangeQueryVariables>): Apollo.UseSuspenseQueryResult<GlobalVoteForDateRangeQuery, GlobalVoteForDateRangeQueryVariables>;
export function useGlobalVoteForDateRangeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GlobalVoteForDateRangeQuery, GlobalVoteForDateRangeQueryVariables>): Apollo.UseSuspenseQueryResult<GlobalVoteForDateRangeQuery | undefined, GlobalVoteForDateRangeQueryVariables>;
export function useGlobalVoteForDateRangeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GlobalVoteForDateRangeQuery, GlobalVoteForDateRangeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GlobalVoteForDateRangeQuery, GlobalVoteForDateRangeQueryVariables>(GlobalVoteForDateRangeDocument, options);
        }
export type GlobalVoteForDateRangeQueryHookResult = ReturnType<typeof useGlobalVoteForDateRangeQuery>;
export type GlobalVoteForDateRangeLazyQueryHookResult = ReturnType<typeof useGlobalVoteForDateRangeLazyQuery>;
export type GlobalVoteForDateRangeSuspenseQueryHookResult = ReturnType<typeof useGlobalVoteForDateRangeSuspenseQuery>;
export type GlobalVoteForDateRangeQueryResult = Apollo.QueryResult<GlobalVoteForDateRangeQuery, GlobalVoteForDateRangeQueryVariables>;
export const ShareTalentDocument = gql`
    mutation shareTalent($input: ShareTalentInput!) {
  shareTalent(input: $input) @rest(type: "ShareTalentResponse", path: "/makro/sharetalent", method: "POST") {
    publicToken
  }
}
    `;
export type ShareTalentMutationFn = Apollo.MutationFunction<ShareTalentMutation, ShareTalentMutationVariables>;

/**
 * __useShareTalentMutation__
 *
 * To run a mutation, you first call `useShareTalentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShareTalentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shareTalentMutation, { data, loading, error }] = useShareTalentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useShareTalentMutation(baseOptions?: Apollo.MutationHookOptions<ShareTalentMutation, ShareTalentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ShareTalentMutation, ShareTalentMutationVariables>(ShareTalentDocument, options);
      }
export type ShareTalentMutationHookResult = ReturnType<typeof useShareTalentMutation>;
export type ShareTalentMutationResult = Apollo.MutationResult<ShareTalentMutation>;
export type ShareTalentMutationOptions = Apollo.BaseMutationOptions<ShareTalentMutation, ShareTalentMutationVariables>;
export const AddRoleModelDocument = gql`
    mutation addRoleModel($input: RoleModelInput!) {
  addRoleModel(input: $input) @rest(type: "MessageResponse", path: "/makro/addrolemodel", method: "POST") {
    message
  }
}
    `;
export type AddRoleModelMutationFn = Apollo.MutationFunction<AddRoleModelMutation, AddRoleModelMutationVariables>;

/**
 * __useAddRoleModelMutation__
 *
 * To run a mutation, you first call `useAddRoleModelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddRoleModelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addRoleModelMutation, { data, loading, error }] = useAddRoleModelMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddRoleModelMutation(baseOptions?: Apollo.MutationHookOptions<AddRoleModelMutation, AddRoleModelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddRoleModelMutation, AddRoleModelMutationVariables>(AddRoleModelDocument, options);
      }
export type AddRoleModelMutationHookResult = ReturnType<typeof useAddRoleModelMutation>;
export type AddRoleModelMutationResult = Apollo.MutationResult<AddRoleModelMutation>;
export type AddRoleModelMutationOptions = Apollo.BaseMutationOptions<AddRoleModelMutation, AddRoleModelMutationVariables>;
export const TransferTalentRequestDocument = gql`
    mutation transferTalentRequest($input: TransferTalentRequestInput!) {
  transferTalentRequest(input: $input) {
    ...talentTransferRequest
  }
}
    ${TalentTransferRequestFragmentDoc}`;
export type TransferTalentRequestMutationFn = Apollo.MutationFunction<TransferTalentRequestMutation, TransferTalentRequestMutationVariables>;

/**
 * __useTransferTalentRequestMutation__
 *
 * To run a mutation, you first call `useTransferTalentRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransferTalentRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transferTalentRequestMutation, { data, loading, error }] = useTransferTalentRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTransferTalentRequestMutation(baseOptions?: Apollo.MutationHookOptions<TransferTalentRequestMutation, TransferTalentRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TransferTalentRequestMutation, TransferTalentRequestMutationVariables>(TransferTalentRequestDocument, options);
      }
export type TransferTalentRequestMutationHookResult = ReturnType<typeof useTransferTalentRequestMutation>;
export type TransferTalentRequestMutationResult = Apollo.MutationResult<TransferTalentRequestMutation>;
export type TransferTalentRequestMutationOptions = Apollo.BaseMutationOptions<TransferTalentRequestMutation, TransferTalentRequestMutationVariables>;
export const EditTransferTalentRequestDocument = gql`
    mutation editTransferTalentRequest($transferId: ID!, $input: EditTransferTalentRequestInput!) {
  editTransferTalentRequest(transferId: $transferId, input: $input) {
    ...talentTransferRequest
  }
}
    ${TalentTransferRequestFragmentDoc}`;
export type EditTransferTalentRequestMutationFn = Apollo.MutationFunction<EditTransferTalentRequestMutation, EditTransferTalentRequestMutationVariables>;

/**
 * __useEditTransferTalentRequestMutation__
 *
 * To run a mutation, you first call `useEditTransferTalentRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditTransferTalentRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editTransferTalentRequestMutation, { data, loading, error }] = useEditTransferTalentRequestMutation({
 *   variables: {
 *      transferId: // value for 'transferId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditTransferTalentRequestMutation(baseOptions?: Apollo.MutationHookOptions<EditTransferTalentRequestMutation, EditTransferTalentRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditTransferTalentRequestMutation, EditTransferTalentRequestMutationVariables>(EditTransferTalentRequestDocument, options);
      }
export type EditTransferTalentRequestMutationHookResult = ReturnType<typeof useEditTransferTalentRequestMutation>;
export type EditTransferTalentRequestMutationResult = Apollo.MutationResult<EditTransferTalentRequestMutation>;
export type EditTransferTalentRequestMutationOptions = Apollo.BaseMutationOptions<EditTransferTalentRequestMutation, EditTransferTalentRequestMutationVariables>;
export const TransferTalentRequestsDocument = gql`
    query transferTalentRequests {
  transferTalentRequests {
    collection {
      ...talentTransferRequest
    }
  }
}
    ${TalentTransferRequestFragmentDoc}`;

/**
 * __useTransferTalentRequestsQuery__
 *
 * To run a query within a React component, call `useTransferTalentRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransferTalentRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransferTalentRequestsQuery({
 *   variables: {
 *   },
 * });
 */
export function useTransferTalentRequestsQuery(baseOptions?: Apollo.QueryHookOptions<TransferTalentRequestsQuery, TransferTalentRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TransferTalentRequestsQuery, TransferTalentRequestsQueryVariables>(TransferTalentRequestsDocument, options);
      }
export function useTransferTalentRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TransferTalentRequestsQuery, TransferTalentRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TransferTalentRequestsQuery, TransferTalentRequestsQueryVariables>(TransferTalentRequestsDocument, options);
        }
// @ts-ignore
export function useTransferTalentRequestsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TransferTalentRequestsQuery, TransferTalentRequestsQueryVariables>): Apollo.UseSuspenseQueryResult<TransferTalentRequestsQuery, TransferTalentRequestsQueryVariables>;
export function useTransferTalentRequestsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TransferTalentRequestsQuery, TransferTalentRequestsQueryVariables>): Apollo.UseSuspenseQueryResult<TransferTalentRequestsQuery | undefined, TransferTalentRequestsQueryVariables>;
export function useTransferTalentRequestsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TransferTalentRequestsQuery, TransferTalentRequestsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TransferTalentRequestsQuery, TransferTalentRequestsQueryVariables>(TransferTalentRequestsDocument, options);
        }
export type TransferTalentRequestsQueryHookResult = ReturnType<typeof useTransferTalentRequestsQuery>;
export type TransferTalentRequestsLazyQueryHookResult = ReturnType<typeof useTransferTalentRequestsLazyQuery>;
export type TransferTalentRequestsSuspenseQueryHookResult = ReturnType<typeof useTransferTalentRequestsSuspenseQuery>;
export type TransferTalentRequestsQueryResult = Apollo.QueryResult<TransferTalentRequestsQuery, TransferTalentRequestsQueryVariables>;
export const SavePerformanceVoteDocument = gql`
    mutation savePerformanceVote($input: PerformanceVoteInput!) {
  savePerformanceVote(input: $input) @rest(type: "PerformanceVote", path: "/makro/performanceVote", method: "POST") {
    ...performanceVote
  }
}
    ${PerformanceVoteFragmentDoc}`;
export type SavePerformanceVoteMutationFn = Apollo.MutationFunction<SavePerformanceVoteMutation, SavePerformanceVoteMutationVariables>;

/**
 * __useSavePerformanceVoteMutation__
 *
 * To run a mutation, you first call `useSavePerformanceVoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSavePerformanceVoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [savePerformanceVoteMutation, { data, loading, error }] = useSavePerformanceVoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSavePerformanceVoteMutation(baseOptions?: Apollo.MutationHookOptions<SavePerformanceVoteMutation, SavePerformanceVoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SavePerformanceVoteMutation, SavePerformanceVoteMutationVariables>(SavePerformanceVoteDocument, options);
      }
export type SavePerformanceVoteMutationHookResult = ReturnType<typeof useSavePerformanceVoteMutation>;
export type SavePerformanceVoteMutationResult = Apollo.MutationResult<SavePerformanceVoteMutation>;
export type SavePerformanceVoteMutationOptions = Apollo.BaseMutationOptions<SavePerformanceVoteMutation, SavePerformanceVoteMutationVariables>;
export const PerformanceVoteDocument = gql`
    query performanceVote($talentId: ID!, $network: String) {
  performanceVote(talentId: $talentId, network: $network) @rest(type: "PerformanceVote", path: "/makro/performanceVote/{args.talentId}{args.network}", method: "GET") {
    ...performanceVote
  }
}
    ${PerformanceVoteFragmentDoc}`;

/**
 * __usePerformanceVoteQuery__
 *
 * To run a query within a React component, call `usePerformanceVoteQuery` and pass it any options that fit your needs.
 * When your component renders, `usePerformanceVoteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePerformanceVoteQuery({
 *   variables: {
 *      talentId: // value for 'talentId'
 *      network: // value for 'network'
 *   },
 * });
 */
export function usePerformanceVoteQuery(baseOptions: Apollo.QueryHookOptions<PerformanceVoteQuery, PerformanceVoteQueryVariables> & ({ variables: PerformanceVoteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PerformanceVoteQuery, PerformanceVoteQueryVariables>(PerformanceVoteDocument, options);
      }
export function usePerformanceVoteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PerformanceVoteQuery, PerformanceVoteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PerformanceVoteQuery, PerformanceVoteQueryVariables>(PerformanceVoteDocument, options);
        }
// @ts-ignore
export function usePerformanceVoteSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PerformanceVoteQuery, PerformanceVoteQueryVariables>): Apollo.UseSuspenseQueryResult<PerformanceVoteQuery, PerformanceVoteQueryVariables>;
export function usePerformanceVoteSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PerformanceVoteQuery, PerformanceVoteQueryVariables>): Apollo.UseSuspenseQueryResult<PerformanceVoteQuery | undefined, PerformanceVoteQueryVariables>;
export function usePerformanceVoteSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PerformanceVoteQuery, PerformanceVoteQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PerformanceVoteQuery, PerformanceVoteQueryVariables>(PerformanceVoteDocument, options);
        }
export type PerformanceVoteQueryHookResult = ReturnType<typeof usePerformanceVoteQuery>;
export type PerformanceVoteLazyQueryHookResult = ReturnType<typeof usePerformanceVoteLazyQuery>;
export type PerformanceVoteSuspenseQueryHookResult = ReturnType<typeof usePerformanceVoteSuspenseQuery>;
export type PerformanceVoteQueryResult = Apollo.QueryResult<PerformanceVoteQuery, PerformanceVoteQueryVariables>;
export const ShortVoteDocument = gql`
    mutation shortVote($talentId: ID!, $input: VoteInput!) {
  shortVote(talentId: $talentId, input: $input) {
    ...vote
  }
}
    ${VoteFragmentDoc}`;
export type ShortVoteMutationFn = Apollo.MutationFunction<ShortVoteMutation, ShortVoteMutationVariables>;

/**
 * __useShortVoteMutation__
 *
 * To run a mutation, you first call `useShortVoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShortVoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shortVoteMutation, { data, loading, error }] = useShortVoteMutation({
 *   variables: {
 *      talentId: // value for 'talentId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useShortVoteMutation(baseOptions?: Apollo.MutationHookOptions<ShortVoteMutation, ShortVoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ShortVoteMutation, ShortVoteMutationVariables>(ShortVoteDocument, options);
      }
export type ShortVoteMutationHookResult = ReturnType<typeof useShortVoteMutation>;
export type ShortVoteMutationResult = Apollo.MutationResult<ShortVoteMutation>;
export type ShortVoteMutationOptions = Apollo.BaseMutationOptions<ShortVoteMutation, ShortVoteMutationVariables>;
export const CertificatesDocument = gql`
    query certificates($talentId: ID!) {
  certificates(talentId: $talentId) {
    id
    club
    talentId
    image
    caption
    firstName
    player
    birthday
    lastName
    talentClass
    camp {
      caption
      campType
      end
      start
    }
    vote
    shareKey
    renderPayload
  }
}
    `;

/**
 * __useCertificatesQuery__
 *
 * To run a query within a React component, call `useCertificatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCertificatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCertificatesQuery({
 *   variables: {
 *      talentId: // value for 'talentId'
 *   },
 * });
 */
export function useCertificatesQuery(baseOptions: Apollo.QueryHookOptions<CertificatesQuery, CertificatesQueryVariables> & ({ variables: CertificatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CertificatesQuery, CertificatesQueryVariables>(CertificatesDocument, options);
      }
export function useCertificatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CertificatesQuery, CertificatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CertificatesQuery, CertificatesQueryVariables>(CertificatesDocument, options);
        }
// @ts-ignore
export function useCertificatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CertificatesQuery, CertificatesQueryVariables>): Apollo.UseSuspenseQueryResult<CertificatesQuery, CertificatesQueryVariables>;
export function useCertificatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CertificatesQuery, CertificatesQueryVariables>): Apollo.UseSuspenseQueryResult<CertificatesQuery | undefined, CertificatesQueryVariables>;
export function useCertificatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CertificatesQuery, CertificatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CertificatesQuery, CertificatesQueryVariables>(CertificatesDocument, options);
        }
export type CertificatesQueryHookResult = ReturnType<typeof useCertificatesQuery>;
export type CertificatesLazyQueryHookResult = ReturnType<typeof useCertificatesLazyQuery>;
export type CertificatesSuspenseQueryHookResult = ReturnType<typeof useCertificatesSuspenseQuery>;
export type CertificatesQueryResult = Apollo.QueryResult<CertificatesQuery, CertificatesQueryVariables>;
export const CreateShanghaiTalentDocument = gql`
    mutation createShanghaiTalent($talentId: ID!) {
  createShanghaiTalent(talentId: $talentId)
}
    `;
export type CreateShanghaiTalentMutationFn = Apollo.MutationFunction<CreateShanghaiTalentMutation, CreateShanghaiTalentMutationVariables>;

/**
 * __useCreateShanghaiTalentMutation__
 *
 * To run a mutation, you first call `useCreateShanghaiTalentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateShanghaiTalentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createShanghaiTalentMutation, { data, loading, error }] = useCreateShanghaiTalentMutation({
 *   variables: {
 *      talentId: // value for 'talentId'
 *   },
 * });
 */
export function useCreateShanghaiTalentMutation(baseOptions?: Apollo.MutationHookOptions<CreateShanghaiTalentMutation, CreateShanghaiTalentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateShanghaiTalentMutation, CreateShanghaiTalentMutationVariables>(CreateShanghaiTalentDocument, options);
      }
export type CreateShanghaiTalentMutationHookResult = ReturnType<typeof useCreateShanghaiTalentMutation>;
export type CreateShanghaiTalentMutationResult = Apollo.MutationResult<CreateShanghaiTalentMutation>;
export type CreateShanghaiTalentMutationOptions = Apollo.BaseMutationOptions<CreateShanghaiTalentMutation, CreateShanghaiTalentMutationVariables>;
export const ShanghaiTalentDocument = gql`
    query shanghaiTalent($token: String!) {
  shanghaiTalent(token: $token) {
    ...talent
  }
}
    ${TalentFragmentDoc}`;

/**
 * __useShanghaiTalentQuery__
 *
 * To run a query within a React component, call `useShanghaiTalentQuery` and pass it any options that fit your needs.
 * When your component renders, `useShanghaiTalentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShanghaiTalentQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useShanghaiTalentQuery(baseOptions: Apollo.QueryHookOptions<ShanghaiTalentQuery, ShanghaiTalentQueryVariables> & ({ variables: ShanghaiTalentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShanghaiTalentQuery, ShanghaiTalentQueryVariables>(ShanghaiTalentDocument, options);
      }
export function useShanghaiTalentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShanghaiTalentQuery, ShanghaiTalentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShanghaiTalentQuery, ShanghaiTalentQueryVariables>(ShanghaiTalentDocument, options);
        }
// @ts-ignore
export function useShanghaiTalentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ShanghaiTalentQuery, ShanghaiTalentQueryVariables>): Apollo.UseSuspenseQueryResult<ShanghaiTalentQuery, ShanghaiTalentQueryVariables>;
export function useShanghaiTalentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ShanghaiTalentQuery, ShanghaiTalentQueryVariables>): Apollo.UseSuspenseQueryResult<ShanghaiTalentQuery | undefined, ShanghaiTalentQueryVariables>;
export function useShanghaiTalentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ShanghaiTalentQuery, ShanghaiTalentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ShanghaiTalentQuery, ShanghaiTalentQueryVariables>(ShanghaiTalentDocument, options);
        }
export type ShanghaiTalentQueryHookResult = ReturnType<typeof useShanghaiTalentQuery>;
export type ShanghaiTalentLazyQueryHookResult = ReturnType<typeof useShanghaiTalentLazyQuery>;
export type ShanghaiTalentSuspenseQueryHookResult = ReturnType<typeof useShanghaiTalentSuspenseQuery>;
export type ShanghaiTalentQueryResult = Apollo.QueryResult<ShanghaiTalentQuery, ShanghaiTalentQueryVariables>;
export const TalentHistoryDocument = gql`
    query talentHistory($talentId: ID!) {
  talentHistory(talentId: $talentId) {
    date
    data
    id
    type
  }
}
    `;

/**
 * __useTalentHistoryQuery__
 *
 * To run a query within a React component, call `useTalentHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useTalentHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTalentHistoryQuery({
 *   variables: {
 *      talentId: // value for 'talentId'
 *   },
 * });
 */
export function useTalentHistoryQuery(baseOptions: Apollo.QueryHookOptions<TalentHistoryQuery, TalentHistoryQueryVariables> & ({ variables: TalentHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TalentHistoryQuery, TalentHistoryQueryVariables>(TalentHistoryDocument, options);
      }
export function useTalentHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TalentHistoryQuery, TalentHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TalentHistoryQuery, TalentHistoryQueryVariables>(TalentHistoryDocument, options);
        }
// @ts-ignore
export function useTalentHistorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TalentHistoryQuery, TalentHistoryQueryVariables>): Apollo.UseSuspenseQueryResult<TalentHistoryQuery, TalentHistoryQueryVariables>;
export function useTalentHistorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TalentHistoryQuery, TalentHistoryQueryVariables>): Apollo.UseSuspenseQueryResult<TalentHistoryQuery | undefined, TalentHistoryQueryVariables>;
export function useTalentHistorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TalentHistoryQuery, TalentHistoryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TalentHistoryQuery, TalentHistoryQueryVariables>(TalentHistoryDocument, options);
        }
export type TalentHistoryQueryHookResult = ReturnType<typeof useTalentHistoryQuery>;
export type TalentHistoryLazyQueryHookResult = ReturnType<typeof useTalentHistoryLazyQuery>;
export type TalentHistorySuspenseQueryHookResult = ReturnType<typeof useTalentHistorySuspenseQuery>;
export type TalentHistoryQueryResult = Apollo.QueryResult<TalentHistoryQuery, TalentHistoryQueryVariables>;
export const CreateHistoryItemDocument = gql`
    mutation createHistoryItem($input: HistoryItemInput!) {
  createHistoryItem(input: $input) {
    date
    data
    id
    type
  }
}
    `;
export type CreateHistoryItemMutationFn = Apollo.MutationFunction<CreateHistoryItemMutation, CreateHistoryItemMutationVariables>;

/**
 * __useCreateHistoryItemMutation__
 *
 * To run a mutation, you first call `useCreateHistoryItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateHistoryItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createHistoryItemMutation, { data, loading, error }] = useCreateHistoryItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateHistoryItemMutation(baseOptions?: Apollo.MutationHookOptions<CreateHistoryItemMutation, CreateHistoryItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateHistoryItemMutation, CreateHistoryItemMutationVariables>(CreateHistoryItemDocument, options);
      }
export type CreateHistoryItemMutationHookResult = ReturnType<typeof useCreateHistoryItemMutation>;
export type CreateHistoryItemMutationResult = Apollo.MutationResult<CreateHistoryItemMutation>;
export type CreateHistoryItemMutationOptions = Apollo.BaseMutationOptions<CreateHistoryItemMutation, CreateHistoryItemMutationVariables>;
export const EditHistoryItemDocument = gql`
    mutation editHistoryItem($input: HistoryItemInput!) {
  editHistoryItem(input: $input) {
    date
    data
    id
    type
  }
}
    `;
export type EditHistoryItemMutationFn = Apollo.MutationFunction<EditHistoryItemMutation, EditHistoryItemMutationVariables>;

/**
 * __useEditHistoryItemMutation__
 *
 * To run a mutation, you first call `useEditHistoryItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditHistoryItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editHistoryItemMutation, { data, loading, error }] = useEditHistoryItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditHistoryItemMutation(baseOptions?: Apollo.MutationHookOptions<EditHistoryItemMutation, EditHistoryItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditHistoryItemMutation, EditHistoryItemMutationVariables>(EditHistoryItemDocument, options);
      }
export type EditHistoryItemMutationHookResult = ReturnType<typeof useEditHistoryItemMutation>;
export type EditHistoryItemMutationResult = Apollo.MutationResult<EditHistoryItemMutation>;
export type EditHistoryItemMutationOptions = Apollo.BaseMutationOptions<EditHistoryItemMutation, EditHistoryItemMutationVariables>;
export const DeleteHistoryItemDocument = gql`
    mutation deleteHistoryItem($id: ID!) {
  deleteHistoryItem(id: $id)
}
    `;
export type DeleteHistoryItemMutationFn = Apollo.MutationFunction<DeleteHistoryItemMutation, DeleteHistoryItemMutationVariables>;

/**
 * __useDeleteHistoryItemMutation__
 *
 * To run a mutation, you first call `useDeleteHistoryItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteHistoryItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteHistoryItemMutation, { data, loading, error }] = useDeleteHistoryItemMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteHistoryItemMutation(baseOptions?: Apollo.MutationHookOptions<DeleteHistoryItemMutation, DeleteHistoryItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteHistoryItemMutation, DeleteHistoryItemMutationVariables>(DeleteHistoryItemDocument, options);
      }
export type DeleteHistoryItemMutationHookResult = ReturnType<typeof useDeleteHistoryItemMutation>;
export type DeleteHistoryItemMutationResult = Apollo.MutationResult<DeleteHistoryItemMutation>;
export type DeleteHistoryItemMutationOptions = Apollo.BaseMutationOptions<DeleteHistoryItemMutation, DeleteHistoryItemMutationVariables>;
export const RecoverUsernameDocument = gql`
    mutation recoverUsername($input: RecoverUsernameInput!) {
  recoverUsername(input: $input) @rest(path: "/user/recover", method: "POST") {
    collection @type(name: "UserRecover") {
      id
      name
      firstName
      lastName
    }
    meta {
      range {
        from
        to
        total
      }
      sortOptions {
        key
        value
      }
    }
  }
}
    `;
export type RecoverUsernameMutationFn = Apollo.MutationFunction<RecoverUsernameMutation, RecoverUsernameMutationVariables>;

/**
 * __useRecoverUsernameMutation__
 *
 * To run a mutation, you first call `useRecoverUsernameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecoverUsernameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recoverUsernameMutation, { data, loading, error }] = useRecoverUsernameMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRecoverUsernameMutation(baseOptions?: Apollo.MutationHookOptions<RecoverUsernameMutation, RecoverUsernameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecoverUsernameMutation, RecoverUsernameMutationVariables>(RecoverUsernameDocument, options);
      }
export type RecoverUsernameMutationHookResult = ReturnType<typeof useRecoverUsernameMutation>;
export type RecoverUsernameMutationResult = Apollo.MutationResult<RecoverUsernameMutation>;
export type RecoverUsernameMutationOptions = Apollo.BaseMutationOptions<RecoverUsernameMutation, RecoverUsernameMutationVariables>;
export const RequestPasswordChangeDocument = gql`
    mutation requestPasswordChange($input: RequestPasswordChangeInput!) {
  requestPasswordChange(input: $input) @rest(path: "/user/recover", method: "POST") {
    token
    user {
      id
      name
      firstName
      lastName
      email
    }
  }
}
    `;
export type RequestPasswordChangeMutationFn = Apollo.MutationFunction<RequestPasswordChangeMutation, RequestPasswordChangeMutationVariables>;

/**
 * __useRequestPasswordChangeMutation__
 *
 * To run a mutation, you first call `useRequestPasswordChangeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestPasswordChangeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestPasswordChangeMutation, { data, loading, error }] = useRequestPasswordChangeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestPasswordChangeMutation(baseOptions?: Apollo.MutationHookOptions<RequestPasswordChangeMutation, RequestPasswordChangeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestPasswordChangeMutation, RequestPasswordChangeMutationVariables>(RequestPasswordChangeDocument, options);
      }
export type RequestPasswordChangeMutationHookResult = ReturnType<typeof useRequestPasswordChangeMutation>;
export type RequestPasswordChangeMutationResult = Apollo.MutationResult<RequestPasswordChangeMutation>;
export type RequestPasswordChangeMutationOptions = Apollo.BaseMutationOptions<RequestPasswordChangeMutation, RequestPasswordChangeMutationVariables>;
export const CreateUserMetaDataDocument = gql`
    mutation createUserMetaData($input: UserMetaDataInput!) {
  saveUserMetaData(input: $input) @rest(type: "UserMetaDataSaveResponse", path: "/makro/userdata", method: "POST") {
    ...userMetadataSaveResponse
  }
}
    ${UserMetadataSaveResponseFragmentDoc}`;
export type CreateUserMetaDataMutationFn = Apollo.MutationFunction<CreateUserMetaDataMutation, CreateUserMetaDataMutationVariables>;

/**
 * __useCreateUserMetaDataMutation__
 *
 * To run a mutation, you first call `useCreateUserMetaDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMetaDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMetaDataMutation, { data, loading, error }] = useCreateUserMetaDataMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUserMetaDataMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserMetaDataMutation, CreateUserMetaDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserMetaDataMutation, CreateUserMetaDataMutationVariables>(CreateUserMetaDataDocument, options);
      }
export type CreateUserMetaDataMutationHookResult = ReturnType<typeof useCreateUserMetaDataMutation>;
export type CreateUserMetaDataMutationResult = Apollo.MutationResult<CreateUserMetaDataMutation>;
export type CreateUserMetaDataMutationOptions = Apollo.BaseMutationOptions<CreateUserMetaDataMutation, CreateUserMetaDataMutationVariables>;
export const UpdateUserMetaDataDocument = gql`
    mutation updateUserMetaData($input: UserMetaDataInput!) {
  saveUserMetaData(input: $input) @rest(type: "UserMetaDataSaveResponse", path: "/makro/userdata", method: "PUT") {
    ...userMetadataSaveResponse
  }
}
    ${UserMetadataSaveResponseFragmentDoc}`;
export type UpdateUserMetaDataMutationFn = Apollo.MutationFunction<UpdateUserMetaDataMutation, UpdateUserMetaDataMutationVariables>;

/**
 * __useUpdateUserMetaDataMutation__
 *
 * To run a mutation, you first call `useUpdateUserMetaDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMetaDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMetaDataMutation, { data, loading, error }] = useUpdateUserMetaDataMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserMetaDataMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMetaDataMutation, UpdateUserMetaDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMetaDataMutation, UpdateUserMetaDataMutationVariables>(UpdateUserMetaDataDocument, options);
      }
export type UpdateUserMetaDataMutationHookResult = ReturnType<typeof useUpdateUserMetaDataMutation>;
export type UpdateUserMetaDataMutationResult = Apollo.MutationResult<UpdateUserMetaDataMutation>;
export type UpdateUserMetaDataMutationOptions = Apollo.BaseMutationOptions<UpdateUserMetaDataMutation, UpdateUserMetaDataMutationVariables>;
export const UserMetaDataDocument = gql`
    query userMetaData($userId: ID!) {
  userMetaData(userId: $userId) @rest(type: "UserMetaDataResponse", path: "/makro/userdata/{args.userId}", method: "GET") {
    ...userMetadataResponse
  }
}
    ${UserMetadataResponseFragmentDoc}`;

/**
 * __useUserMetaDataQuery__
 *
 * To run a query within a React component, call `useUserMetaDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserMetaDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserMetaDataQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserMetaDataQuery(baseOptions: Apollo.QueryHookOptions<UserMetaDataQuery, UserMetaDataQueryVariables> & ({ variables: UserMetaDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserMetaDataQuery, UserMetaDataQueryVariables>(UserMetaDataDocument, options);
      }
export function useUserMetaDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserMetaDataQuery, UserMetaDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserMetaDataQuery, UserMetaDataQueryVariables>(UserMetaDataDocument, options);
        }
// @ts-ignore
export function useUserMetaDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserMetaDataQuery, UserMetaDataQueryVariables>): Apollo.UseSuspenseQueryResult<UserMetaDataQuery, UserMetaDataQueryVariables>;
export function useUserMetaDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserMetaDataQuery, UserMetaDataQueryVariables>): Apollo.UseSuspenseQueryResult<UserMetaDataQuery | undefined, UserMetaDataQueryVariables>;
export function useUserMetaDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserMetaDataQuery, UserMetaDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserMetaDataQuery, UserMetaDataQueryVariables>(UserMetaDataDocument, options);
        }
export type UserMetaDataQueryHookResult = ReturnType<typeof useUserMetaDataQuery>;
export type UserMetaDataLazyQueryHookResult = ReturnType<typeof useUserMetaDataLazyQuery>;
export type UserMetaDataSuspenseQueryHookResult = ReturnType<typeof useUserMetaDataSuspenseQuery>;
export type UserMetaDataQueryResult = Apollo.QueryResult<UserMetaDataQuery, UserMetaDataQueryVariables>;
export const SuggestUserDocument = gql`
    query suggestUser($q: String!) {
  suggestUser(q: $q) @rest(type: "SuggestUser", path: "/user/suggest?q={args.q}", method: "GET") {
    name
  }
}
    `;

/**
 * __useSuggestUserQuery__
 *
 * To run a query within a React component, call `useSuggestUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuggestUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuggestUserQuery({
 *   variables: {
 *      q: // value for 'q'
 *   },
 * });
 */
export function useSuggestUserQuery(baseOptions: Apollo.QueryHookOptions<SuggestUserQuery, SuggestUserQueryVariables> & ({ variables: SuggestUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SuggestUserQuery, SuggestUserQueryVariables>(SuggestUserDocument, options);
      }
export function useSuggestUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SuggestUserQuery, SuggestUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SuggestUserQuery, SuggestUserQueryVariables>(SuggestUserDocument, options);
        }
// @ts-ignore
export function useSuggestUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SuggestUserQuery, SuggestUserQueryVariables>): Apollo.UseSuspenseQueryResult<SuggestUserQuery, SuggestUserQueryVariables>;
export function useSuggestUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SuggestUserQuery, SuggestUserQueryVariables>): Apollo.UseSuspenseQueryResult<SuggestUserQuery | undefined, SuggestUserQueryVariables>;
export function useSuggestUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SuggestUserQuery, SuggestUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SuggestUserQuery, SuggestUserQueryVariables>(SuggestUserDocument, options);
        }
export type SuggestUserQueryHookResult = ReturnType<typeof useSuggestUserQuery>;
export type SuggestUserLazyQueryHookResult = ReturnType<typeof useSuggestUserLazyQuery>;
export type SuggestUserSuspenseQueryHookResult = ReturnType<typeof useSuggestUserSuspenseQuery>;
export type SuggestUserQueryResult = Apollo.QueryResult<SuggestUserQuery, SuggestUserQueryVariables>;
export const SearchUserDocument = gql`
    query searchUser($query: String!, $meId: String!, $networkId: String!, $sort: String = "&sort=newestFirst", $start: Int, $limit: Int) {
  searchUser(
    query: $query
    meId: $meId
    networkId: $networkId
    sort: $sort
    start: $start
    limit: $limit
  ) @rest(type: "SearchUser", path: "/my/{args.meId}/network/{args.networkId}/user/search&query={args.query}{args.sort}", method: "GET") {
    meta {
      range {
        from
        to
        total
      }
      sortOptions {
        key
        value
      }
    }
    collection @type(name: "User") {
      ...user
    }
  }
}
    ${UserFragmentDoc}`;

/**
 * __useSearchUserQuery__
 *
 * To run a query within a React component, call `useSearchUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchUserQuery({
 *   variables: {
 *      query: // value for 'query'
 *      meId: // value for 'meId'
 *      networkId: // value for 'networkId'
 *      sort: // value for 'sort'
 *      start: // value for 'start'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useSearchUserQuery(baseOptions: Apollo.QueryHookOptions<SearchUserQuery, SearchUserQueryVariables> & ({ variables: SearchUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchUserQuery, SearchUserQueryVariables>(SearchUserDocument, options);
      }
export function useSearchUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchUserQuery, SearchUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchUserQuery, SearchUserQueryVariables>(SearchUserDocument, options);
        }
// @ts-ignore
export function useSearchUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchUserQuery, SearchUserQueryVariables>): Apollo.UseSuspenseQueryResult<SearchUserQuery, SearchUserQueryVariables>;
export function useSearchUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchUserQuery, SearchUserQueryVariables>): Apollo.UseSuspenseQueryResult<SearchUserQuery | undefined, SearchUserQueryVariables>;
export function useSearchUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchUserQuery, SearchUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchUserQuery, SearchUserQueryVariables>(SearchUserDocument, options);
        }
export type SearchUserQueryHookResult = ReturnType<typeof useSearchUserQuery>;
export type SearchUserLazyQueryHookResult = ReturnType<typeof useSearchUserLazyQuery>;
export type SearchUserSuspenseQueryHookResult = ReturnType<typeof useSearchUserSuspenseQuery>;
export type SearchUserQueryResult = Apollo.QueryResult<SearchUserQuery, SearchUserQueryVariables>;
export const UpdateUserDocument = gql`
    mutation updateUser($input: UserInput!, $userId: String!) {
  updateUser(input: $input, userId: $userId) @rest(type: "User", path: "/user/{args.userId}", method: "PATCH") {
    ...user
  }
}
    ${UserFragmentDoc}`;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const UpdatePasswordDocument = gql`
    mutation updatePassword($input: PasswordInput!, $userId: String!) {
  updatePassword(input: $input, userId: $userId) @rest(type: "User", path: "/user/{args.userId}", method: "PATCH") {
    ...user
  }
}
    ${UserFragmentDoc}`;
export type UpdatePasswordMutationFn = Apollo.MutationFunction<UpdatePasswordMutation, UpdatePasswordMutationVariables>;

/**
 * __useUpdatePasswordMutation__
 *
 * To run a mutation, you first call `useUpdatePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePasswordMutation, { data, loading, error }] = useUpdatePasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUpdatePasswordMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePasswordMutation, UpdatePasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePasswordMutation, UpdatePasswordMutationVariables>(UpdatePasswordDocument, options);
      }
export type UpdatePasswordMutationHookResult = ReturnType<typeof useUpdatePasswordMutation>;
export type UpdatePasswordMutationResult = Apollo.MutationResult<UpdatePasswordMutation>;
export type UpdatePasswordMutationOptions = Apollo.BaseMutationOptions<UpdatePasswordMutation, UpdatePasswordMutationVariables>;
export const UserLinkImageDocument = gql`
    mutation userLinkImage($url: String!, $userId: String!) {
  userLinkImage(input: {_links: {image: {url: $url}}}, userId: $userId) @rest(type: "User", method: "PUT", path: "/user/{args.userId}&method=LINK") {
    ...user
  }
}
    ${UserFragmentDoc}`;
export type UserLinkImageMutationFn = Apollo.MutationFunction<UserLinkImageMutation, UserLinkImageMutationVariables>;

/**
 * __useUserLinkImageMutation__
 *
 * To run a mutation, you first call `useUserLinkImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserLinkImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userLinkImageMutation, { data, loading, error }] = useUserLinkImageMutation({
 *   variables: {
 *      url: // value for 'url'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserLinkImageMutation(baseOptions?: Apollo.MutationHookOptions<UserLinkImageMutation, UserLinkImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserLinkImageMutation, UserLinkImageMutationVariables>(UserLinkImageDocument, options);
      }
export type UserLinkImageMutationHookResult = ReturnType<typeof useUserLinkImageMutation>;
export type UserLinkImageMutationResult = Apollo.MutationResult<UserLinkImageMutation>;
export type UserLinkImageMutationOptions = Apollo.BaseMutationOptions<UserLinkImageMutation, UserLinkImageMutationVariables>;
export const UserUnlinkImageDocument = gql`
    mutation userUnlinkImage($url: String!, $userId: String!) {
  userUnlinkImage(input: {_links: {image: {url: $url}}}, userId: $userId) @rest(type: "User", method: "PUT", path: "/user/{args.userId}&method=UNLINK") {
    ...user
  }
}
    ${UserFragmentDoc}`;
export type UserUnlinkImageMutationFn = Apollo.MutationFunction<UserUnlinkImageMutation, UserUnlinkImageMutationVariables>;

/**
 * __useUserUnlinkImageMutation__
 *
 * To run a mutation, you first call `useUserUnlinkImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserUnlinkImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userUnlinkImageMutation, { data, loading, error }] = useUserUnlinkImageMutation({
 *   variables: {
 *      url: // value for 'url'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserUnlinkImageMutation(baseOptions?: Apollo.MutationHookOptions<UserUnlinkImageMutation, UserUnlinkImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserUnlinkImageMutation, UserUnlinkImageMutationVariables>(UserUnlinkImageDocument, options);
      }
export type UserUnlinkImageMutationHookResult = ReturnType<typeof useUserUnlinkImageMutation>;
export type UserUnlinkImageMutationResult = Apollo.MutationResult<UserUnlinkImageMutation>;
export type UserUnlinkImageMutationOptions = Apollo.BaseMutationOptions<UserUnlinkImageMutation, UserUnlinkImageMutationVariables>;
export const UserFollowDocument = gql`
    mutation userFollow($url: String!, $userId: String!, $method: String!) {
  userFollow(
    input: {_links: {follow_user: {url: $url}}}
    userId: $userId
    method: $method
  ) @rest(type: "User", method: "PUT", path: "/user/{args.userId}&method={args.method}") {
    id
  }
}
    `;
export type UserFollowMutationFn = Apollo.MutationFunction<UserFollowMutation, UserFollowMutationVariables>;

/**
 * __useUserFollowMutation__
 *
 * To run a mutation, you first call `useUserFollowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserFollowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userFollowMutation, { data, loading, error }] = useUserFollowMutation({
 *   variables: {
 *      url: // value for 'url'
 *      userId: // value for 'userId'
 *      method: // value for 'method'
 *   },
 * });
 */
export function useUserFollowMutation(baseOptions?: Apollo.MutationHookOptions<UserFollowMutation, UserFollowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserFollowMutation, UserFollowMutationVariables>(UserFollowDocument, options);
      }
export type UserFollowMutationHookResult = ReturnType<typeof useUserFollowMutation>;
export type UserFollowMutationResult = Apollo.MutationResult<UserFollowMutation>;
export type UserFollowMutationOptions = Apollo.BaseMutationOptions<UserFollowMutation, UserFollowMutationVariables>;
export const UserJoinMarketplaceDocument = gql`
    mutation userJoinMarketplace {
  userJoinMarketplace(input: "💩") @rest(type: "Network", method: "POST", path: "/makro/joinmarketplacewithuser", bodySerializer: "noBody") {
    ...network
  }
}
    ${NetworkFragmentDoc}`;
export type UserJoinMarketplaceMutationFn = Apollo.MutationFunction<UserJoinMarketplaceMutation, UserJoinMarketplaceMutationVariables>;

/**
 * __useUserJoinMarketplaceMutation__
 *
 * To run a mutation, you first call `useUserJoinMarketplaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserJoinMarketplaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userJoinMarketplaceMutation, { data, loading, error }] = useUserJoinMarketplaceMutation({
 *   variables: {
 *   },
 * });
 */
export function useUserJoinMarketplaceMutation(baseOptions?: Apollo.MutationHookOptions<UserJoinMarketplaceMutation, UserJoinMarketplaceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserJoinMarketplaceMutation, UserJoinMarketplaceMutationVariables>(UserJoinMarketplaceDocument, options);
      }
export type UserJoinMarketplaceMutationHookResult = ReturnType<typeof useUserJoinMarketplaceMutation>;
export type UserJoinMarketplaceMutationResult = Apollo.MutationResult<UserJoinMarketplaceMutation>;
export type UserJoinMarketplaceMutationOptions = Apollo.BaseMutationOptions<UserJoinMarketplaceMutation, UserJoinMarketplaceMutationVariables>;
export const DeleteAccountDocument = gql`
    mutation deleteAccount($input: DeleteAccountInput!) {
  deleteAccount(input: $input) @rest(type: "DeleteAccountResponse", method: "POST", path: "/makro/deleteaccount") {
    message
  }
}
    `;
export type DeleteAccountMutationFn = Apollo.MutationFunction<DeleteAccountMutation, DeleteAccountMutationVariables>;

/**
 * __useDeleteAccountMutation__
 *
 * To run a mutation, you first call `useDeleteAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAccountMutation, { data, loading, error }] = useDeleteAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteAccountMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAccountMutation, DeleteAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAccountMutation, DeleteAccountMutationVariables>(DeleteAccountDocument, options);
      }
export type DeleteAccountMutationHookResult = ReturnType<typeof useDeleteAccountMutation>;
export type DeleteAccountMutationResult = Apollo.MutationResult<DeleteAccountMutation>;
export type DeleteAccountMutationOptions = Apollo.BaseMutationOptions<DeleteAccountMutation, DeleteAccountMutationVariables>;
export const UserDocument = gql`
    query user($userId: ID!, $networkId: ID!) {
  user(userId: $userId, networkId: $networkId) {
    ...user
    userMetaData {
      ...userMetadataResponse
    }
  }
}
    ${UserFragmentDoc}
${UserMetadataResponseFragmentDoc}`;

/**
 * __useUserQuery__
 *
 * To run a query within a React component, call `useUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      networkId: // value for 'networkId'
 *   },
 * });
 */
export function useUserQuery(baseOptions: Apollo.QueryHookOptions<UserQuery, UserQueryVariables> & ({ variables: UserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserQuery, UserQueryVariables>(UserDocument, options);
      }
export function useUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserQuery, UserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserQuery, UserQueryVariables>(UserDocument, options);
        }
// @ts-ignore
export function useUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserQuery, UserQueryVariables>): Apollo.UseSuspenseQueryResult<UserQuery, UserQueryVariables>;
export function useUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserQuery, UserQueryVariables>): Apollo.UseSuspenseQueryResult<UserQuery | undefined, UserQueryVariables>;
export function useUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserQuery, UserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserQuery, UserQueryVariables>(UserDocument, options);
        }
export type UserQueryHookResult = ReturnType<typeof useUserQuery>;
export type UserLazyQueryHookResult = ReturnType<typeof useUserLazyQuery>;
export type UserSuspenseQueryHookResult = ReturnType<typeof useUserSuspenseQuery>;
export type UserQueryResult = Apollo.QueryResult<UserQuery, UserQueryVariables>;
export const UserStatusDocument = gql`
    query userStatus($userId: ID!) {
  userStatus(userId: $userId) @rest(type: "UserStatusResponse", method: "GET", path: "/makro/playerprofile/0&userid={args.userId}&useronly=1") {
    selfNetwork
    selfPlayer
    selfUser
    jmtNetworks
  }
}
    `;

/**
 * __useUserStatusQuery__
 *
 * To run a query within a React component, call `useUserStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserStatusQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserStatusQuery(baseOptions: Apollo.QueryHookOptions<UserStatusQuery, UserStatusQueryVariables> & ({ variables: UserStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserStatusQuery, UserStatusQueryVariables>(UserStatusDocument, options);
      }
export function useUserStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserStatusQuery, UserStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserStatusQuery, UserStatusQueryVariables>(UserStatusDocument, options);
        }
// @ts-ignore
export function useUserStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserStatusQuery, UserStatusQueryVariables>): Apollo.UseSuspenseQueryResult<UserStatusQuery, UserStatusQueryVariables>;
export function useUserStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserStatusQuery, UserStatusQueryVariables>): Apollo.UseSuspenseQueryResult<UserStatusQuery | undefined, UserStatusQueryVariables>;
export function useUserStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserStatusQuery, UserStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserStatusQuery, UserStatusQueryVariables>(UserStatusDocument, options);
        }
export type UserStatusQueryHookResult = ReturnType<typeof useUserStatusQuery>;
export type UserStatusLazyQueryHookResult = ReturnType<typeof useUserStatusLazyQuery>;
export type UserStatusSuspenseQueryHookResult = ReturnType<typeof useUserStatusSuspenseQuery>;
export type UserStatusQueryResult = Apollo.QueryResult<UserStatusQuery, UserStatusQueryVariables>;
export const RelationshipsDocument = gql`
    query relationships($start: Int, $limit: Int) {
  followed(start: $start, limit: $limit) @rest(type: "UserCollection", path: "/my/{args.userId}/user/{args.userId}/followed_users", method: "GET") {
    collection @type(name: "User") {
      ...user
      isFriend
    }
    meta {
      range {
        from
        to
        total
      }
      sortOptions {
        key
        value
      }
    }
  }
  follower(start: $start, limit: $limit) @rest(type: "UserCollection", path: "/my/{args.userId}/user/{args.userId}/followers", method: "GET") {
    collection @type(name: "User") {
      ...user
      isFriend
    }
    meta {
      range {
        from
        to
        total
      }
      sortOptions {
        key
        value
      }
    }
  }
}
    ${UserFragmentDoc}`;

/**
 * __useRelationshipsQuery__
 *
 * To run a query within a React component, call `useRelationshipsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRelationshipsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRelationshipsQuery({
 *   variables: {
 *      start: // value for 'start'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useRelationshipsQuery(baseOptions?: Apollo.QueryHookOptions<RelationshipsQuery, RelationshipsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RelationshipsQuery, RelationshipsQueryVariables>(RelationshipsDocument, options);
      }
export function useRelationshipsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RelationshipsQuery, RelationshipsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RelationshipsQuery, RelationshipsQueryVariables>(RelationshipsDocument, options);
        }
// @ts-ignore
export function useRelationshipsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RelationshipsQuery, RelationshipsQueryVariables>): Apollo.UseSuspenseQueryResult<RelationshipsQuery, RelationshipsQueryVariables>;
export function useRelationshipsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RelationshipsQuery, RelationshipsQueryVariables>): Apollo.UseSuspenseQueryResult<RelationshipsQuery | undefined, RelationshipsQueryVariables>;
export function useRelationshipsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RelationshipsQuery, RelationshipsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RelationshipsQuery, RelationshipsQueryVariables>(RelationshipsDocument, options);
        }
export type RelationshipsQueryHookResult = ReturnType<typeof useRelationshipsQuery>;
export type RelationshipsLazyQueryHookResult = ReturnType<typeof useRelationshipsLazyQuery>;
export type RelationshipsSuspenseQueryHookResult = ReturnType<typeof useRelationshipsSuspenseQuery>;
export type RelationshipsQueryResult = Apollo.QueryResult<RelationshipsQuery, RelationshipsQueryVariables>;
export const NewActivitiesDocument = gql`
    query newActivities($isoDate: String!) {
  newActivities(isoDate: $isoDate) @rest(type: "Activity", method: "GET", path: "/makro/newactivities/{args.isoDate}") {
    ...activity
  }
}
    ${ActivityFragmentDoc}`;

/**
 * __useNewActivitiesQuery__
 *
 * To run a query within a React component, call `useNewActivitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useNewActivitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewActivitiesQuery({
 *   variables: {
 *      isoDate: // value for 'isoDate'
 *   },
 * });
 */
export function useNewActivitiesQuery(baseOptions: Apollo.QueryHookOptions<NewActivitiesQuery, NewActivitiesQueryVariables> & ({ variables: NewActivitiesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NewActivitiesQuery, NewActivitiesQueryVariables>(NewActivitiesDocument, options);
      }
export function useNewActivitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NewActivitiesQuery, NewActivitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NewActivitiesQuery, NewActivitiesQueryVariables>(NewActivitiesDocument, options);
        }
// @ts-ignore
export function useNewActivitiesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<NewActivitiesQuery, NewActivitiesQueryVariables>): Apollo.UseSuspenseQueryResult<NewActivitiesQuery, NewActivitiesQueryVariables>;
export function useNewActivitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NewActivitiesQuery, NewActivitiesQueryVariables>): Apollo.UseSuspenseQueryResult<NewActivitiesQuery | undefined, NewActivitiesQueryVariables>;
export function useNewActivitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NewActivitiesQuery, NewActivitiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NewActivitiesQuery, NewActivitiesQueryVariables>(NewActivitiesDocument, options);
        }
export type NewActivitiesQueryHookResult = ReturnType<typeof useNewActivitiesQuery>;
export type NewActivitiesLazyQueryHookResult = ReturnType<typeof useNewActivitiesLazyQuery>;
export type NewActivitiesSuspenseQueryHookResult = ReturnType<typeof useNewActivitiesSuspenseQuery>;
export type NewActivitiesQueryResult = Apollo.QueryResult<NewActivitiesQuery, NewActivitiesQueryVariables>;
export const ActivitiesDocument = gql`
    query activities($from: Int, $limit: Int, $date: String!) {
  activities(from: $from, limit: $limit, date: $date) {
    meta {
      range {
        from
        to
        total
      }
    }
    collection @type(name: "Activity") {
      ...activity
    }
  }
}
    ${ActivityFragmentDoc}`;

/**
 * __useActivitiesQuery__
 *
 * To run a query within a React component, call `useActivitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivitiesQuery({
 *   variables: {
 *      from: // value for 'from'
 *      limit: // value for 'limit'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useActivitiesQuery(baseOptions: Apollo.QueryHookOptions<ActivitiesQuery, ActivitiesQueryVariables> & ({ variables: ActivitiesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActivitiesQuery, ActivitiesQueryVariables>(ActivitiesDocument, options);
      }
export function useActivitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActivitiesQuery, ActivitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActivitiesQuery, ActivitiesQueryVariables>(ActivitiesDocument, options);
        }
// @ts-ignore
export function useActivitiesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ActivitiesQuery, ActivitiesQueryVariables>): Apollo.UseSuspenseQueryResult<ActivitiesQuery, ActivitiesQueryVariables>;
export function useActivitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ActivitiesQuery, ActivitiesQueryVariables>): Apollo.UseSuspenseQueryResult<ActivitiesQuery | undefined, ActivitiesQueryVariables>;
export function useActivitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ActivitiesQuery, ActivitiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ActivitiesQuery, ActivitiesQueryVariables>(ActivitiesDocument, options);
        }
export type ActivitiesQueryHookResult = ReturnType<typeof useActivitiesQuery>;
export type ActivitiesLazyQueryHookResult = ReturnType<typeof useActivitiesLazyQuery>;
export type ActivitiesSuspenseQueryHookResult = ReturnType<typeof useActivitiesSuspenseQuery>;
export type ActivitiesQueryResult = Apollo.QueryResult<ActivitiesQuery, ActivitiesQueryVariables>;
export const ActivitylevelDocument = gql`
    query activitylevel($userId: ID!) {
  activitylevel(userId: $userId) @rest(path: "/makro/activitylevel/{args.userId}", method: "GET")
}
    `;

/**
 * __useActivitylevelQuery__
 *
 * To run a query within a React component, call `useActivitylevelQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivitylevelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivitylevelQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useActivitylevelQuery(baseOptions: Apollo.QueryHookOptions<ActivitylevelQuery, ActivitylevelQueryVariables> & ({ variables: ActivitylevelQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActivitylevelQuery, ActivitylevelQueryVariables>(ActivitylevelDocument, options);
      }
export function useActivitylevelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActivitylevelQuery, ActivitylevelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActivitylevelQuery, ActivitylevelQueryVariables>(ActivitylevelDocument, options);
        }
// @ts-ignore
export function useActivitylevelSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ActivitylevelQuery, ActivitylevelQueryVariables>): Apollo.UseSuspenseQueryResult<ActivitylevelQuery, ActivitylevelQueryVariables>;
export function useActivitylevelSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ActivitylevelQuery, ActivitylevelQueryVariables>): Apollo.UseSuspenseQueryResult<ActivitylevelQuery | undefined, ActivitylevelQueryVariables>;
export function useActivitylevelSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ActivitylevelQuery, ActivitylevelQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ActivitylevelQuery, ActivitylevelQueryVariables>(ActivitylevelDocument, options);
        }
export type ActivitylevelQueryHookResult = ReturnType<typeof useActivitylevelQuery>;
export type ActivitylevelLazyQueryHookResult = ReturnType<typeof useActivitylevelLazyQuery>;
export type ActivitylevelSuspenseQueryHookResult = ReturnType<typeof useActivitylevelSuspenseQuery>;
export type ActivitylevelQueryResult = Apollo.QueryResult<ActivitylevelQuery, ActivitylevelQueryVariables>;